(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3882],{

/***/ 5508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ process_Process1; }
});

// UNUSED EXPORTS: Process10, Process11, Process12, Process13, Process14, Process15, Process16, Process17, Process2, Process3, Process4, Process5, Process6, Process7, Process8, Process9

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/reuseable/process-list/ProcessList1.tsx

// ==============================================================
var ProcessList1_ProcessList1 = function(props) {
    var no = props.no, title = props.title, subtitle = props.subtitle, className = props.className, shadow = props.shadow, icon = props.icon, iconAlt = props.iconAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(className, " ").concat(shadow && "shadow-lg"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card-body p-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 60,
                                height: 60,
                                src: icon,
                                alt: iconAlt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pl-2 ps-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-1",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: subtitle
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var process_list_ProcessList1 = (ProcessList1_ProcessList1);

;// CONCATENATED MODULE: ./src/components/reuseable/process-list/ProcessList2.tsx

// ==============================================================
var ProcessList2_ProcessList2 = function(props) {
    var no = props.no, title = props.title, subtitle = props.subtitle, className = props.className;
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex flex-row mb-6",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("span", {
                    className: className,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "number fs-18",
                        children: no
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        className: "mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-0",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_list_ProcessList2 = ((/* unused pure expression or super */ null && (ProcessList2_ProcessList2)));

;// CONCATENATED MODULE: ./src/components/reuseable/process-list/index.ts




// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process1.tsx






var Process1 = function(param) {
    var subtitle = param.subtitle, title = param.title, body = param.body, displayButton = param.displayButton, list = param.list, buttonLink = param.buttonLink, buttonTitle = param.buttonTitle, src = param.src, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container pb-5 pt-md-10 pb-md-1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row gx-md-8 gx-xl-12 gy-10 mb-14 mb-md-18 align-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-6 order-2",
                        children: list.map(function(item) {
                            return /*#__PURE__*/ (0,react.createElement)(process_list_ProcessList1, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                shadow: true
                            }, item), {
                                key: item
                            }));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-lg-6 order-1",
                        children: [
                            src !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 500,
                                height: "auto",
                                src: src,
                                alt: alt,
                                className: "card-img-top mw border-bottom-1 border-black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "display-4 mb-5",
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: body
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                //legacyBehavior2 passHref2
                                title: buttonTitle,
                                href: buttonLink,
                                className: "btn btn-primary rounded-pill mt-2 ".concat(displayButton),
                                activeClass: "active",
                                to: "contact",
                                spy: true,
                                smooth: true,
                                offset: 0,
                                duration: 500,
                                children: "Get in Touch"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var process_Process1 = (Process1);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/data/process.ts + 1 modules
var process = __webpack_require__(9870);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process2.tsx





// import { useSpring, animated } from '@react-spring/web';

// -------- data -------- //

var Process2 = function() {
    // const props1 = useSpring({ from: { marginTop: -100, opacity: 0 }, to: { marginTop: 0, opacity: 1 }, delay: 1500,config: { mass: 1, tension: 150, friction: 20}, });
    // const props2 = useSpring({ from: { opacity: 0 }, to: { opacity: 1 }, delay: 1900 });
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gy-10 gy-sm-13 gx-lg-3 align-items-center mb-14 mb-md-17 mb-lg-19",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-md-8 col-lg-6 position-relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape bg-line red rounded-circle rellax w-18 h-18",
                        style: {
                            top: "-2.2rem",
                            left: "-2.4rem"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape rounded bg-soft-primary rellax d-md-block",
                        style: {
                            width: "85%",
                            height: "90%",
                            right: "-1.5rem",
                            bottom: "-1.8rem"
                        }
                    }),
                    /*#__PURE__*/ _jsx("figure", {
                        className: "rounded",
                        children: /*#__PURE__*/ _jsx(Image, {
                            width: 575,
                            height: 550,
                            layout: "responsive",
                            src: "/img/photos/about9.jpg",
                            alt: "How work"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5 col-xl-4 offset-lg-1",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-4 mb-3",
                        children: "How It Works?"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "lead fs-lg mb-6",
                        children: "So here are three working steps why our valued customers choose us."
                    }),
                    processList3.map(function(item) {
                        return /*#__PURE__*/ _createElement(ProcessList2, _object_spread_props(_object_spread({}, item), {
                            key: item.no,
                            className: "icon btn btn-circle btn-primary pe-none me-5"
                        }));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process2 = ((/* unused pure expression or super */ null && (Process2)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process3.tsx





// -------- data -------- //

var Process3 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gy-10 gy-sm-13 gx-lg-3 mb-16 mb-md-18 align-items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-md-8 col-lg-6 position-relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape bg-dot primary rellax w-17 h-21",
                        style: {
                            top: "-2rem",
                            left: "-1.9rem"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape rounded bg-soft-primary rellax d-md-block",
                        style: {
                            width: "85%",
                            height: "90%",
                            right: "-1.5rem",
                            bottom: "-1.8rem"
                        }
                    }),
                    /*#__PURE__*/ _jsx("figure", {
                        className: "rounded",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/img/photos/about7.jpg",
                            srcSet: "/img/photos/about7@2x.jpg 2x",
                            alt: "process"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5 col-xl-4 offset-lg-1",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-16 text-uppercase text-line text-primary mb-3",
                        children: "How It Works?"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-7",
                        children: "Here are the 3 working steps on success."
                    }),
                    processList4.map(function(item) {
                        return /*#__PURE__*/ _createElement(ProcessList2, _object_spread_props(_object_spread({}, item), {
                            key: item.no,
                            className: "icon btn btn-block btn-soft-primary pe-none me-5"
                        }));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process3 = ((/* unused pure expression or super */ null && (Process3)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process4.tsx

// import Plyr from 'plyr-react';

// -------- data -------- //

var Process4 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 pt-md-16 pt-lg-0 pb-md-16",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    style: animation({
                        name: "slideInUp",
                        delay: "0ms"
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-10 mx-auto",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "mt-lg-n20 mt-xl-n22 position-relative",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape bg-dot red rellax w-16 h-18",
                                    style: {
                                        zIndex: 0,
                                        top: "1rem",
                                        left: "-3.9rem"
                                    }
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape rounded-circle bg-line primary rellax w-18 h-18",
                                    style: {
                                        zIndex: 0,
                                        bottom: "2rem",
                                        right: "-3rem"
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center mt-12",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-9 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-15 text-uppercase text-muted mb-3",
                                children: "Our Process"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-0 text-center px-xl-10 px-xxl-15",
                                children: "Find out everything you need to know about creating a business process model"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row gx-lg-8 gx-xl-12 process-wrapper text-center mt-9",
                                children: processList5.map(function(param) {
                                    var title = param.title, subtitle = param.subtitle, Icon = param.Icon, color = param.color;
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "col-md-4",
                                        children: [
                                            /*#__PURE__*/ _jsx(Icon, {
                                                className: "icon-svg-md text-".concat(color, " mb-3")
                                            }),
                                            /*#__PURE__*/ _jsx("h4", {
                                                className: "mb-1",
                                                children: title
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: subtitle
                                            })
                                        ]
                                    }, title);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var process_Process4 = ((/* unused pure expression or super */ null && (Process4)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process5.tsx

// -------- data -------- //

var Process5 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-10 mb-lg-19 mb-xl-22 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        alt: "how it work",
                        src: "/img/photos/device.png",
                        srcSet: "/img/photos/device@2x.png 2x"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-6",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-muted mb-3",
                        children: "How It Works"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5",
                        children: "Download the app, create your profile and voil\xe0, you're all set!"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-8",
                        children: "Donec ullamcorper nulla non metus auctor fringilla. Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nulla vitae elit libero. Etiam porta sem malesuada magna mollis euismod. Fusce dapibus, tellus ac cursus commodo."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row gy-6 gx-xxl-8 process-wrapper",
                        children: processList6.map(function(param) {
                            var id = param.id, title = param.title, description = param.description, Icon = param.Icon, color = param.color;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        className: "icon-svg-sm text-".concat(color, " mb-3")
                                    }),
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "mb-1",
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-0",
                                        children: description
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process5 = ((/* unused pure expression or super */ null && (Process5)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process6.tsx


// -------- data -------- //

var Process6 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "display-4 mb-3",
                children: "How We Do It?"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "lead fs-lg mb-8",
                children: [
                    "We make your spending ",
                    /*#__PURE__*/ _jsx("span", {
                        className: "underline",
                        children: "stress-free"
                    }),
                    " for you to have the perfect control."
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-lg-8 gx-xl-12 gy-6 process-wrapper line",
                children: processList2.map(function(param, i) {
                    var no = param.no, title = param.title, subtitle = param.subtitle;
                    var iconColor = i === 1 ? "btn-primary" : "btn-soft-primary";
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-6 col-lg-3",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon btn btn-circle btn-lg pe-none mb-4 ".concat(iconColor),
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "number",
                                    children: no
                                })
                            }),
                            /*#__PURE__*/ _jsx("h4", {
                                className: "mb-1",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: subtitle
                            })
                        ]
                    }, no);
                })
            })
        ]
    });
};
/* harmony default export */ var process_Process6 = ((/* unused pure expression or super */ null && (Process6)));

;// CONCATENATED MODULE: ./src/icons/lineal/List.tsx

var List_List = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 512 447",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md mb-4"),
        children: [
            /*#__PURE__*/ _jsx("path", {
                className: "lineal-stroke",
                d: "M102.4 447C45.8 447 0 401.1 0 344.6s45.9-102.4 102.4-102.4c36.3 0 69.9 19.2 88.3 50.5 4.1 6.9 1.8 15.8-5.2 19.9-6.9 4.1-15.8 1.8-19.9-5.2-20.5-34.9-65.4-46.6-100.3-26.1s-46.6 65.4-26.1 100.3 65.4 46.6 100.3 26.1c10.2-6 18.8-14.3 25-24.3 4.3-6.8 13.2-8.9 20.1-4.6 6.8 4.3 8.9 13.2 4.6 20.1-18.7 30-51.5 48.2-86.8 48.1zm395.1-119.8H254.3c-8-.2-14.4-6.9-14.2-14.9.2-7.7 6.4-14 14.2-14.2h243.1c8 .2 14.4 6.9 14.2 14.9-.2 7.8-6.4 14-14.1 14.2zm-91.2 63.9h-152c-8-.2-14.4-6.9-14.2-14.9.2-7.7 6.4-14 14.2-14.2h152c8 .2 14.4 6.9 14.2 14.9-.2 7.7-6.5 14-14.2 14.2z"
            }),
            /*#__PURE__*/ _jsx("circle", {
                className: "lineal-fill",
                cx: "102.4",
                cy: "102.4",
                r: "87.8"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "lineal-stroke",
                d: "M102.4 204.8C45.8 204.8 0 158.9 0 102.4S45.8 0 102.4 0s102.4 45.8 102.4 102.4c-.1 56.5-45.9 102.3-102.4 102.4zm0-175.7c-40.5 0-73.3 32.8-73.3 73.3s32.8 73.3 73.3 73.3 73.3-32.8 73.3-73.3c-.1-40.5-32.9-73.2-73.3-73.3zM497.5 85H254.3c-8-.2-14.4-6.9-14.2-14.9.2-7.7 6.4-14 14.2-14.2h243.1c8 .2 14.4 6.9 14.2 14.9-.2 7.8-6.4 14-14.1 14.2zm-91.2 63.8h-152c-8-.2-14.4-6.9-14.2-14.9.2-7.7 6.4-14 14.2-14.2h152c8 .2 14.4 6.9 14.2 14.9-.2 7.8-6.5 14-14.2 14.2z"
            })
        ]
    });
};
/* harmony default export */ var lineal_List = ((/* unused pure expression or super */ null && (List_List)));

// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(9472);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process7.tsx








// -------- data -------- //

var Process7 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row mb-5",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 col-xl-8 col-xxl-7 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx(List, {}),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "display-4 mb-4 px-lg-14",
                            children: "Here are 3 working steps to organize our business projects."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6 order-lg-2",
                        children: processList1.map(function(item) {
                            return /*#__PURE__*/ _createElement(ProcessList1, _object_spread_props(_object_spread({}, item), {
                                key: item.no
                            }));
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-6 mb-3",
                                children: "How It Works?"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg pe-lg-5",
                                children: "Find out everything you need to know and more about how we create our business process models."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Etiam porta sem malesuada magna mollis euismod. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus eget urna mollis ornare."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-6",
                                children: "Nullam id dolor id nibh ultricies vehicula ut id elit. Vestibulum id ligula porta felis euismod semper. Aenean lacinia bibendum nulla sed consectetur. Sed posuere consectetur est at lobortis. Vestibulum id ligula porta felis."
                            }),
                            /*#__PURE__*/ _jsx(NextLink, {
                                title: "Learn More",
                                href: "#",
                                className: "btn btn-primary rounded-pill mb-0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process7 = ((/* unused pure expression or super */ null && (Process7)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process8.tsx

// -------- data -------- //

var Process8 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 mb-14 mb-md-16 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-7",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "w-auto",
                        src: "/img/illustrations/i3.png",
                        srcSet: "/img/illustrations/i3@2x.png 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-line text-primary mb-3",
                        children: "How It Works?"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-5 mb-7 pe-xxl-5",
                        children: "Everything you need on creating a business process."
                    }),
                    processList7.map(function(param, i) {
                        var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                        var lastItem = i === processList7.length - 1;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-row ".concat(lastItem ? "mb-0" : "mb-4"),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Icon, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "mb-1",
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-1",
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        }, id);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process8 = ((/* unused pure expression or super */ null && (Process8)));

// EXTERNAL MODULE: ./src/components/common/GoogleAppBtn.tsx
var common_GoogleAppBtn = __webpack_require__(1147);
;// CONCATENATED MODULE: ./src/components/blocks/banner/Banner1.tsx


var Banner1 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-10 pb-15 py-lg-17 py-xl-20 py-xxl-22 position-relative",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    alt: "",
                    src: "/img/photos/devices2.png",
                    srcSet: "/img/photos/devices2@2x.png 2x",
                    className: "position-lg-absolute col-12 col-lg-12 mt-lg-n50p mb-3 mb-md-10 mb-lg-0",
                    style: {
                        top: "50%",
                        left: "-23%"
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-lg-8 gx-xl-12 align-items-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 col-lg-6 offset-lg-6 mt-md-n9 text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-4 mb-4 px-md-10 px-lg-0",
                                children: "Get all of your steps, exercise, sleep and meds in one place."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-7 px-md-10 px-lg-0 pe-xxl-15",
                                children: "SEOptimist is now available to download from both the App Store and Google Play Store."
                            }),
                            /*#__PURE__*/ _jsx(GoogleAppBtn, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var banner_Banner1 = ((/* unused pure expression or super */ null && (Banner1)));

;// CONCATENATED MODULE: ./src/components/blocks/banner/Banner2.tsx

var Banner2 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "wrapper image-wrapper bg-image bg-overlay text-white",
        style: {
            backgroundImage: "url(/img/photos/bg34.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-16 py-md-19 text-center",
            children: /*#__PURE__*/ _jsxs("h2", {
                className: "display-1 text-white mb-0",
                children: [
                    "I take photographs with ",
                    /*#__PURE__*/ _jsx("br", {
                        className: "d-none d-md-block"
                    }),
                    " creativity, concept & passion"
                ]
            })
        })
    });
};
/* harmony default export */ var banner_Banner2 = ((/* unused pure expression or super */ null && (Banner2)));

// EXTERNAL MODULE: ./src/hooks/useLightBox.ts
var hooks_useLightBox = __webpack_require__(9486);
;// CONCATENATED MODULE: ./src/components/blocks/banner/Banner3.tsx


var Banner3 = function() {
    // used for light box popup
    useLightBox();
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay",
        style: {
            backgroundImage: "url(/img/photos/bg1.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-18 text-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-10 col-xl-10 col-xxl-8 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "/media/movie.mp4",
                            "data-glightbox": true,
                            className: "btn btn-circle btn-white btn-play ripple mx-auto mb-5",
                            children: /*#__PURE__*/ _jsx("i", {
                                className: "icn-caret-right"
                            })
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "display-4 px-lg-10 px-xl-13 px-xxl-10 mb-10 text-white",
                            children: "Find out everything you need to know about creating a business process model."
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var banner_Banner3 = ((/* unused pure expression or super */ null && (Banner3)));

;// CONCATENATED MODULE: ./src/components/blocks/banner/Banner4.tsx


// ======================================================
var Banner4_Banner4 = function(param) {
    var hideShape = param.hideShape, _imageName = param.imageName, imageName = _imageName === void 0 ? "about12" : _imageName, _btnColor = param.btnColor, btnColor = _btnColor === void 0 ? "primary" : _btnColor;
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("a", {
                "data-glightbox": true,
                href: "/media/movie.mp4",
                className: "btn btn-circle btn-".concat(btnColor, " btn-play ripple mx-auto mb-5 position-absolute"),
                style: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    zIndex: 3
                },
                children: /*#__PURE__*/ _jsx("i", {
                    className: "icn-caret-right"
                })
            }),
            !hideShape && /*#__PURE__*/ _jsx("div", {
                className: "shape rounded bg-soft-primary rellax d-md-block",
                style: {
                    width: "85%",
                    height: "90%",
                    right: "-1.5rem",
                    bottom: "-1.8rem"
                }
            }),
            /*#__PURE__*/ _jsx("figure", {
                className: "rounded",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/img/photos/".concat(imageName, ".jpg"),
                    srcSet: "/img/photos/".concat(imageName, "@2x.jpg 2x"),
                    alt: imageName
                })
            })
        ]
    });
};
/* harmony default export */ var banner_Banner4 = ((/* unused pure expression or super */ null && (Banner4_Banner4)));

;// CONCATENATED MODULE: ./src/components/blocks/banner/Banner5.tsx

// import Plyr from 'plyr-react';
var Banner5 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-16",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-xl-9 col-xxl-7 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "icn-flower text-leaf fs-30 opacity-25"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-5 text-center mt-2 mb-10",
                                children: "I would like to give you a unique photography and video experience, built to serve you best."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-9 mx-auto"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var banner_Banner5 = ((/* unused pure expression or super */ null && (Banner5)));

;// CONCATENATED MODULE: ./src/components/blocks/banner/index.ts







// EXTERNAL MODULE: ./src/components/reuseable/service-cards/index.ts + 6 modules
var service_cards = __webpack_require__(1169);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process9.tsx




// -------- custom component -------- //


// -------- custom hooks -------- //

// -------- data -------- //

var Process9 = function() {
    // lighbox hook called
    useLightBox();
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gy-10 gy-sm-13 gx-lg-3 align-items-center mb-14 mb-md-19",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-8 col-lg-6 position-relative",
                children: /*#__PURE__*/ _jsx(Banner4, {
                    imageName: "about8"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5 col-xl-4 offset-lg-1",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-muted mb-3",
                        children: "How It Works?"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-7",
                        children: "Here are the 3 working steps on success."
                    }),
                    processList8.map(function(_param) /*#__PURE__*/ {
                        var Icon = _param.Icon, id = _param.id, iconColor = _param.iconColor, item = _object_without_properties(_param, [
                            "Icon",
                            "id",
                            "iconColor"
                        ]);
                        return _jsx(ServiceCard3, _object_spread_props(_object_spread({}, item), {
                            Icon: /*#__PURE__*/ _jsx(Icon, {
                                className: "icon-svg-md text-".concat(iconColor, " me-5")
                            })
                        }), id);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process9 = ((/* unused pure expression or super */ null && (Process9)));

// EXTERNAL MODULE: ./src/data/demo-12.ts + 4 modules
var demo_12 = __webpack_require__(3152);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process10.tsx





// -------- data -------- //

var Process10 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 mb-14 mb-md-17 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-7",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "w-auto",
                        src: "/img/illustrations/i8.png",
                        srcSet: "/img/illustrations/i8@2x.png 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-7",
                        children: "Our three process steps on creating awesome projects."
                    }),
                    processList.map(function(item) {
                        return /*#__PURE__*/ _createElement(ProcessList2, _object_spread_props(_object_spread({}, item), {
                            key: item.no,
                            className: "icon btn btn-circle btn-soft-primary pe-none me-5"
                        }));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process10 = ((/* unused pure expression or super */ null && (Process10)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process11.tsx






// -------- data -------- //

var Process11 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row mb-8 text-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-8 col-xl-7 col-xxl-6 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-primary mb-3",
                            children: "Company Strategy"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4",
                            children: "Just sit and relax while we take care of your business needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 mb-14 mb-md-17 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 position-relative",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "shape bg-dot leaf rellax w-17 h-18",
                                style: {
                                    bottom: "-2rem",
                                    left: "-0.7rem"
                                }
                            }),
                            /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/about20.jpg",
                                    srcSet: "/img/photos/about20@2x.jpg 2x",
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 col-xxl-5",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-6 mb-7",
                                children: "Our Working Process"
                            }),
                            processList.map(function(item) {
                                return /*#__PURE__*/ _createElement(ProcessList2, _object_spread_props(_object_spread({}, item), {
                                    key: item.no,
                                    className: "icon btn btn-circle btn-soft-primary pe-none me-5"
                                }));
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process11 = ((/* unused pure expression or super */ null && (Process11)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process12.tsx



// -------- data -------- //

var Process12 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-8 gx-xl-12 gy-10 align-items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-6",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-muted mb-3",
                        children: "Our Strategy"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5",
                        children: "3 working steps to organize our business projects."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Etiam porta sem malesuada magna mollis euismod eget. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-6",
                        children: "Nullam id dolor id nibh ultricies vehicula ut id elit. Vestibulum id ligula porta felis euismod semper. Aenean lacinia bibendum consectetur."
                    }),
                    /*#__PURE__*/ _jsx(NextLink, {
                        href: "#",
                        title: "Learn More",
                        className: "btn btn-primary rounded-pill mb-0"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6",
                children: processList9.map(function(param) {
                    var className = param.className, no = param.no, title = param.title, subtitle = param.subtitle, color = param.color;
                    return /*#__PURE__*/ _jsx(ServiceCard3, {
                        title: title,
                        description: subtitle,
                        className: "d-flex flex-row " + className,
                        Icon: /*#__PURE__*/ _jsx("span", {
                            className: "icon btn btn-block btn-lg btn-soft-".concat(color, " pe-none mt-1 me-5"),
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "number fs-22",
                                children: no
                            })
                        })
                    }, no);
                })
            })
        ]
    });
};
/* harmony default export */ var process_Process12 = ((/* unused pure expression or super */ null && (Process12)));

;// CONCATENATED MODULE: ./src/icons/Hex.tsx

var Hex_Hex = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 500 549.53",
        className: "svg-inject icon-svg w-100 h-100",
        children: /*#__PURE__*/ _jsx("path", {
            className: "svg-fill",
            d: "M250 549.39c-15.51 0-30.05-3.46-40.94-9.75l-168-97C18.5 429.63.14 397.82.14 371.75v-194c0-26.07 18.36-57.88 40.94-70.91l168-97C220 3.6 234.49.14 250 .14s30.05 3.46 40.94 9.75l168 97c22.58 13 40.94 44.84 40.94 70.91v194c0 26.07-18.36 57.88-40.94 70.91l-168 97c-10.89 6.22-25.43 9.68-40.94 9.68z"
        })
    });
};
/* harmony default export */ var icons_Hex = ((/* unused pure expression or super */ null && (Hex_Hex)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process13.tsx

// import Plyr from 'plyr-react';

// -------- data -------- //

var Process13 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-15 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-10 mx-auto position-relative",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "position-relative",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape pale-pink rellax w-18 h-18",
                                    style: {
                                        top: "1rem",
                                        left: "-4.2rem"
                                    },
                                    children: /*#__PURE__*/ _jsx(Hex, {})
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape pale-primary rellax w-18 h-18",
                                    style: {
                                        bottom: "2rem",
                                        right: "-3.5rem"
                                    },
                                    children: /*#__PURE__*/ _jsx("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 500 500",
                                        className: "svg-inject icon-svg w-100 h-100",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            "data-name": "Layer 2",
                                            children: /*#__PURE__*/ _jsx("path", {
                                                className: "svg-fill",
                                                d: "M250 0C111.93 0 0 111.93 0 250s111.93 250 250 250 250-111.93 250-250S388.07 0 250 0zm0 425a175 175 0 11175-175 175 175 0 01-175 175z",
                                                "data-name": "Layer 1"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center mt-12",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-10 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "Our Working Process"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 text-center px-xl-10 px-xxl-15 mb-10",
                                children: "Find out everything you need to know about creating a business process model"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row gx-lg-8 gx-xl-12 process-wrapper arrow text-center",
                                children: processList10.map(function(param) {
                                    var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "col-md-4",
                                        children: [
                                            /*#__PURE__*/ _jsx(Icon, {
                                                className: "icon-svg-sm solid-duo text-purple-pink mb-4"
                                            }),
                                            /*#__PURE__*/ _jsx("h3", {
                                                className: "fs-22",
                                                children: title
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: description
                                            })
                                        ]
                                    }, id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var process_Process13 = ((/* unused pure expression or super */ null && (Process13)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process14.tsx






// -------- data -------- //

var Process14 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pb-14 pb-md-17",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-md-8 gx-xl-12 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6 order-lg-2",
                        children: processList1.map(function(item) {
                            return /*#__PURE__*/ _createElement(ProcessList1, _object_spread_props(_object_spread({
                                shadow: true
                            }, item), {
                                key: item.no
                            }));
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "Our Strategy"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 mb-4",
                                children: "Here are 3 working steps to organize our projects."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Etiam porta sem malesuada magna mollis euismod. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus eget urna mollis."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-6",
                                children: "Nullam id dolor id nibh ultricies vehicula ut id elit. Vestibulum id ligula porta felis euismod semper. Aenean lacinia bibendum nulla sed consectetur."
                            }),
                            /*#__PURE__*/ _jsx(NextLink, {
                                title: "Learn More",
                                href: "#",
                                className: "btn btn-primary rounded-pill mb-0"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var process_Process14 = ((/* unused pure expression or super */ null && (Process14)));

;// CONCATENATED MODULE: ./src/components/blocks/process/Process15.tsx

// -------- data -------- //

var Process15 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 mb-15 mb-md-17 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-7",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        alt: "process",
                        className: "w-auto",
                        src: "/img/illustrations/i9.png",
                        srcSet: "/img/illustrations/i9@2x.png 2x"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "fs-16 text-uppercase text-muted mb-3",
                        children: "How It Works?"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-6",
                        children: "Find out everything about creating a business model."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row gy-4",
                        children: processList11.map(function(param) {
                            var id = param.id, title = param.title, description = param.description;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsxs("h4", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "text-primary",
                                                children: [
                                                    id,
                                                    "."
                                                ]
                                            }),
                                            " ",
                                            title
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-0",
                                        children: description
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process15 = ((/* unused pure expression or super */ null && (Process15)));

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process16.tsx


var Process16 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-3 gy-10 gy-lg-0 mb-15 mb-md-17 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-5 mx-auto order-lg-2",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "w-auto",
                        src: "/img/illustrations/3d5.png",
                        srcSet: "/img/illustrations/3d5@2x.png 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5 me-auto",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-16 text-uppercase text-grape mb-3",
                        children: "Our Solutions"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5 pe-xxl-5",
                        children: "Just sit & relax while we take care of your business needs."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-6",
                        children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus. Maecenas sed diam eget risus varius blandit sit amet non magna. Praesent commodo cursus magna."
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row align-items-center counter-wrapper gy-6",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "counter counter-lg mb-1",
                                        children: /*#__PURE__*/ _jsx(CountUp, {
                                            end: 99,
                                            suffix: "%"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h6", {
                                        className: "fs-17 mb-1",
                                        children: "Customer Satisfaction"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ratings five"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "counter counter-lg mb-1",
                                        children: /*#__PURE__*/ _jsx(CountUp, {
                                            end: 4,
                                            suffix: "x"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h6", {
                                        className: "fs-17 mb-1",
                                        children: "New Visitors"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ratings five"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var process_Process16 = ((/* unused pure expression or super */ null && (Process16)));

// EXTERNAL MODULE: ./src/data/demo-27.ts + 6 modules
var demo_27 = __webpack_require__(4823);
;// CONCATENATED MODULE: ./src/components/blocks/process/Process17.tsx


var Process17 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-gray position-relative min-vh-60 d-lg-flex align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6 position-lg-absolute top-0 start-0 image-wrapper bg-image bg-cover h-100",
                style: {
                    backgroundImage: "url(/img/photos/bg38.jpg)"
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: "divider text-gray divider-v-end d-none d-lg-block",
                    children: /*#__PURE__*/ _jsxs("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 54 1200",
                        children: [
                            /*#__PURE__*/ _jsx("g", {}),
                            /*#__PURE__*/ _jsx("g", {
                                children: /*#__PURE__*/ _jsx("g", {
                                    children: /*#__PURE__*/ _jsx("polygon", {
                                        fill: "currentColor",
                                        points: "48 0 0 0 48 1200 54 1200 54 0 48 0"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row gx-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6 ms-auto",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "pt-13 pb-15 pb-md-17 py-lg-16 ps-lg-15 pe-xxl-16",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "fs-15 text-uppercase text-muted mb-3",
                                    children: "How It Works?"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-3 ls-sm mb-7",
                                    children: "Here are the 3 working steps on success."
                                }),
                                data.processList.map(function(param) {
                                    var id = param.id, Icon = param.Icon, title = param.title, description = param.description;
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex flex-row mb-5",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx(Icon, {
                                                    className: "icon-svg-md text-blue me-5 mt-1"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h4", {
                                                        className: "fs-20 ls-sm",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "mb-0",
                                                        children: description
                                                    })
                                                ]
                                            })
                                        ]
                                    }, id);
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var process_Process17 = ((/* unused pure expression or super */ null && (Process17)));

;// CONCATENATED MODULE: ./src/components/blocks/process/index.ts




















/***/ }),

/***/ 587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hi": function() { return /* reexport */ services_Services19; },
  "m9": function() { return /* reexport */ services_Services22; }
});

// UNUSED EXPORTS: Services1, Services10, Services11, Services12, Services13, Services14, Services15, Services16, Services17, Services18, Services2, Services20, Services21, Services23, Services24, Services25, Services26, Services27, Services28, Services29, Services3, Services4, Services5, Services6, Services7, Services8, Services9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/reuseable/service-cards/index.ts + 6 modules
var service_cards = __webpack_require__(1169);
// EXTERNAL MODULE: ./src/data/service.ts + 16 modules
var service = __webpack_require__(9864);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services1.tsx



// -------- data -------- //

var Services1 = function() {
    var boxRef = useRef(null);
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-14 pt-md-16",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "What We Do?"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-10 px-xl-10",
                                children: "The service we offer is specifically designed to meet your needs."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "position-relative",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "shape rounded-circle bg-soft-blue rellax w-16 h-16",
                            style: {
                                zIndex: 0,
                                right: "-2.2rem",
                                bottom: "-0.5rem"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "shape bg-dot primary rellax w-16 h-17",
                            style: {
                                zIndex: 0,
                                top: "-0.5rem",
                                left: "-2.2rem"
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "row gx-md-5 gy-5 text-center",
                            children: serviceList1.map(function(item) {
                                return /*#__PURE__*/ _jsx(ServiceCard1, {
                                    Icon: item.icon,
                                    title: item.title,
                                    linkUrl: item.link,
                                    linkType: item.linkType,
                                    description: item.description
                                }, item.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services1 = ((/* unused pure expression or super */ null && (Services1)));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./src/components/reuseable/ListColumn.tsx



// ===========================================================
var ListColumn_ListColumn = function(param) {
    var list = param.list, _rowClass = param.rowClass, rowClass = _rowClass === void 0 ? "" : _rowClass, _bulletColor = param.bulletColor, bulletColor = _bulletColor === void 0 ? "primary" : _bulletColor;
    return /*#__PURE__*/ _jsx("div", {
        className: "row gy-3 " + rowClass,
        children: list.map(function(item, i) {
            return /*#__PURE__*/ _jsx("div", {
                className: "col-xl-6",
                children: /*#__PURE__*/ _jsx("ul", {
                    className: "icon-list bullet-bg bullet-soft-".concat(bulletColor, " mb-0"),
                    children: item.map(function(li, i) {
                        var liProps = i !== 0 ? {
                            className: "mt-3"
                        } : {};
                        return /*#__PURE__*/ _jsxs("li", _object_spread_props(_object_spread({}, liProps), {
                            children: [
                                /*#__PURE__*/ _jsx("i", {
                                    className: "uil uil-check"
                                }),
                                " ",
                                li
                            ]
                        }), li);
                    })
                })
            }, i);
        })
    });
};
/* harmony default export */ var reuseable_ListColumn = ((/* unused pure expression or super */ null && (ListColumn_ListColumn)));

// EXTERNAL MODULE: ./src/icons/solid-mono/Lamp.tsx
var Lamp = __webpack_require__(3521);
// EXTERNAL MODULE: ./src/icons/solid-mono/Bulb.tsx
var Bulb = __webpack_require__(417);
// EXTERNAL MODULE: ./src/icons/solid-mono/Puzzle.tsx
var Puzzle = __webpack_require__(5992);
// EXTERNAL MODULE: ./src/icons/solid-mono/Headphone.tsx
var Headphone = __webpack_require__(9033);
;// CONCATENATED MODULE: ./src/data/about.ts
// -------- icons -------- //




// =========================================================================
// used in the about-2, about-8, about-11, about-13, about-15, about-17 block
var about_aboutList1 = (/* unused pure expression or super */ null && ([
    [
        "Aenean quam ornare. Curabitur blandit.",
        "Nullam quis risus eget urna mollis ornare."
    ],
    [
        "Etiam porta euismod malesuada mollis.",
        "Vivamus sagittis lacus vel augue rutrum."
    ]
]));
// used in the about-6, about-19 block
var aboutList2 = (/* unused pure expression or super */ null && ([
    [
        "Aenean eu leo quam ornare curabitur blandit tempus.",
        "Nullam quis risus eget urna mollis ornare donec elit."
    ],
    [
        "Etiam porta sem malesuada magna mollis euismod.",
        "Fermentum massa vivamus faucibus amet euismod."
    ]
]));
// used in the about-11, about-19 block
var aboutList3 = [
    {
        id: 1,
        title: "Our Vision",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget. Fusce dapibus tellus."
    },
    {
        id: 2,
        title: "Our Mission",
        description: "Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet. Sed posuere consectetur."
    },
    {
        id: 3,
        title: "Our Values",
        description: "Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna scelerisque."
    }
];
// used in the about-20, about-21 block
var aboutList4 = [
    {
        id: 1,
        Icon: Lamp/* default */.Z,
        color: "fuchsia",
        title: "Creativity",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 2,
        Icon: Bulb/* default */.Z,
        color: "violet",
        title: "Innovative Thinking",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 3,
        Icon: Puzzle/* default */.Z,
        color: "orange",
        title: "Rapid Solutions",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 4,
        Icon: Headphone/* default */.Z,
        color: "green",
        title: "Top-Notch Support",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    }
];

;// CONCATENATED MODULE: ./src/components/blocks/services/Services2.tsx



// -------- data -------- //

var Services2 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7 order-lg-2",
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: /*#__PURE__*/ _jsx(Image, {
                                className: "w-auto",
                                alt: "our solutions",
                                src: "/img/illustrations/i8.png",
                                width: 640,
                                height: 458
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-5",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "Our Solutions"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-5",
                                children: "We make your spending stress-free for you to have the perfect control."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-6",
                                children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus."
                            }),
                            /*#__PURE__*/ _jsx(ListColumn, {
                                list: aboutList1
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var services_Services2 = ((/* unused pure expression or super */ null && (Services2)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services3.tsx




// -------- data -------- //

var Services3 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-15 text-uppercase text-muted mb-3 ",
                            children: "What We Do?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-5 mb-10",
                            children: "The service we offer is specifically designed to meet your needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-md-8 gy-8 text-center mb-14 mb-md-17",
                children: serviceList2.map(function(item) {
                    return /*#__PURE__*/ _jsx(ServiceCard2, _object_spread({}, item), item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services3 = ((/* unused pure expression or super */ null && (Services3)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services4.tsx






// -------- data -------- //

var Services4 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-8 col-xl-7 col-xxl-6",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-line text-primary mb-3",
                            children: "What We Do?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-9",
                            children: "The service we offer is specifically designed to meet your needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-md-8 gy-8 mb-14 mb-md-18",
                children: serviceList3.map(function(item) {
                    return /*#__PURE__*/ _createElement(ServiceCard2, _object_spread_props(_object_spread({}, item), {
                        key: item.id,
                        iconBoxClassNames: "icon btn btn-block btn-lg btn-soft-primary pe-none mb-6"
                    }));
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services4 = ((/* unused pure expression or super */ null && (Services4)));

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
// EXTERNAL MODULE: ./src/components/elements/tiles/index.tsx + 11 modules
var tiles = __webpack_require__(7492);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services5.tsx









// -------- data -------- //


var Services5 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-12 align-items-center mb-10 mb-md-13",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 position-relative",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "btn btn-circle btn-primary pe-none position-absolute counter-wrapper flex-column d-none d-md-flex",
                                style: {
                                    zIndex: 1,
                                    top: "50%",
                                    width: 170,
                                    height: 170,
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "text-white mb-1 mt-n2",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "counter counter-lg",
                                            children: /*#__PURE__*/ _jsx(CountUp, {
                                                end: 20,
                                                suffix: "+"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "Year Experience"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Tiles1, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-5",
                                children: "We bring solutions to make life easier for our customers."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-7",
                                children: "Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Vestibulum id ligula porta felis euismod semper. Vestibulum id ligula."
                            }),
                            /*#__PURE__*/ _jsx(ListColumn, {
                                list: aboutList1
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-lg-8 gx-xl-12 gy-8",
                children: serviceList4.map(function(_param) /*#__PURE__*/ {
                    var Icon = _param.Icon, item = _object_without_properties(_param, [
                        "Icon"
                    ]);
                    return _jsx("div", {
                        className: "col-md-6 col-lg-4",
                        children: /*#__PURE__*/ _jsx(ServiceCard3, _object_spread_props(_object_spread({}, item), {
                            Icon: /*#__PURE__*/ _jsx(Icon, {})
                        }))
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services5 = ((/* unused pure expression or super */ null && (Services5)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services6.tsx


// -------- data -------- //

// ============================================================
var Services6 = function(props) {
    var colOne = props.colOne, title = props.title, description = props.description, _colTwoClassNames = props.colTwoClassNames, colTwoClassNames = _colTwoClassNames === void 0 ? "" : _colTwoClassNames, _rowClassNames = props.rowClassNames, rowClassNames = _rowClassNames === void 0 ? "" : _rowClassNames, _bulletColor = props.bulletColor, bulletColor = _bulletColor === void 0 ? "primary" : _bulletColor;
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center " + rowClassNames,
        children: [
            colOne,
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-6 " + colTwoClassNames,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-5",
                        children: description
                    }),
                    /*#__PURE__*/ _jsx(ListColumn, {
                        list: serviceList5,
                        bulletColor: bulletColor
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services6 = ((/* unused pure expression or super */ null && (Services6)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services7.tsx






// -------- data -------- //

var Services7 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row text-center mt-xl-12",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-15 text-uppercase text-muted mb-3",
                            children: "App Features"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-9 px-xxl-11",
                            children: "SEOptimist is the only app you need to track your goals for better health."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-lg-8 gx-xl-12 gy-8 mb-14 mb-md-17",
                children: serviceList6.map(function(_param) /*#__PURE__*/ {
                    var Icon = _param.Icon, color = _param.color, item = _object_without_properties(_param, [
                        "Icon",
                        "color"
                    ]);
                    return _jsx("div", {
                        className: "col-md-6 col-lg-4",
                        children: /*#__PURE__*/ _jsx(ServiceCard3, _object_spread_props(_object_spread({}, item), {
                            Icon: /*#__PURE__*/ _jsx(Icon, {
                                className: "icon-svg-sm text-".concat(color, " me-4")
                            })
                        }))
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services7 = ((/* unused pure expression or super */ null && (Services7)));

// EXTERNAL MODULE: ./src/components/reuseable/IconBox.tsx
var reuseable_IconBox = __webpack_require__(220);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services8.tsx




// -------- data -------- //

var Services8 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gy-8 mt-5 mt-md-12 mt-lg-0 mb-15 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6 order-lg-2",
                children: /*#__PURE__*/ _jsx(Tiles4, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-6",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-4 mb-3",
                        children: "What We Do?"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "lead fs-lg mb-8 pe-xxl-2",
                        children: [
                            "The full service we are offering is ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "underline",
                                children: "specifically"
                            }),
                            " designed to meet your business needs and projects."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row gx-xl-10 gy-6",
                        children: serviceList2.map(function(param) {
                            var title = param.title, id = param.id, icon = param.icon;
                            return /*#__PURE__*/ _jsx("div", {
                                className: "col-md-6 col-lg-12 col-xl-6",
                                children: /*#__PURE__*/ _jsx(ServiceCard3, {
                                    title: title,
                                    description: "Nulla vitae elit libero pharetra augue dapibus.",
                                    Icon: /*#__PURE__*/ _jsx(IconBox, {
                                        icon: icon,
                                        className: "icon btn btn-circle btn-lg btn-soft-primary pe-none me-5"
                                    })
                                })
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services8 = ((/* unused pure expression or super */ null && (Services8)));

// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(9472);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services9.tsx



// -------- custom component -------- //


// -------- data -------- //

var Services9 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 mb-10 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-7 order-lg-2",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row gx-md-5 gy-5",
                    children: serviceList7.map(function(_param) /*#__PURE__*/ {
                        var id = _param.id, Icon = _param.Icon, color = _param.color, item = _object_without_properties(_param, [
                            "id",
                            "Icon",
                            "color"
                        ]);
                        return _jsx(ServiceCard4, _object_spread({
                            Icon: /*#__PURE__*/ _jsx(Icon, {
                                className: "icon-svg-md text-".concat(color, " mb-3")
                            })
                        }, item), id);
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-muted mb-3",
                        children: "What We Do?"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5",
                        children: "The service we offer is specifically designed to meet your needs."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Maecenas sed diam eget risus varius blandit sit amet non magna. Maecenas faucibus mollis interdum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et."
                    }),
                    /*#__PURE__*/ _jsx(NextLink, {
                        title: "More Details",
                        href: "#",
                        className: "btn btn-navy rounded-pill mt-3"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services9 = ((/* unused pure expression or super */ null && (Services9)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services10.tsx



var Services10 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-0 gy-10 mb-15 mb-md-18 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row g-6 text-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-6",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-lg-12",
                                        children: /*#__PURE__*/ _jsx("figure", {
                                            className: "rounded mb-6",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/img/photos/se1.jpg",
                                                srcSet: "/img/photos/se1@2x.jpg 2x",
                                                alt: ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-lg-12",
                                        children: /*#__PURE__*/ _jsx(ServiceCard5, {
                                            url: "#",
                                            icon: "uil-monitor",
                                            title: "Web Design",
                                            description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-6",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-lg-12 order-md-2",
                                        children: /*#__PURE__*/ _jsx("figure", {
                                            className: "rounded mb-6 mb-md-0",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/img/photos/se2.jpg",
                                                srcSet: "/img/photos/se2@2x.jpg 2x",
                                                alt: ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-lg-12",
                                        children: /*#__PURE__*/ _jsx(ServiceCard5, {
                                            url: "#",
                                            title: "Mobile Design",
                                            icon: "uil-mobile-android",
                                            className: "card shadow-lg mb-md-6 mt-lg-6",
                                            description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5 offset-lg-1",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-4 mb-3",
                        children: "What We Do?"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "lead fs-lg lh-sm",
                        children: "The full service we are offering is specifically designed to meet your business needs."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "Donec ullamcorper nulla non metus auctor fringilla. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam quis risus eget urna mollis ornare vel eu leo. Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas faucibus mollis elit interdum. Duis mollis, est non commodo luctus, nisi erat ligula."
                    }),
                    /*#__PURE__*/ _jsx(NextLink, {
                        title: "More Details",
                        href: "#",
                        className: "btn btn-primary rounded-pill mt-3"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services10 = ((/* unused pure expression or super */ null && (Services10)));

// EXTERNAL MODULE: ./src/data/demo-8.ts + 1 modules
var demo_8 = __webpack_require__(1657);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services11.tsx


// -------- data -------- //

var Services11 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 mb-14 mb-md-20 align-items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-md-8 col-lg-6 order-lg-2 position-relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape bg-soft-primary rounded-circle rellax w-20 h-20",
                        style: {
                            top: "-2rem",
                            right: "-1.9rem"
                        }
                    }),
                    /*#__PURE__*/ _jsx("figure", {
                        className: "rounded",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/img/photos/about11.jpg",
                            srcSet: "/img/photos/about11@2x.jpg 2x",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-6",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-4 mb-3",
                        children: "What We Do?"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "lead fs-lg mb-8 pe-xxl-2",
                        children: [
                            "The full service we are offering is ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "underline",
                                children: "specifically"
                            }),
                            " designed to meet your business needs and projects."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row gx-xl-10 gy-6",
                        children: services.map(function(param) {
                            var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                            return /*#__PURE__*/ _jsx("div", {
                                className: "col-md-6 col-lg-12 col-xl-6",
                                children: /*#__PURE__*/ _jsx(ServiceCard3, {
                                    title: title,
                                    description: description,
                                    Icon: /*#__PURE__*/ _jsx(Icon, {
                                        className: "icon-svg-sm text-primary me-5"
                                    })
                                })
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services11 = ((/* unused pure expression or super */ null && (Services11)));

// EXTERNAL MODULE: ./src/icons/lineal/Rocket.tsx
var lineal_Rocket = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/icons/lineal/Shield.tsx
var lineal_Shield = __webpack_require__(9524);
// EXTERNAL MODULE: ./src/icons/lineal/Savings.tsx
var lineal_Savings = __webpack_require__(4545);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services12.tsx


// -------- icons -------- //



// -------- custom component -------- //

var Services12 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-15 text-uppercase text-muted mb-3",
                            children: "Why Choose SEOptimist ?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-10 px-xl-10 px-xxl-15",
                            children: "Here are a few reasons why our customers choose molto."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("ul", {
                role: "tablist",
                className: "nav nav-tabs nav-tabs-bg nav-tabs-shadow-lg d-flex justify-content-between nav-justified flex-lg-row flex-column",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "nav-item",
                        role: "presentation",
                        children: /*#__PURE__*/ _jsxs("a", {
                            role: "tab",
                            href: "#tab2-1",
                            "data-bs-toggle": "tab",
                            "aria-selected": "true",
                            className: "nav-link d-flex flex-row active",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Rocket, {
                                        className: "icon-svg-md text-yellow me-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "mb-1",
                                            children: "Easy Usage"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Duis mollis commodo luctus cursus commodo tortor mauris."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "nav-item",
                        role: "presentation",
                        children: /*#__PURE__*/ _jsxs("a", {
                            role: "tab",
                            tabIndex: -1,
                            href: "#tab2-2",
                            "data-bs-toggle": "tab",
                            "aria-selected": "false",
                            className: "nav-link d-flex flex-row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Savings, {
                                        className: "icon-svg-md text-green me-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "mb-1",
                                            children: "Fast Transactions"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Vivamus sagittis lacus augue fusce dapibus tellus nibh."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "nav-item",
                        role: "presentation",
                        children: /*#__PURE__*/ _jsxs("a", {
                            role: "tab",
                            tabIndex: -1,
                            href: "#tab2-3",
                            "data-bs-toggle": "tab",
                            "aria-selected": "false",
                            className: "nav-link d-flex flex-row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Shield, {
                                        className: "icon-svg-md text-red me-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "mb-1",
                                            children: "Secure Payments"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Vestibulum ligula porta felis maecenas faucibus mollis."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "tab-content mt-6 mt-lg-8 mb-md-9",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-pane fade active show",
                        id: "tab2-1",
                        role: "tabpanel",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-6",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-md-5 gy-5 align-items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-6",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    alt: "",
                                                    src: "/img/photos/sa13.jpg",
                                                    srcSet: "/img/photos/sa13@2x.jpg 2x",
                                                    className: "img-fluid rounded shadow-lg d-flex ms-auto"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-6",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa14.jpg",
                                                        srcSet: "/img/photos/sa14@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg mb-5"
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa15.jpg",
                                                        srcSet: "/img/photos/sa15@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg d-flex col-10"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(List, {
                                    title: "Easy Usage",
                                    color: "yellow"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-pane fade",
                        id: "tab2-2",
                        role: "tabpanel",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-6 order-lg-2",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-md-5 gy-5",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-5",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa9.jpg",
                                                        srcSet: "/img/photos/sa9@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg my-5 d-flex ms-auto"
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa10.jpg",
                                                        srcSet: "/img/photos/sa10@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg d-flex col-10 ms-auto"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa11.jpg",
                                                        srcSet: "/img/photos/sa11@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg mb-5"
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa12.jpg",
                                                        srcSet: "/img/photos/sa12@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg d-flex col-11"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(List, {
                                    title: "Fast Transactions",
                                    color: "green"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-pane fade",
                        id: "tab2-3",
                        role: "tabpanel",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-6",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-md-5 gy-5",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-6",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa5.jpg",
                                                        srcSet: "/img/photos/sa5@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg mb-5"
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa6.jpg",
                                                        srcSet: "/img/photos/sa6@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg d-flex col-10 ms-auto"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-6",
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa7.jpg",
                                                        srcSet: "/img/photos/sa7@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg my-5"
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        alt: "",
                                                        src: "/img/photos/sa8.jpg",
                                                        srcSet: "/img/photos/sa8@2x.jpg 2x",
                                                        className: "img-fluid rounded shadow-lg d-flex col-10"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(List, {
                                    title: "Secure Payments",
                                    color: "red"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var List = function(param) {
    var color = param.color, title = param.title;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-lg-6",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "mb-3",
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Nullam quis risus eget urna."
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "icon-list bullet-bg bullet-soft-".concat(color),
                children: [
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-check"
                            }),
                            " Aenean eu leo quam. Pellentesque ornare."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-check"
                            }),
                            " Nullam quis risus eget urna mollis ornare."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-check"
                            }),
                            " Donec id elit non mi porta gravida at eget."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                title: "Learn More",
                href: "#",
                className: "btn btn-".concat(color, " mt-2")
            })
        ]
    });
};
/* harmony default export */ var services_Services12 = ((/* unused pure expression or super */ null && (Services12)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services13.tsx






// -------- data -------- //

var Services13 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-dark",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-16",
            children: [
                /*#__PURE__*/ _jsx("figure", {
                    className: "rounded mt-md-n21 mt-lg-n23 mb-14",
                    style: slideInDownAnimate("900ms"),
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/about15.jpg",
                        srcSet: "/img/photos/about15@2x.jpg 2x",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-md-10 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 text-white mb-10",
                            children: "The service we offer is specifically designed to meet your needs."
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-md-8 gy-8 text-center text-white",
                    children: serviceList2.map(function(item) {
                        return /*#__PURE__*/ _createElement(ServiceCard2, _object_spread_props(_object_spread({}, item), {
                            key: item.id,
                            titleColor: "text-white",
                            hiddenBtn: true
                        }));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services13 = ((/* unused pure expression or super */ null && (Services13)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services14.tsx




// -------- data -------- //

var Services14 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row text-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-15 text-uppercase text-primary mb-3",
                            children: "What We Do?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-10 px-xl-10",
                            children: "The service we offer is specifically designed to meet your needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "position-relative mb-14 mb-md-17",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape rounded-circle bg-soft-primary rellax w-16 h-16",
                        style: {
                            bottom: "-0.5rem",
                            right: "-2.5rem",
                            zIndex: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "shape bg-dot primary rellax w-16 h-17",
                        style: {
                            top: "-0.5rem",
                            left: "-2.5rem",
                            zIndex: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row gx-md-5 gy-5 text-center",
                        children: serviceList2.map(function(item) {
                            return /*#__PURE__*/ _jsx(ServiceCard6, _object_spread({}, item), item.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services14 = ((/* unused pure expression or super */ null && (Services14)));

// EXTERNAL MODULE: ./src/data/demo-11.ts
var demo_11 = __webpack_require__(9190);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services15.tsx


// -------- data -------- //

var Services15 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center mb-md-15",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-7 order-lg-2",
                children: /*#__PURE__*/ _jsx("figure", {
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "w-auto",
                        src: "/img/illustrations/i17.png",
                        srcSet: "/img/illustrations/i17@2x.png 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-5",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "fs-15 text-uppercase text-primary mb-3",
                        children: "Our Solutions"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "display-4 mb-5",
                        children: "We make your spending stress-free for you to have the perfect control."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-6",
                        children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus."
                    }),
                    /*#__PURE__*/ _jsx(ListColumn, {
                        list: list
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var services_Services15 = ((/* unused pure expression or super */ null && (Services15)));

// EXTERNAL MODULE: ./src/data/demo-12.ts + 4 modules
var demo_12 = __webpack_require__(3152);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services16.tsx






// -------- data -------- //

var Services16 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row gx-md-5 gy-5 mt-n18 mt-md-n21 mb-14 mb-md-17",
        children: services.map(function(_param) /*#__PURE__*/ {
            var id = _param.id, Icon = _param.Icon, item = _object_without_properties(_param, [
                "id",
                "Icon"
            ]);
            return _createElement(ServiceCard1, _object_spread_props(_object_spread({}, item), {
                key: id,
                linkUrl: "#",
                Icon: Icon
            }));
        })
    });
};
/* harmony default export */ var services_Services16 = ((/* unused pure expression or super */ null && (Services16)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services17.tsx



// -------- data -------- //

var Services17 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-14 pt-md-23 pb-14 pb-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8 text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-8 col-xl-7 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "What We Do"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4",
                                children: "We make your spending stress-free for you to have the perfect control."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-10 mb-14 mb-md-17 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6 position-relative",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape bg-dot primary rellax w-17 h-18",
                                    style: {
                                        bottom: "-2rem",
                                        left: "-0.7rem"
                                    }
                                }),
                                /*#__PURE__*/ _jsx("figure", {
                                    className: "rounded mb-0",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/img/photos/se3.jpg",
                                        srcSet: "/img/photos/se3@2x.jpg 2x",
                                        alt: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6",
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-6 mb-4",
                                    children: "Package Design"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Maecenas faucibus mollis interdum. Maecenas sed diam eget risus varius."
                                }),
                                /*#__PURE__*/ _jsx(ListColumn, {
                                    list: aboutList1,
                                    bulletColor: "leaf"
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "More Details",
                                    href: "#",
                                    className: "btn btn-soft-leaf rounded-pill mt-6 mb-0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6 order-lg-2 position-relative",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "shape rounded-circle bg-soft-primary rellax w-18 h-18",
                                    style: {
                                        bottom: "-2.5rem",
                                        right: "-1.5rem"
                                    }
                                }),
                                /*#__PURE__*/ _jsx("figure", {
                                    className: "rounded mb-0",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/img/photos/se4.jpg",
                                        srcSet: "/img/photos/se4@2x.jpg 2x",
                                        alt: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6",
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-6 mb-4",
                                    children: "Corporate Design"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Maecenas faucibus mollis interdum. Maecenas sed diam eget risus varius."
                                }),
                                /*#__PURE__*/ _jsx(ListColumn, {
                                    list: aboutList1,
                                    bulletColor: "leaf"
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "More Details",
                                    href: "#",
                                    className: "btn btn-soft-leaf rounded-pill mt-6 mb-0"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services17 = ((/* unused pure expression or super */ null && (Services17)));

;// CONCATENATED MODULE: ./src/hooks/useProgressbar.ts

var useProgressbar_useProgressbar = function() {
    useEffect(function() {
        __webpack_require__(713);
        var ProgressBar = __webpack_require__(2948);
        var pline = document.querySelectorAll(".progressbar.line");
        var pcircle = document.querySelectorAll(".progressbar.semi-circle");
        pline.forEach(function(e) {
            var line = new ProgressBar.Line(e, {
                strokeWidth: 6,
                trailWidth: 6,
                duration: 3000,
                easing: "easeInOut",
                text: {
                    style: {
                        color: "inherit",
                        position: "absolute",
                        right: "0",
                        top: "-30px",
                        padding: 0,
                        margin: 0,
                        transform: null
                    },
                    autoStyleContainer: false
                },
                step: function(_, line) {
                    line.setText(Math.round(line.value() * 100) + " %");
                }
            });
            var value = Number(e.getAttribute("data-value")) / 100;
            var waypoint = new window.Waypoint({
                element: e,
                offset: "bottom-in-view",
                handler: function() {
                    return line.animate(value);
                }
            });
            return function() {
                line.destroy();
                waypoint.destroy();
            };
        });
        pcircle.forEach(function(e) {
            var circle = new ProgressBar.SemiCircle(e, {
                strokeWidth: 6,
                trailWidth: 6,
                duration: 2000,
                easing: "easeInOut",
                step: function(_, circle) {
                    circle.setText(Math.round(circle.value() * 100));
                }
            });
            var value = Number(e.getAttribute("data-value")) / 100;
            var waypoint = new window.Waypoint({
                element: e,
                offset: "bottom-in-view",
                handler: function() {
                    return circle.animate(value);
                }
            });
            return function() {
                circle.destroy();
                waypoint.destroy();
            };
        });
    }, []);
    return;
};
/* harmony default export */ var hooks_useProgressbar = ((/* unused pure expression or super */ null && (useProgressbar_useProgressbar)));

// EXTERNAL MODULE: ./src/utils/color.ts
var color = __webpack_require__(516);
;// CONCATENATED MODULE: ./src/data/skill.ts

var skill_skill1 = [
    {
        id: 1,
        percent: 100,
        title: "Web Design",
        color: color/* default.violet */.Z.violet
    },
    {
        id: 2,
        percent: 80,
        title: "Mobile Design",
        color: color/* default.blue */.Z.blue
    },
    {
        id: 3,
        percent: 85,
        title: "Development",
        color: color/* default.leaf */.Z.leaf
    },
    {
        id: 4,
        percent: 90,
        title: "SEO",
        color: color/* default.pink */.Z.pink
    }
];
// used in the about-24 block
var skill2 = [
    {
        id: 1,
        title: "Photoshop",
        value: 100
    },
    {
        id: 2,
        title: "Final Cut",
        value: 80
    },
    {
        id: 3,
        title: "Motion Video",
        value: 85
    },
    {
        id: 4,
        title: "Manupilation",
        value: 75
    }
];

;// CONCATENATED MODULE: ./src/components/blocks/services/Services18.tsx

// -------- hook -------- //

// -------- data -------- //


var Services18 = function() {
    // used for the animated line
    useProgressbar();
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light wrapper-border",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-18",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-6 mb-10",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6 order-lg-2",
                            children: /*#__PURE__*/ _jsx("ul", {
                                className: "progress-list",
                                children: skill1.map(function(param) {
                                    var id = param.id, title = param.title, percent = param.percent, color = param.color;
                                    return /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: title
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "progressbar line soft-".concat(color),
                                                "data-value": percent
                                            })
                                        ]
                                    }, id);
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "display-4 mb-3",
                                    children: "What I Do?"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-20 mb-5",
                                    children: "Duis mollis est commodo luctus nisi erat porttitor ligula, eget lacinia odio sem nec elit. Nullam quis risus eget urna mollis ornare vel. Nulla vitae elit libero, a pharetra augue. Praesent commodo cursus magna, vel scelerisque nisl."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-6 text-center",
                    children: serviceList8.map(function(param) {
                        var id = param.id, Icon = param.Icon, title = param.title, description = param.description;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-6 col-lg-3",
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    className: "icon-svg-md text-violet mb-3"
                                }),
                                /*#__PURE__*/ _jsx("h4", {
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-2",
                                    children: description
                                })
                            ]
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services18 = ((/* unused pure expression or super */ null && (Services18)));

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services19.tsx




var Services19 = function(param) {
    var title = param.title, serviceList = param.serviceList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container py-17 pt-md-17",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-9 col-xl-8 col-xxl-7 mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "fs-15 text-uppercase text-muted",
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-9 col-xl-8 col-xxl-5 mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "display-4 mb-9",
                            style: {
                                textTransform: "none"
                            },
                            children: [
                                "Why choose",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline-3 style-2 blue",
                                    children: "SEOptimist"
                                }),
                                " ",
                                "as your ",
                                title,
                                "s?"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row gx-md-8 gx-xl-12 gy-8 mb-14 mb-md-16 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_IconBox/* default */.Z, {
                                    className: "icon btn btn-block btn-lg btn-soft-".concat(serviceList[0].color, " pe-none mb-5"),
                                    icon: serviceList[0].icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: serviceList[0].title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-3",
                                    children: serviceList[0].description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                    //legacyBehavior2 passHref2
                                    className: "more hover link-".concat(serviceList[0].color),
                                    activeClass: "active",
                                    to: "localSEO",
                                    spy: true,
                                    smooth: true,
                                    offset: 0,
                                    duration: 500,
                                    children: "Browse Local SEO"
                                })
                            ]
                        }, serviceList[0].id),
                        serviceList.slice(1).map(function(id) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_IconBox/* default */.Z, {
                                        className: "icon btn btn-block btn-lg btn-soft-".concat(id.color, " pe-none mb-5"),
                                        icon: id.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: id.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-3",
                                        children: id.description
                                    })
                                ]
                            }, id);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services19 = (Services19);

;// CONCATENATED MODULE: ./src/components/blocks/services/Services20.tsx


// -------- data -------- //

var Services20 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row text-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-gradient gradient-1 mb-3",
                            children: "Our Features"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-9 px-xl-11",
                            children: "The service we offer is specifically designed to meet your needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gy-8 mb-17",
                children: serviceList10.map(function(param) {
                    var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                    return /*#__PURE__*/ _jsx("div", {
                        className: "col-md-6 col-lg-4",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        className: "icon-svg-sm solid-duo text-grape-fuchsia me-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "fs-22 mb-1",
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-0",
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services20 = ((/* unused pure expression or super */ null && (Services20)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services21.tsx






// -------- data -------- //

var Services21 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row gx-md-5 gy-5 mb-14 mb-md-17",
        children: serviceList11.map(function(_param) /*#__PURE__*/ {
            var id = _param.id, Icon = _param.Icon, item = _object_without_properties(_param, [
                "id",
                "Icon"
            ]);
            return _createElement(ServiceCard1, _object_spread_props(_object_spread({}, item), {
                key: id,
                linkUrl: "#",
                Icon: Icon
            }));
        })
    });
};
/* harmony default export */ var services_Services21 = ((/* unused pure expression or super */ null && (Services21)));

// EXTERNAL MODULE: ./src/icons/solid-mono/Compare.tsx
var Compare = __webpack_require__(2415);
// EXTERNAL MODULE: ./src/icons/solid-mono/DeliveryBox.tsx
var DeliveryBox = __webpack_require__(9585);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(4870);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services22.tsx


// -------- icons -------- //





var Services22 = function(param) {
    var title = param.title, wordCloud = param.wordCloud;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container py-14 pt-md-14 pb-md-18",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: wordCloud.HomeList[4].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "display-3 mb-5 px-xl-10 px-xxl-15",
                                style: {
                                    textTransform: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "underline-3 style-2 yellow text-capitalize",
                                    children: wordCloud.HomeList[5].title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "lead fs-20 mx-auto mb-10",
                                children: [
                                    "Technical issues may be preventing the website from performing optimally in search engine results\xa0pages\xa0(SERPs). Our ",
                                    wordCloud.HomeList[5].title,
                                    " begin after an initial technical assessment of your website."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    role: "tablist",
                    className: "nav nav-tabs nav-tabs-bg nav-tabs-shadow-lg d-flex justify-content-between nav-justified flex-lg-row flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item",
                            role: "presentation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                role: "tab",
                                href: "#tab2-1",
                                "data-bs-toggle": "tab",
                                "aria-selected": "true",
                                className: "nav-link d-flex flex-row active",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bulb/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-1",
                                                children: "AI Keyword research"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Keyword research is an important part of SEO strategy, and identifies which keywords are vital for your brand."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item",
                            role: "presentation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                role: "tab",
                                tabIndex: -1,
                                href: "#tab2-2",
                                "data-bs-toggle": "tab",
                                "aria-selected": "false",
                                className: "nav-link d-flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Compare/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-1",
                                                children: "Competitor & Technical Analysis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Studying your competitors' websites and marketing strategies"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item",
                            role: "presentation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                role: "tab",
                                tabIndex: -1,
                                href: "#tab2-3",
                                "data-bs-toggle": "tab",
                                "aria-selected": "false",
                                className: "nav-link d-flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryBox/* default */.Z, {
                                            className: "icon-svg-sm solid-mono text-green me-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-1",
                                                children: "Transparent Process"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "At SEOptimist, we believe in transparent and ethical SEO practices."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tab-content mt-6 mt-lg-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-pane fade active show",
                            id: "tab2-1",
                            role: "tabpanel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/img/".concat(wordCloud.HomeList[2].title.replace(/ /g, "-").toLowerCase(), ".png"),
                                                // srcSet={`/img/${wordCloud.HomeList[2].title.replace(/ /g, '-').toLowerCase()}@2x.png 2x`}
                                                alt: wordCloud.HomeList[2].title.toLowerCase()
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List1, {
                                        wordCloud: wordCloud.HomeList,
                                        title: "Keyword research",
                                        heading: title,
                                        color: "fuchsia"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-pane fade",
                            id: "tab2-2",
                            role: "tabpanel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 order-lg-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/img/".concat(wordCloud.HomeList[4].title.replace(/ /g, "-").toLowerCase(), ".png"),
                                                // srcSet="/img/technical-seo-company@2x.png 2x"
                                                alt: wordCloud.HomeList[4].title.toLowerCase()
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List2, {
                                        wordCloud: wordCloud.HomeList,
                                        title: "Competitor & Technical Analysis",
                                        heading: title,
                                        color: "violet"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-pane fade",
                            id: "tab2-3",
                            role: "tabpanel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/img/".concat(wordCloud.HomeList[3].title.replace(/ /g, "-").toLowerCase(), ".png"),
                                                // srcSet="/img/technical-seo-company@2x.png 2x"
                                                alt: wordCloud.HomeList[3].title.toLowerCase()
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List3, {
                                        wordCloud: wordCloud.HomeList,
                                        title: "Transparent Process",
                                        heading: title,
                                        color: "green"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var List1 = function(param) {
    var color = param.color, title = param.title, heading = param.heading, wordCloud = param.wordCloud;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-lg-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-3",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Keyword research plays a crucial role in developing a successful ",
                    wordCloud[0].title,
                    " strategy as it helps in identifying the most important keywords for your brand. By analyzing search patterns and user behavior, we can determine the specific keywords and phrases that your target audience is using to search for your products or services."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "With rapid advancements in technology, AI-powered tools have revolutionized the keyword research process, allowing us to gather and analyze data at an unprecedented scale and speed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "By leveraging the power of AI,",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/" + keywords.SEOAudit[0].url + "/" + keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-"),
                        children: "SEOptimist"
                    }),
                    " ",
                    "can identify and target highly relevant keywords that are more likely to drive traffic to your website and generate leads. This not only improves the efficiency and accuracy of the keyword research process, but also helps in achieving better results and maximizing the return on investment for your SEO efforts."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                //legacyBehavior2 passHref2
                activeClass: "active",
                to: "contact",
                spy: true,
                smooth: true,
                offset: 0,
                duration: 500,
                className: "btn btn-sm btn-primary rounded-pill",
                children: "Learn more"
            })
        ]
    });
};
var List2 = function(param) {
    var color = param.color, title = param.title, heading = param.heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-lg-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-3",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "A thorough analysis of your competitors' keywords, content, and backlink profiles is key to staying ahead of the competition."
                    }),
                    " ",
                    "Analyzing competitor keywords, content, and backlink profiles creates lots of high return marketing opportunities."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Technical analysis of your website's structure, code and page speed"
                    }),
                    " identifies any technical issues that may be impacting your search engine rankings.",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "By identifying and fixing these issues, you can improve the user experience and ensure that your website is optimized for search engines."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Both competitor and technical analysis are important components of SEO research, as they can help you identify areas for improvement and develop a targeted SEO strategy that will drive traffic and increase your online visibility."
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                //legacyBehavior2 passHref2
                activeClass: "active",
                to: "contact",
                spy: true,
                smooth: true,
                offset: 0,
                duration: 500,
                className: "btn btn-sm btn-primary rounded-pill",
                children: "Learn more"
            })
        ]
    });
};
var List3 = function(param) {
    var color = param.color, title = param.title, heading = param.heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-lg-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-3",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We provide our clients with a detailed SEO process that outlines the specific tasks and strategies we will use to improve their website's search engine rankings."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "Our process includes:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SEO audit: Comprehensive audit of the client's website to identify any technical issues, on-page SEO issues, and opportunities for improvement."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Keyword research: Research and identify the most relevant and profitable keywords for the client's business and target audience."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "On-page optimization: Optimize the client's website pages for their targeted keywords by improving the content, meta tags, and other on-page elements."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Off-page optimization: Build high-quality backlinks to the client's website to improve its authority and visibility in search engine results pages."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Reporting and tracking: Provide regular reports to the client to track the progress of our SEO efforts and make any necessary adjustments to our strategy."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SEOptimist ensures that all clients have access to the analytics and the work that we have completed. You can see exactly what tasks have been completed and the results that have been achieved. We only take the final payment when the client is satisfied and can see proof of tasks completed."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                //legacyBehavior2 passHref2
                activeClass: "active",
                to: "contact",
                spy: true,
                smooth: true,
                offset: 0,
                duration: 500,
                className: "btn btn-sm btn-primary rounded-pill",
                children: "Learn more"
            })
        ]
    });
};
/* harmony default export */ var services_Services22 = (Services22);

;// CONCATENATED MODULE: ./src/components/blocks/services/Services23.tsx


var Services23 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-15 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center mb-10",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 col-lg-9 col-xxl-8 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "What We Do?"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 px-xl-10 mb-0",
                                children: "The service we offer is specifically designed to meet your needs."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-10 mb-15 mb-md-17 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded mb-0",
                                children: /*#__PURE__*/ _jsx("img", {
                                    alt: "",
                                    className: "img-fluid",
                                    src: "/img/illustrations/ui4.png",
                                    srcSet: "/img/illustrations/ui4@2x.png 2x"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ColumnTwo, {
                            title: "Web Design",
                            className: "ms-auto"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-10 mb-15 mb-md-17 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6 order-lg-2 ms-auto",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded mb-0",
                                children: /*#__PURE__*/ _jsx("img", {
                                    alt: "",
                                    className: "img-fluid",
                                    src: "/img/illustrations/ui1.png",
                                    srcSet: "/img/illustrations/ui1@2x.png 2x"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ColumnTwo, {
                            title: "Mobile Development"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-10 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded mb-0",
                                children: /*#__PURE__*/ _jsx("img", {
                                    alt: "",
                                    className: "img-fluid",
                                    src: "/img/illustrations/ui5.png",
                                    srcSet: "/img/illustrations/ui5@2x.png 2x"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ColumnTwo, {
                            title: "SEO Optimization",
                            className: "ms-auto"
                        })
                    ]
                })
            ]
        })
    });
};
var ColumnTwo = function(param) {
    var title = param.title, _className = param.className, className = _className === void 0 ? "" : _className;
    // list data
    var list = [
        "Aenean quam ornare curabitur blandit.",
        "Nullam quis risus eget urna mollis ornare leo.",
        "Etiam porta euismod mollis natoque ornare."
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-lg-5 ".concat(className),
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "fs-28 mb-3",
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna risus varius."
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "icon-list bullet-bg bullet-soft-primary",
                children: list.map(function(item) {
                    return /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-check"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: item
                            })
                        ]
                    }, item);
                })
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                title: "More Details",
                href: "#",
                className: "btn btn-soft-primary rounded-pill mt-2 mb-0"
            })
        ]
    });
};
/* harmony default export */ var services_Services23 = ((/* unused pure expression or super */ null && (Services23)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services24.tsx


// -------- data -------- //

var Services24 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gradient-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-12 pt-lg-8 pb-14 pb-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 col-lg-8 offset-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "What We Do?"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 mb-10 px-xxl-10",
                                children: "The service we offer is specifically designed to meet your needs."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-11 px-xxl-5 text-center d-flex align-items-end",
                    children: serviceList12.map(function(param) {
                        var id = param.id, image = param.image, title = param.title, description = param.description;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "px-md-15 px-lg-3",
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        className: "mb-6",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            className: "img-fluid",
                                            src: image["1x"],
                                            srcSet: image["2x"],
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-2",
                                        children: description
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "Learn More",
                                        href: "#",
                                        className: "more hover"
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services24 = ((/* unused pure expression or super */ null && (Services24)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services25.tsx



// -------- data -------- //

var Services25 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row text-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-9 col-xl-8 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-muted mb-3",
                            children: "What We Do?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-10 px-xxl-10",
                            children: "The full service we are offering is specifically designed to meet your needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-xxl-11 mx-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row gx-lg-8 gx-xl-12 gy-11 text-center d-flex align-items-end",
                        children: serviceList13.map(function(param) {
                            var id = param.id, description = param.description, icon = param.icon, linkUrl = param.linkUrl, title = param.title, color = param.color;
                            return /*#__PURE__*/ _jsx("div", {
                                className: "col-sm-8 col-md-6 col-lg-4 mx-auto",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "px-md-3 px-lg-0 px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "icon btn btn-block btn-lg btn-soft-".concat(color, " pe-none mb-5"),
                                            children: /*#__PURE__*/ _jsx("i", {
                                                className: "uil ".concat(icon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "fs-22",
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-2",
                                            children: description
                                        }),
                                        /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Learn More",
                                            href: linkUrl,
                                            className: "more hover link-".concat(color)
                                        })
                                    ]
                                })
                            }, id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services25 = ((/* unused pure expression or super */ null && (Services25)));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services26.tsx


// -------- data -------- //

var Services26 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-16",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-12 col-xl-10 col-xxl-7 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "icn-flower text-leaf fs-30 opacity-25"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-5 text-center mt-2 mb-10",
                                children: "I absolutely love shooting weddings and couples because there are so many feelings to capture."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row grid-view gx-md-8 gx-xl-10 gy-8 gy-lg-0 text-center",
                    children: serviceList14.map(function(param) {
                        var id = param.id, title = param.title, image = param.image, url = param.url;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "col-sm-8 col-md-6 col-lg-4 mx-auto",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card shadow-lg",
                                children: [
                                    /*#__PURE__*/ _jsxs("figure", {
                                        className: "card-img-top overlay overlay-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Link, {
                                                // legacyBehavior2 passHref2 
                                                href: url,
                                                children: /*#__PURE__*/ _jsxs("a", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("img", {
                                                            className: "img-fluid",
                                                            src: image["1x"],
                                                            srcSet: image["2x"],
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "bg"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("figcaption", {
                                                children: /*#__PURE__*/ _jsx("h5", {
                                                    className: "from-top mb-0",
                                                    children: "View Gallery"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card-body p-6",
                                        children: /*#__PURE__*/ _jsx("h3", {
                                            className: "fs-21 mb-0",
                                            children: title
                                        })
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services26 = ((/* unused pure expression or super */ null && (Services26)));

;// CONCATENATED MODULE: ./src/components/blocks/services/Services27.tsx



var Services27 = function() {
    return /*#__PURE__*/ _jsx("section", {
        id: "services",
        children: /*#__PURE__*/ _jsx("div", {
            className: "wrapper bg-gray",
            children: /*#__PURE__*/ _jsx("div", {
                className: "container py-15 py-md-17",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-10 align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row g-6 text-center",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "col-md-6",
                                        children: [
                                            /*#__PURE__*/ _jsx(Card, {
                                                title: "Products",
                                                image: "/img/photos/fs4.jpg",
                                                className: "mb-6"
                                            }),
                                            /*#__PURE__*/ _jsx(Card, {
                                                title: "Recipes",
                                                image: "/img/photos/fs6.jpg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "col-md-6",
                                        children: [
                                            /*#__PURE__*/ _jsx(Card, {
                                                title: "Restaurants",
                                                image: "/img/photos/fs5.jpg",
                                                className: "mt-md-6 mb-6"
                                            }),
                                            /*#__PURE__*/ _jsx(Card, {
                                                title: "Still Life",
                                                image: "/img/photos/fs7.jpg"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-5 offset-lg-1",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "display-5 mb-3",
                                    children: "My Services"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-lg",
                                    children: "I would like to give you a unique photography experience, capture your products with excellent composition and lighting skills."
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: "Donec ullamcorper nulla non metus auctor fringilla. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam quis risus eget urna mollis ornare vel eu leo. Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas faucibus mollis elit interdum. Duis mollis, est non commodo luctus, nisi erat ligula mollis metus auctor fringilla."
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "More Details",
                                    href: "#",
                                    className: "btn btn-primary rounded-pill mt-2"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var Card = function(param) {
    var image = param.image, title = param.title, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsxs("div", {
        className: "card shadow-lg ".concat(className),
        children: [
            /*#__PURE__*/ _jsxs("figure", {
                className: "card-img-top overlay overlay-1",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        // legacyBehavior2 passHref2 
                        href: "#",
                        children: /*#__PURE__*/ _jsxs("a", {
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "img-fluid",
                                    src: image,
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "bg"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("figcaption", {
                        children: /*#__PURE__*/ _jsx("h5", {
                            className: "from-top mb-0",
                            children: "View Gallery"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card-body p-4",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h4 mb-0",
                    children: title
                })
            })
        ]
    });
};
/* harmony default export */ var services_Services27 = ((/* unused pure expression or super */ null && (Services27)));

// EXTERNAL MODULE: ./src/data/demo-26.ts + 4 modules
var demo_26 = __webpack_require__(8231);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services28.tsx



// -------- data -------- //

var Services28_Services27 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row text-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 offset-md-1 col-xxl-8 offset-xxl-2",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-primary mb-3",
                            children: "What We Do?"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-9",
                            children: "The full service we are offering is specifically designed to meet your business needs."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-md-8 gy-8 mb-15 mb-md-17 text-center",
                children: data.serviceList.map(function(param) {
                    var id = param.id, Icon = param.Icon, title = param.title, description = param.description, url = param.url;
                    return /*#__PURE__*/ _jsx("div", {
                        className: "col-md-6 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "px-md-3 px-lg-0 px-xl-3",
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {}),
                                /*#__PURE__*/ _jsx("h4", {
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-2",
                                    children: description
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "Learn More",
                                    href: url,
                                    className: "more hover"
                                })
                            ]
                        })
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var Services28 = ((/* unused pure expression or super */ null && (Services28_Services27)));

// EXTERNAL MODULE: ./src/data/demo-27.ts + 6 modules
var demo_27 = __webpack_require__(4823);
;// CONCATENATED MODULE: ./src/components/blocks/services/Services29.tsx

// -------- data -------- //

var Services29 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-15 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 col-lg-9 col-xxl-8 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-15 text-uppercase text-muted mb-3",
                                children: "What We Do?"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 ls-sm mb-9 px-xl-11",
                                children: "The service we offer is specifically designed to meet your needs."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-8",
                    children: data.serviceList.map(function(param) {
                        var Icon = param.Icon, id = param.id, title = param.title, color = param.color, description = param.description;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "col-md-6 col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx(Icon, {
                                            className: "icon-svg-md text-".concat(color, " me-5 mt-1")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("h4", {
                                                className: "fs-20 ls-sm",
                                                children: title
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mb-0",
                                                children: description
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var services_Services29 = ((/* unused pure expression or super */ null && (Services29)));

;// CONCATENATED MODULE: ./src/components/blocks/services/index.ts
































/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9472);




var GoogleAppBtn = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex justify-content-center justify-content-lg-start",
        style: slideInDownAnimate("900ms"),
        children: [
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1200ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-primary btn-icon btn-icon-start rounded me-2",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-apple"
                            }),
                            " App Store"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1500ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-green btn-icon btn-icon-start rounded",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-google-play"
                            }),
                            " Google Play"
                        ]
                    })
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (GoogleAppBtn)));


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 1169:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: ServiceCard1, ServiceCard2, ServiceCard3, ServiceCard4, ServiceCard5, ServiceCard6

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(9472);
;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard1.tsx


// ===============================================================
var ServiceCard1 = function(props) {
    var title = props.title, description = props.description, Icon = props.Icon, linkUrl = props.linkUrl, linkType = props.linkType, _cardClassName = props.cardClassName, cardClassName = _cardClassName === void 0 ? "" : _cardClassName, iconClassName = props.iconClassName;
    return /*#__PURE__*/ _jsx("div", {
        className: "col-md-6 col-xl-3",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card shadow-lg ".concat(cardClassName),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "card-body",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: iconClassName
                    }),
                    /*#__PURE__*/ _jsx("h4", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-2",
                        children: description
                    }),
                    /*#__PURE__*/ _jsx(NextLink, {
                        title: "Learn More",
                        href: linkUrl,
                        className: "more hover link-".concat(linkType)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var service_cards_ServiceCard1 = ((/* unused pure expression or super */ null && (ServiceCard1)));

// EXTERNAL MODULE: ./src/components/reuseable/IconBox.tsx
var IconBox = __webpack_require__(220);
;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard2.tsx



// ================================================
var ServiceCard2 = function(props) {
    var title = props.title, linkUrl = props.linkUrl, description = props.description, icon = props.icon, iconBoxClassNames = props.iconBoxClassNames, titleColor = props.titleColor, hiddenBtn = props.hiddenBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-md-6 col-lg-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox/* default */.Z, {
                icon: icon,
                className: iconBoxClassNames
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: titleColor,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-3",
                children: description
            }),
            !hiddenBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                title: "Learn More",
                href: linkUrl,
                className: "more hover"
            })
        ]
    });
};
// set deafult Props
ServiceCard2.defaultProps = {
    iconBoxClassNames: "icon btn btn-circle btn-lg btn-primary pe-none mb-5"
};
/* harmony default export */ var service_cards_ServiceCard2 = ((/* unused pure expression or super */ null && (ServiceCard2)));

;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard3.tsx

// ================================================
var ServiceCard3 = function(props) {
    var title = props.title, description = props.description, Icon = props.Icon, _className = props.className, className = _className === void 0 ? "d-flex flex-row" : _className;
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: Icon
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        className: "mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-0",
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var service_cards_ServiceCard3 = ((/* unused pure expression or super */ null && (ServiceCard3)));

;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard4.tsx

// ==================================================================================
var ServiceCard4 = function(props) {
    var title = props.title, Icon = props.Icon, cardColor = props.cardColor, columnClass = props.columnClass, description = props.description;
    return /*#__PURE__*/ _jsx("div", {
        className: columnClass,
        children: /*#__PURE__*/ _jsx("div", {
            className: "card ".concat(cardColor),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "card-body",
                children: [
                    Icon,
                    /*#__PURE__*/ _jsx("h4", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-0",
                        children: description
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var service_cards_ServiceCard4 = ((/* unused pure expression or super */ null && (ServiceCard4)));

;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard5.tsx


// ==================================================================================
var ServiceCard5 = function(props) {
    var icon = props.icon, title = props.title, description = props.description, url = props.url, _className = props.className, className = _className === void 0 ? "card shadow-lg mb-md-6 mt-lg-6" : _className;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "icon btn btn-circle btn-lg btn-soft-purple pe-none mb-3",
                    children: /*#__PURE__*/ _jsx("i", {
                        className: "uil ".concat(icon)
                    })
                }),
                /*#__PURE__*/ _jsx("h4", {
                    children: title
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-2",
                    children: description
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    title: "Learn More",
                    href: url,
                    className: "more hover link-purple"
                })
            ]
        })
    });
};
/* harmony default export */ var service_cards_ServiceCard5 = ((/* unused pure expression or super */ null && (ServiceCard5)));

;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/ServiceCard6.tsx



// ================================================
var ServiceCard6 = function(props) {
    var title = props.title, linkUrl = props.linkUrl, description = props.description, icon = props.icon, iconBoxClassNames = props.iconBoxClassNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-md-6 col-lg-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-body",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox/* default */.Z, {
                        icon: icon,
                        className: iconBoxClassNames
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-3",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                        title: "Learn More",
                        href: linkUrl,
                        className: "more hover"
                    })
                ]
            })
        })
    });
};
// set deafult Props
ServiceCard6.defaultProps = {
    iconBoxClassNames: "icon btn btn-circle btn-lg btn-primary pe-none mb-5"
};
/* harmony default export */ var service_cards_ServiceCard6 = ((/* unused pure expression or super */ null && (ServiceCard6)));

;// CONCATENATED MODULE: ./src/components/reuseable/service-cards/index.ts









/***/ }),

/***/ 4823:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./src/icons/lineal/Shield.tsx
var Shield = __webpack_require__(9524);
// EXTERNAL MODULE: ./src/icons/lineal/Design.tsx
var Design = __webpack_require__(757);
// EXTERNAL MODULE: ./src/icons/lineal/Target.tsx
var Target = __webpack_require__(9708);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/icons/lineal/Wallet.tsx

var Wallet = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 383.36 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-yellow me-5 mt-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M11.5,220.22A11.5,11.5,0,0,1,0,208.72V155.06A77.14,77.14,0,0,1,77.06,78H316.67a11.5,11.5,0,0,1,0,23H77.06A54.12,54.12,0,0,0,23,155.06v53.66a11.5,11.5,0,0,1-11.5,11.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M260.2,138.87a82.37,82.37,0,1,0-138,0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M260.2,150.37h-138a11.49,11.49,0,0,1-9.63-5.21A94.23,94.23,0,0,1,124.84,27.49a93.88,93.88,0,0,1,132.75,0,94.23,94.23,0,0,1,12.24,117.67,11.49,11.49,0,0,1-9.63,5.21Zm-131.44-23H253.67a71.18,71.18,0,0,0-12.35-83.61,70.85,70.85,0,0,0-100.21,0,71.18,71.18,0,0,0-12.35,83.61Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M189.6,128.68c-11.73-.3-20.55-6.6-20.55-12,0-2.71,2.43-6.78,5.43-6.78,3.69,0,6.59,6.3,15.12,7.27V97.85c-8.82-3.3-18.8-7.08-18.8-19.49s9.11-17.64,18.8-18.9V56.75c0-1.26,1.46-2.43,3.3-2.43,1.65,0,3.3,1.17,3.3,2.43v2.52c6.3.19,16.57,2,16.57,7.66,0,2.22-1.55,6.68-5.14,6.68-2.71,0-4.94-3.1-11.43-3.58V87.09c8.62,3.2,18.32,7.56,18.32,20.74,0,11.93-7.47,18.81-18.32,20.55v3c0,1.26-1.65,2.42-3.3,2.42-1.84,0-3.3-1.16-3.3-2.42ZM190.38,85V70.32c-4.84.77-7.76,3.1-7.76,6.79,0,4.26,3.3,6.1,7.76,7.85Zm5,15.22V117c4.27-.87,7.27-3.39,7.27-8,0-4.75-3.1-7.07-7.27-8.91Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M319.3,409.6H77.06A77.15,77.15,0,0,1,0,332.54V204.79a77.16,77.16,0,0,1,77.06-77.06H319.31a40.36,40.36,0,0,1,40.31,40.33V234.9a11.5,11.5,0,1,1-23,0V168.06a17.34,17.34,0,0,0-17.31-17.32H77.06a54.12,54.12,0,0,0-54.06,54V332.54A54.12,54.12,0,0,0,77.06,386.6H319.31a17.34,17.34,0,0,0,17.31-17.32V358.36a11.5,11.5,0,0,1,23,0v10.92A40.36,40.36,0,0,1,319.3,409.6Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M371.86,309.66H280.24a43.82,43.82,0,0,1,0-87.63h91.62Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M371.86,321.16H280.24a55.32,55.32,0,1,1,0-110.64h91.62A11.52,11.52,0,0,1,383.36,222v87.63a11.51,11.51,0,0,1-11.5,11.5Zm-91.62-87.63a32.32,32.32,0,0,0,0,64.63h80.11V233.53Z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Wallet = (Wallet);

// EXTERNAL MODULE: ./src/icons/lineal/ChatTwo.tsx
var ChatTwo = __webpack_require__(2875);
;// CONCATENATED MODULE: ./src/icons/lineal/Loyalty.tsx

var Loyalty = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 457.97",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-yellow me-5"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M286.5,180.78c-18.21,0-26.38,10.21-29.59,16.2a1.08,1.08,0,0,1-1.9,0c-3.21-6-11.33-16.2-29.54-16.2-20.74,0-39,14.16-39,40a54.24,54.24,0,0,0,8,29.43c12.06,20.38,51.78,46.81,59.94,52a2.74,2.74,0,0,0,3,0c8.16-5.18,47.9-31.48,60.05-52a54.22,54.22,0,0,0,8-29.43C325.51,194.94,307.24,180.78,286.5,180.78Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M256,316.82h0a16.91,16.91,0,0,1-9.09-2.65c-8.3-5.3-50.43-32.93-64.51-56.74a68.28,68.28,0,0,1-10-36.64c0-31.38,22.34-54.16,53.13-54.16,13.91,0,23.74,4.56,30.5,9.92,6.76-5.36,16.61-9.92,30.53-9.92,30.81,0,53.16,22.78,53.16,54.16a68.25,68.25,0,0,1-10,36.64c-14.19,24-56.34,51.49-64.65,56.76A16.86,16.86,0,0,1,256,316.82ZM225.47,194.94c-11.45,0-24.83,6.77-24.83,25.85A40.3,40.3,0,0,0,206.72,243c7.43,12.57,31.56,31.35,49.25,43.27,17.69-11.87,41.84-30.61,49.33-43.27a40.38,40.38,0,0,0,6.06-22.22c0-19.08-13.39-25.86-24.86-25.86-8.25,0-14,2.94-17.12,8.74a15.24,15.24,0,0,1-26.86,0C239.43,197.87,233.7,194.94,225.47,194.94Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M130.67,458c-8.1,0-19.71-3.73-44.41-31.37C74.07,413,64.07,399.53,63.65,399a14.32,14.32,0,0,1-1-1.56A58.57,58.57,0,0,1,55.29,369V301.34a14.15,14.15,0,0,1,14.15-14.15H155.9a50,50,0,0,1,35.31,14.46l44.27,43.56a36.25,36.25,0,1,1-51.18,51.34L141,353.28l-9.66-.06a14.16,14.16,0,0,1,.08-28.31h.07c5.35,0,9.26.06,11.84.09,5.33.07,9.54.13,13.67,4.25l47.28,47.29a7.94,7.94,0,0,0,11.23-11.24l-44.18-43.48a21.93,21.93,0,0,0-15.46-6.33H83.59V369A30.14,30.14,0,0,0,87,382.9c16.91,22.62,37.33,44.05,44.52,46.77l115,0c7.14,0,15.91-4,24.27-8,6.87-3.33,59.31-38.81,94.36-62.95.24-.16.48-.32.73-.46a9.49,9.49,0,0,0,3.22-13,9.47,9.47,0,0,0-12.79-3.34l-64.07,42.48a14.15,14.15,0,1,1-15.64-23.58L341,318.09l.52-.33a37.77,37.77,0,0,1,39.39,64.46c-15.12,10.41-86.6,59.5-97.77,64.9S259.62,458,246.49,458l-115.82,0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                className: "lineal-fill",
                x: "14.15",
                y: "288.21",
                width: "73.13",
                height: "141.2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M87.28,443.56H14.15A14.16,14.16,0,0,1,0,429.41V288.21a14.15,14.15,0,0,1,14.15-14.15H87.28a14.14,14.14,0,0,1,14.15,14.15v141.2A14.15,14.15,0,0,1,87.28,443.56Zm-59-28.31H73.13V302.36H28.3Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M442.56,170.79H356.11a50.09,50.09,0,0,1-35.32-14.46l-44.27-43.56a36.25,36.25,0,1,1,51.19-51.35L371,104.69l9.66.07a14.15,14.15,0,0,1-.07,28.3h-.08c-5.34,0-9.25-.06-11.84-.09-5.33-.07-9.54-.12-13.66-4.25L307.69,81.44a7.94,7.94,0,0,0-11.23,11.23l44.18,43.48a21.93,21.93,0,0,0,15.46,6.33h72.3V88.94A30.13,30.13,0,0,0,425,75.07C408.11,52.45,387.69,31,380.5,28.3l-115,0c-7.14,0-15.91,4-24.28,8-6.86,3.33-59.3,38.82-94.35,63-.24.16-.48.32-.73.47a9.47,9.47,0,0,0,9.56,16.34L219.79,73.6a14.15,14.15,0,0,1,15.64,23.59l-64.38,42.7-.52.32a37.77,37.77,0,0,1-39.39-64.46c15.11-10.4,86.6-59.49,97.77-64.9C240.23,5.37,252.38,0,265.51,0L381.32,0h0c8.1,0,19.72,3.73,44.41,31.37C437.94,45,447.93,58.44,448.35,59a14.32,14.32,0,0,1,1,1.56,58.57,58.57,0,0,1,7.35,28.37v67.69A14.16,14.16,0,0,1,442.56,170.79Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                className: "lineal-fill",
                x: "424.72",
                y: "28.56",
                width: "73.13",
                height: "141.2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M497.85,183.92H424.72a14.15,14.15,0,0,1-14.15-14.16V28.56a14.15,14.15,0,0,1,14.15-14.15h73.13A14.16,14.16,0,0,1,512,28.56v141.2A14.16,14.16,0,0,1,497.85,183.92Zm-59-28.31H483.7V42.72H438.87Z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Loyalty = (Loyalty);

;// CONCATENATED MODULE: ./src/icons/lineal/Padlock.tsx

var Padlock = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 324.02 512",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-pink me-5 mt-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M14.31,241.68V439.17a58.52,58.52,0,0,0,58.52,58.52H251.19a58.52,58.52,0,0,0,58.52-58.52V241.68ZM162,407.85a47.7,47.7,0,1,1,47.7-47.7A47.7,47.7,0,0,1,162,407.85Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M251.19,512H72.83A72.91,72.91,0,0,1,0,439.17V241.68a14.31,14.31,0,0,1,14.31-14.3h295.4A14.31,14.31,0,0,1,324,241.68V439.17A72.91,72.91,0,0,1,251.19,512ZM28.62,256V439.17a44.26,44.26,0,0,0,44.21,44.21H251.19a44.26,44.26,0,0,0,44.21-44.21V256ZM162,422.16a62,62,0,1,1,62-62A62.08,62.08,0,0,1,162,422.16Zm0-95.4a33.39,33.39,0,1,0,33.39,33.39A33.44,33.44,0,0,0,162,326.76Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M68.56,234.54H20.38a14.31,14.31,0,0,1,0-28.62H68.56a14.31,14.31,0,0,1,0,28.62Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M303.64,234.54H255.46a14.31,14.31,0,0,1,0-28.62h48.18a14.31,14.31,0,0,1,0,28.62Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M45.14,256a14.3,14.3,0,0,1-14.31-14.31V124a124.16,124.16,0,0,1,124-124h14.32a124.17,124.17,0,0,1,124,124V225.16a14.31,14.31,0,1,1-28.62,0V124a95.51,95.51,0,0,0-95.4-95.4H154.85A95.51,95.51,0,0,0,59.44,124V241.68A14.3,14.3,0,0,1,45.14,256Z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Padlock = (Padlock);

// EXTERNAL MODULE: ./src/icons/lineal/AwardTwo.tsx
var AwardTwo = __webpack_require__(7885);
;// CONCATENATED MODULE: ./src/icons/lineal/CheckList.tsx

var CheckList = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 418.2 512",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-blue me-5 mt-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M14.8 97.6h85.4V14.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M100.2 112.4H14.8C6.6 112.4 0 105.8 0 97.7c0-4 1.6-7.9 4.5-10.7L89.9 4.2c5.8-5.7 15.2-5.6 20.9.3 2.7 2.8 4.2 6.5 4.2 10.3v82.8c0 8.2-6.6 14.8-14.8 14.8zm-49-29.6h34.2V49.7L51.2 82.8zM403.4 320c-8.2 0-14.8-6.6-14.8-14.8v-269c0-3.6-3.2-6.6-7.2-6.6H168.7c-8.2 0-14.8-6.6-14.8-14.8 0-8.2 6.6-14.8 14.8-14.8h212.6c20.3 0 36.8 16.2 36.8 36.1v269c.1 8.3-6.5 14.9-14.7 14.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M381.4 512H36.8C16.5 512 0 495.8 0 475.9V97.6c0-4 1.6-7.8 4.5-10.6L89.9 4.2c5.9-5.7 15.2-5.5 20.9.3 5.7 5.9 5.5 15.2-.3 20.9l-80.9 78.5v372c0 3.6 3.2 6.6 7.2 6.6h344.6c4 0 7.2-3 7.2-6.6v-92.7c.2-8.2 7-14.6 15.2-14.4 7.9.2 14.2 6.5 14.4 14.4v92.7c0 19.9-16.5 36.1-36.8 36.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M403.4 112.4H168.7c-8.2-.2-14.6-7-14.4-15.2.2-7.9 6.5-14.2 14.4-14.4h219.9v-43c0-5.7-4.6-10.3-10.3-10.3H168.7c-8.2 0-14.8-6.6-14.8-14.8C154 6.6 160.6 0 168.7 0h209.6c22 0 39.8 17.9 39.9 39.8v57.8c0 8.2-6.6 14.8-14.8 14.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M73 189.6h124.1v65H73z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M197.1 269.4H73c-8.2 0-14.8-6.6-14.8-14.8v-65c0-8.2 6.6-14.8 14.7-14.8H197c8.2 0 14.8 6.6 14.8 14.8v65c.1 8.1-6.5 14.8-14.7 14.8.1 0 0 0 0 0zM87.8 239.8h94.6v-35.5H87.8v35.5zm201 25.3c-3.9 0-7.7-1.6-10.5-4.3l-23.6-23.6c-5.7-5.9-5.6-15.2.3-20.9 5.7-5.6 14.9-5.6 20.6 0l13.2 13.2 46-46c5.9-5.7 15.2-5.6 20.9.3 5.6 5.7 5.6 14.9 0 20.6l-56.4 56.4c-2.8 2.7-6.6 4.3-10.5 4.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M73 346.1h124.1v65H73z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M197.1 426H73c-8.2 0-14.8-6.6-14.8-14.8v-65c0-8.2 6.5-14.8 14.7-14.9h124.2c8.2 0 14.8 6.6 14.8 14.8v65c0 8.2-6.5 14.9-14.8 14.9.1 0 .1 0 0 0zM87.8 396.4h94.6v-35.5H87.8v35.5zm201 25.3c-3.9 0-7.7-1.6-10.5-4.3l-23.6-23.6c-5.7-5.9-5.6-15.2.3-20.9 5.7-5.6 14.9-5.6 20.6 0l13.2 13.2 46-46c5.9-5.7 15.2-5.6 20.9.3 5.6 5.7 5.6 14.9 0 20.6l-56.4 56.4c-2.8 2.7-6.6 4.3-10.5 4.3z"
            })
        ]
    });
};
/* harmony default export */ var lineal_CheckList = (CheckList);

;// CONCATENATED MODULE: ./src/icons/lineal/Insurance.tsx

var Insurance = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 441.41 512",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-pink me-5 mt-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M254.93,457a46.24,46.24,0,0,1-24.13-40.62V285.62A70,70,0,0,0,307.94,270a100.73,100.73,0,0,0-81.62-41.61H115.72A100.88,100.88,0,0,0,14.84,329.31V497.16H327.2v-.81Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M426.57,270.78a14.85,14.85,0,0,0-14.85,14.84V416.34a31.41,31.41,0,0,1-16.38,27.59l-66.66,36.32L262,443.93a31.4,31.4,0,0,1-16.39-27.59V305.05a85.35,85.35,0,0,0,12.31.89c1.26,0,2.51,0,3.76-.1l1,0c1.13-.06,2.25-.14,3.37-.25l1.59-.18,1.65-.2a83.72,83.72,0,0,0,41.13-17.47l1.09-.86,1.28-1.07c.85-.72,1.69-1.47,2.52-2.23l.41-.38c.95-.88,1.88-1.79,2.78-2.71l0,0h0a85,85,0,0,0,10.13-12.56,85.74,85.74,0,0,0,28,26.55,14.84,14.84,0,0,0,15-25.63A55.78,55.78,0,0,1,349,243.37a14.85,14.85,0,0,0-13.58-8.85H321.94a14.85,14.85,0,0,0-13.58,8.85c-.45,1-.94,2-1.44,3a116.46,116.46,0,0,0-45.39-27.21,87.22,87.22,0,0,0,27.23-63.34V87.5a14.85,14.85,0,0,0-29.69,0v68.29A57.86,57.86,0,0,1,202,213.58H140A57.86,57.86,0,0,1,83,155.79V87.5a57.87,57.87,0,0,1,57.81-57.81h60.48a14.85,14.85,0,0,0,0-29.69H140.78a87.6,87.6,0,0,0-87.5,87.5v68.29a87.23,87.23,0,0,0,27.19,63.3A115.93,115.93,0,0,0,0,329.31V497.16A14.85,14.85,0,0,0,14.84,512H327.2c.27,0,.55,0,.82,0s.44,0,.66,0a14.76,14.76,0,0,0,7.1-1.81L409.54,470a61.06,61.06,0,0,0,31.87-53.65V285.63A14.85,14.85,0,0,0,426.57,270.78Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M29.69,482.31v-153a86.13,86.13,0,0,1,86-86H140l.74,0h15.4V387.46a14.84,14.84,0,1,0,29.68,0V243.29h15.4l.74,0h24.32a86.35,86.35,0,0,1,60.4,24.82,55,55,0,0,1-20.58,7.54l-.15,0c-1.15.17-2.31.29-3.47.38l-.56.06c-1.24.09-2.49.13-3.74.14H258a54.76,54.76,0,0,1-21.38-4.3A14.84,14.84,0,0,0,216,285.62V416.34A61.12,61.12,0,0,0,247.82,470l22.6,12.31Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M327.19,405.92a14.81,14.81,0,0,1-7.22-1.87l-24.85-13.86a14.84,14.84,0,0,1,14.45-25.93L325.24,373l34.06-30.14A14.84,14.84,0,1,1,379,365.09L337,402.2A14.82,14.82,0,0,1,327.19,405.92Z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Insurance = (Insurance);

// EXTERNAL MODULE: ./src/icons/lineal/Telephone.tsx
var Telephone = __webpack_require__(8290);
// EXTERNAL MODULE: ./src/icons/lineal/Analytics.tsx
var Analytics = __webpack_require__(3293);
// EXTERNAL MODULE: ./src/icons/lineal/Megaphone.tsx
var Megaphone = __webpack_require__(58);
// EXTERNAL MODULE: ./src/icons/lineal/LightBulb.tsx
var LightBulb = __webpack_require__(9759);
// EXTERNAL MODULE: ./src/icons/lineal/PieChartTwo.tsx
var PieChartTwo = __webpack_require__(9669);
;// CONCATENATED MODULE: ./src/icons/lineal/CloudComputingTwo.tsx

var CloudComputingTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 319.1",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-orange me-5"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M333.9 278.3H276c-6-.2-10.8-5.2-10.6-11.2.2-5.8 4.8-10.4 10.6-10.6h57.9c29.8 0 53.9-24.1 53.9-53.9 0-25.9-18.5-48.1-43.9-52.9-5.9-1.1-9.8-6.8-8.7-12.7 0-.2.1-.5.2-.7 12.6-48.9-16.8-98.7-65.7-111.4-38.3-9.9-78.7 6-100 39.4-2.9 4.6-8.8 6.3-13.7 4.1-30.1-13.6-65.6-.2-79.2 29.9-3.5 7.8-5.3 16.2-5.3 24.7 0 4.6.6 9.3 1.6 13.8 1.4 5.9-2.3 11.7-8.1 13.1-.1 0-.2 0-.2.1-29.3 6-47.9 34.6-41.8 63.7 5.3 24.9 27.2 42.8 52.7 42.8h58.2c6 .2 10.8 5.2 10.6 11.2-.2 5.8-4.8 10.4-10.6 10.6H75.7C33.9 278.3 0 244.4 0 202.6c0-31.9 20-60.4 50-71.2-.3-2.8-.4-5.7-.5-8.5 0-45.1 36.6-81.7 81.8-81.7 8.5 0 16.9 1.3 25 3.9 37.6-50 108.6-60 158.5-22.4C348.4 48 365.2 89.6 358.6 131c39.5 13.6 60.5 56.7 46.9 96.2-10.6 30.6-39.3 51.1-71.6 51.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M250.6 224.3l-39.3-53.6c-2.7-3.6-7.8-4.4-11.4-1.8-.7.5-1.3 1.1-1.8 1.8L159 224.3c-2.7 3.6-1.9 8.7 1.7 11.4 1.4 1 3.1 1.6 4.9 1.6h10.7v52.2c0 10.3 8.3 18.6 18.6 18.6h19.8c10.3 0 18.6-8.3 18.6-18.6v-52.3H244c4.5 0 8.2-3.6 8.2-8.1.1-1.7-.5-3.4-1.6-4.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M214.7 319.1h-19.8c-16.3 0-29.5-13.2-29.5-29.5v-41.3c-10.5-.1-19-8.8-18.9-19.3 0-4 1.3-7.8 3.7-11l39.3-53.6c6.2-8.5 18-10.4 26.5-4.2 1.6 1.2 3 2.6 4.2 4.2l39.3 53.6c6.2 8.5 4.4 20.4-4.1 26.6-3.2 2.3-7.1 3.6-11 3.7v41.3c-.1 16.2-13.4 29.4-29.7 29.5zM171 226.4h5.3c6 0 10.9 4.9 10.9 10.9v52.2c0 4.3 3.5 7.7 7.7 7.7h19.8c4.3 0 7.7-3.5 7.7-7.7v-52.2c0-6 4.9-10.9 10.9-10.9h5.3l-33.9-46.2-33.7 46.2z"
            })
        ]
    });
};
/* harmony default export */ var lineal_CloudComputingTwo = (CloudComputingTwo);

// EXTERNAL MODULE: ./src/utils/color.ts
var color = __webpack_require__(516);
;// CONCATENATED MODULE: ./src/data/demo-27.ts

















var serviceList = [
    {
        id: 1,
        Icon: Telephone/* default */.Z,
        color: color/* default.blue */.Z.blue,
        title: "24/7 Support",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 2,
        Icon: Shield/* default */.Z,
        color: color/* default.yellow */.Z.yellow,
        title: "Secure Payments",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 3,
        color: color/* default.orange */.Z.orange,
        Icon: lineal_CloudComputingTwo,
        title: "Daily Updates",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 4,
        Icon: Analytics/* default */.Z,
        color: color/* default.pink */.Z.pink,
        title: "Market Research",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 5,
        Icon: ChatTwo/* default */.Z,
        color: color/* default.green */.Z.green,
        title: "Social Engagement",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 6,
        Icon: Megaphone/* default */.Z,
        color: color/* default.purple */.Z.purple,
        title: "Content Marketing",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    }
];
var processList = [
    {
        id: 1,
        Icon: LightBulb/* default */.Z,
        title: "Collect Ideas",
        description: "Nulla vitae elit libero pharetra augue dapibus. Praesent commodo cursus."
    },
    {
        id: 2,
        Icon: PieChartTwo/* default */.Z,
        title: "Data Analysis",
        description: "Vivamus sagittis lacus vel augue laoreet. Etiam porta sem malesuada magna."
    },
    {
        id: 3,
        Icon: Design/* default */.Z,
        title: "Magic Touch",
        description: "Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed."
    }
];
var abouts = [
    {
        id: 1,
        Icon: Target/* default */.Z,
        color: color/* default.blue */.Z.blue,
        title: "Our Vision",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget. Fusce dapibus\n        tellus."
    },
    {
        id: 2,
        Icon: AwardTwo/* default */.Z,
        color: color/* default.green */.Z.green,
        title: "Our Mission",
        description: "Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet. Sed posuere  consectetur."
    },
    {
        id: 3,
        Icon: lineal_Loyalty,
        color: color/* default.yellow */.Z.yellow,
        title: "Our Values",
        description: "Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna scelerisque."
    }
];
var pricingList = [
    {
        price: 9,
        plan: "Basic",
        features: [
            "2 Projects",
            "100K API Access",
            "100MB Storage",
            "Weekly Reports",
            "7/24 Support"
        ]
    },
    {
        price: 19,
        plan: "Premium",
        features: [
            "5 Projects",
            "200K API Access",
            "300MB Storage",
            "Weekly Reports",
            "7/24 Support"
        ]
    },
    {
        price: 29,
        plan: "Corporate",
        features: [
            "20 Projects",
            "300K API Access",
            "500MB Storage",
            "Weekly Reports",
            "7/24 Support"
        ]
    },
    {
        price: 49,
        plan: "Community",
        features: [
            "90 Projects",
            "900K API Access",
            "900MB Storage",
            "Weekly Reports",
            "7/24 Support"
        ]
    }
];
var faqList = [
    {
        id: 1,
        Icon: lineal_CheckList,
        title: "Can I cancel my subscription?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod."
    },
    {
        id: 2,
        Icon: lineal_Wallet,
        title: "Which payment methods do you accept?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod."
    },
    {
        id: 3,
        Icon: lineal_Insurance,
        title: "How can I manage my Account?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod."
    },
    {
        id: 4,
        Icon: lineal_Padlock,
        title: "Is my credit card information secure?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod."
    }
];
/* harmony default export */ var demo_27 = ({
    serviceList: serviceList,
    processList: processList,
    abouts: abouts,
    pricingList: pricingList,
    faqList: faqList
});


/***/ }),

/***/ 9870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vz": function() { return /* binding */ processList1; },
  "f2": function() { return /* binding */ seoAuditList1; }
});

// UNUSED EXPORTS: processList10, processList11, processList12, processList2, processList3, processList4, processList5, processList6, processList7, processList8, processList9

// EXTERNAL MODULE: ./src/icons/solid-mono/Bulb.tsx
var Bulb = __webpack_require__(417);
// EXTERNAL MODULE: ./src/icons/lineal/Shield.tsx
var Shield = __webpack_require__(9524);
// EXTERNAL MODULE: ./src/icons/lineal/Rocket.tsx
var Rocket = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/icons/lineal/Design.tsx
var Design = __webpack_require__(757);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/icons/lineal/Loading.tsx

var Loading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 409.6 353.3",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-yellow mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M176.6 353.3c-46.9 0-91.9-18.6-125-51.8-68.9-68.9-68.9-181 0-249.9 69-69 180.9-69 249.9 0 24 24 40.5 54.3 47.7 87.5.4 1.9.8 3.9 1.2 6.2l2.7 14.8c1.1 6.2-3 12.2-9.3 13.3-.7.1-1.3.2-2 .2h-51c-5.4 0-10-3.7-11.2-9l-2.1-9.9C265.3 99 210.1 63.8 154.4 76.1s-90.9 67.4-78.6 123.2c7.9 35.6 33.9 64.4 68.6 75.8 3 1 6.1 1.8 9.1 2.5 6.2 1.4 10 7.5 8.6 13.7-1.4 6.2-7.5 10-13.7 8.6-3.7-.9-7.5-1.9-11.1-3.1C71 275 34.9 203.4 56.8 137c6.2-18.7 16.6-35.7 30.5-49.7 49.2-49.3 129-49.5 178.4-.3 17.3 17.2 29.2 39 34.3 62.9l.2.9h28.1l-.2-1.4c-.4-2-.7-3.8-1.1-5.4C308.9 60.9 226.9 8.3 143.8 26.4c-28.8 6.3-55.2 20.7-76 41.5-60 60-60 157.6 0 217.6 41 41.1 101.7 55.5 156.9 37.4L206 290.3c-3-5.6-.9-12.5 4.6-15.5 5.3-2.9 12-1.1 15.2 4.1l25.6 44.4c3.2 5.5 1.3 12.5-4.2 15.6-.6.4-1.3.7-2 .9l-10.8 3.7c-18.6 6.5-38.1 9.8-57.8 9.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M236.6 160.7l80.8 140 80.8-140H236.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M317.4 312.1c-4.1 0-7.9-2.2-9.9-5.7l-80.8-140c-3.2-5.5-1.3-12.5 4.2-15.6 1.7-1 3.7-1.5 5.7-1.5h161.6c6.3 0 11.4 5.1 11.4 11.4 0 2-.5 4-1.5 5.7l-80.8 140c-2.1 3.6-5.9 5.7-9.9 5.7zm-61-140l61 105.7 61-105.7h-122z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Loading = (Loading);

// EXTERNAL MODULE: ./src/icons/solid-mono/Compare.tsx
var Compare = __webpack_require__(2415);
// EXTERNAL MODULE: ./src/icons/lineal/Savings.tsx
var Savings = __webpack_require__(4545);
// EXTERNAL MODULE: ./src/icons/lineal/LightBulb.tsx
var LightBulb = __webpack_require__(9759);
// EXTERNAL MODULE: ./src/icons/solid-mono/DeliveryBox.tsx
var DeliveryBox = __webpack_require__(9585);
// EXTERNAL MODULE: ./src/icons/lineal/PieChartTwo.tsx
var PieChartTwo = __webpack_require__(9669);
// EXTERNAL MODULE: ./src/icons/lineal/SmartphoneTwo.tsx
var SmartphoneTwo = __webpack_require__(9711);
// EXTERNAL MODULE: ./src/icons/lineal/CloudComputing.tsx
var CloudComputing = __webpack_require__(1777);
;// CONCATENATED MODULE: ./src/data/process.ts
// -------- icons -------- //












var processList1 = [
    {
        no: "1",
        title: "Keyword Research",
        className: "ms-lg-15 mt-6",
        subtitle: "SEOptimist discovers the best keywords for your industry with AI based keyword research. We improve your position in search engines, attract more targeted visitors and increase your ROI with less work.",
        icon: "/home-icons/semrush.png",
        iconAlt: "SEMRush"
    },
    {
        no: "2",
        className: "me-lg-6",
        title: "Analyse Data",
        subtitle: "We base your strategy on hard data. We remove all the guesswork to improve your SEO. You will see a significant rise in site visitors and revenue.",
        icon: "/home-icons/1.png",
        iconAlt: "Data-driven AI SEO"
    },
    {
        no: "3",
        title: "Dominate Google",
        className: "mx-lg-6 ms-lg-10 mt-6",
        subtitle: "We have helped many removals companies get high quality traffic from top Google positions, which leads to significantly increased turnover.",
        icon: "/home-icons/google.png",
        iconAlt: "SEMRush"
    },
    {
        no: "4",
        title: "AI SEO Content",
        className: "mx-lg-6 ms-lg-0 mt-6",
        subtitle: "Fast creation of high-quality, search engine optimised articles. With creative paraphrasing and human editing, your content will be optimised for higher rankings and more traffic.",
        icon: "/home-icons/chat-gpt.png",
        iconAlt: "ChatGPT"
    }
];
var seoAuditList1 = [
    {
        no: "1",
        className: "me-lg-6",
        title: "Why do you need an SEO Audit?",
        subtitle: "The success of a website relies heavily on search engine optimisation (SEO). It helps to attract traffic to your site, improves your rankings in search engine results pages (SERPs), and generally raises your profile online. If you want your website to perform as well as it possibly can in search engine results, an SEO audit service can point you where tweaks are needed."
    },
    {
        no: "2",
        title: "What is in an SEO Audit?",
        className: "ms-lg-15 mt-6",
        subtitle: "A website's overall search engine optimisation effectiveness can be evaluated with the use of an SEO audit. It examines everything from the site's keywords and content to its links and technical SEO. Title tags, meta descriptions, optimised content, optimised images, internal linking structure, and other on-page factors are just some of the things that will be looked at throughout the audit. Off-page factors like link development, social media presence, and other external aspects will also be assessed."
    },
    {
        no: "3",
        title: "SEO recommendations",
        className: "mx-lg-6 ms-lg-10 mt-6",
        subtitle: "An SEO audit is a comprehensive look at where your site is in the search engine results pages and where changes can be made. An audit will also provide actionable recommendations for optimisation and best practises to apply to boost the overall performance of the website."
    },
    {
        no: "4",
        title: "Free Online SEO Audit",
        className: "mx-lg-6 ms-lg-0 mt-6",
        subtitle: "You can save both money and effort by using our free audit service to evaluate your website's effectiveness."
    }
];
// 
//An SEO audit is an essential step in any successful SEO campaign. 
// used in the process-6 block
var processList2 = [
    {
        no: "01",
        title: "Concept",
        subtitle: "Nulla vitae elit libero elit non porta gravida eget metus cras. Aenean eu leo quam. Pellentesque ornare."
    },
    {
        no: "02",
        title: "Prepare",
        subtitle: "Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis."
    },
    {
        no: "03",
        title: "Retouch",
        subtitle: "Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nulla vitae elit libero."
    },
    {
        no: "04",
        title: "Finalize",
        subtitle: "Integer posuere erat, consectetur adipiscing elit. Fusce dapibus, tellus ac cursus commodo."
    }
];
// used in the process-2 block
var processList3 = [
    {
        no: "1",
        className: "me-lg-6",
        title: "Collect Ideas",
        subtitle: "Nulla vitae elit libero pharetra augue dapibus. Praesent commodo cursus."
    },
    {
        no: "2",
        title: "Data Analysis",
        className: "ms-lg-13 mt-6",
        subtitle: "Vivamus sagittis lacus vel augue laoreet. Etiam porta sem malesuada magna."
    },
    {
        no: "3",
        title: "Finalize Product",
        className: "mx-lg-6 mt-6",
        subtitle: "Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed."
    }
];
// used in the process-3 block
var processList4 = [
    {
        no: "1",
        title: "Collect Ideas",
        subtitle: "Nulla vitae elit libero pharetra augue dapibus. Praesent commodo cursus."
    },
    {
        no: "2",
        title: "Data Analysis",
        subtitle: "Vivamus sagittis lacus vel augue laoreet. Etiam porta sem malesuada magna."
    },
    {
        no: "3",
        title: "Finalize Product",
        subtitle: "Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed."
    }
];
// used in the process-4 block
var processList5 = [
    {
        Icon: Shield/* default */.Z,
        color: "red",
        title: "1. Secured Transactions",
        subtitle: "Etiam porta malesuada magna mollis euismod sem."
    },
    {
        Icon: Savings/* default */.Z,
        color: "green",
        title: "2. Budget Planning",
        subtitle: "Etiam porta malesuada magna mollis euismod sem."
    },
    {
        Icon: lineal_Loading,
        color: "yellow",
        title: "3. Up to Date",
        subtitle: "Etiam porta malesuada magna mollis euismod sem."
    }
];
// used in the process-5 block
var processList6 = [
    {
        id: 1,
        color: "green",
        Icon: CloudComputing/* default */.Z,
        title: "1. Download",
        description: "Nulla vitae elit libero elit non porta eget."
    },
    {
        id: 2,
        color: "red",
        Icon: SmartphoneTwo/* default */.Z,
        title: "2. Set Profile",
        description: "Nulla vitae elit libero elit non porta eget."
    },
    {
        id: 3,
        color: "aqua",
        Icon: Rocket/* default */.Z,
        title: "3. Start",
        description: "Nulla vitae elit libero elit non porta eget."
    }
];
// used in the process-8 block
var processList7 = [
    {
        id: 1,
        Icon: LightBulb/* default */.Z,
        title: "Collect Ideas",
        description: "Nulla vitae elit libero pharetra augue dapibus."
    },
    {
        id: 2,
        Icon: PieChartTwo/* default */.Z,
        title: "Data Analysis",
        description: "Vivamus sagittis lacus augue laoreet vel."
    },
    {
        id: 3,
        Icon: Design/* default */.Z,
        title: "Magic Touch",
        description: "Cras mattis consectetur purus sit amet."
    }
];
// used in the process-9 block
var processList8 = [
    {
        id: 1,
        Icon: Shield/* default */.Z,
        iconColor: "yellow",
        title: "Secured Transactions",
        className: "d-flex flex-row mb-5",
        description: "Nulla vitae elit libero pharetra augue dapibus. Praesent commodo cursus."
    },
    {
        id: 2,
        Icon: Savings/* default */.Z,
        iconColor: "green",
        title: "Bills Planning",
        className: "d-flex flex-row mb-5",
        description: "Vivamus sagittis lacus vel augue laoreet. Etiam porta sem malesuada magna."
    },
    {
        id: 3,
        Icon: lineal_Loading,
        iconColor: "red",
        title: "Always up to date",
        className: "d-flex flex-row",
        description: "Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed."
    }
];
// used in the process-12 block
var processList9 = [
    {
        no: "01",
        className: "",
        color: "purple",
        title: "Collect Ideas",
        subtitle: "Nulla vitae elit libero pharetra augue dapibus. Fusce dapibus, tellus ac cursus commodo."
    },
    {
        no: "02",
        color: "green",
        title: "Data Analysis",
        className: "mt-8 ms-lg-10",
        subtitle: "Vivamus sagittis lacus vel augue laoreet tortor mauris condimentum fermentum."
    },
    {
        no: "03",
        color: "orange",
        className: "mt-8",
        title: "Finalize Product",
        subtitle: "Cras mattis consectetur purus sit amet massa justo sit amet risus consectetur magna elit."
    }
];
// used in the process-13 block
var processList10 = [
    {
        id: 1,
        Icon: Bulb/* default */.Z,
        title: "1. Collect Ideas",
        description: "Etiam porta malesuada magna mollis euismod consectetur leo elit."
    },
    {
        id: 2,
        Icon: Compare/* default */.Z,
        title: "2. Data Analysis",
        description: "Etiam porta malesuada magna mollis euismod consectetur leo elit."
    },
    {
        id: 1,
        Icon: DeliveryBox/* default */.Z,
        title: "3. Finalize Product",
        description: "Etiam porta malesuada magna mollis euismod consectetur leo elit."
    }
];
// used in the process-15 block
var processList11 = [
    {
        id: 1,
        title: "Creative Ideas",
        description: "Nulla vitae elit libero a augue donec id elit non mi porta."
    },
    {
        id: 2,
        title: "Magic Touch",
        description: "Nulla vitae elit libero a augue donec id elit non mi porta."
    },
    {
        id: 3,
        title: "Data Analysis",
        description: "Nulla vitae elit libero a augue donec id elit non mi porta."
    },
    {
        id: 4,
        title: "Finalize Product",
        description: "Nulla vitae elit libero a augue donec id elit non mi porta."
    }
];
// used in the about-25 block
var processList12 = [
    {
        no: "1",
        title: "Concept",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
    },
    {
        no: "2",
        title: "Prepare",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
    },
    {
        no: "3",
        title: "Retouch",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
    },
    {
        no: "4",
        title: "Finalize",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida."
    }
];


/***/ }),

/***/ 9864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lf": function() { return /* binding */ serviceList9; }
});

// UNUSED EXPORTS: serviceList1, serviceList10, serviceList11, serviceList12, serviceList13, serviceList14, serviceList2, serviceList3, serviceList4, serviceList5, serviceList6, serviceList7, serviceList8

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/icons/solid-mono/Edit.tsx

var Edit = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-fuchsia mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M152 0H29.33A29.32 29.32 0 000 29.33v165.33A29.32 29.32 0 0029.33 224h78.72l2.35-13.12a29.71 29.71 0 018.11-15.68l62.83-62.72V29.33A29.33 29.33 0 00152 0zM42.67 42.67h42.67a10.67 10.67 0 110 21.33H42.66a10.67 10.67 0 010-21.33zM96 149.33H42.67a10.67 10.67 0 110-21.33H96a10.67 10.67 0 110 21.33zm42.67-42.66h-96a10.67 10.67 0 010-21.34h96a10.67 10.67 0 110 21.34z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M133.63 256a8 8 0 01-7.89-9.38l5.67-32.06a8 8 0 012.22-4.27l79.2-79.2c9.73-9.75 19.28-7.12 24.51-1.89l13.2 13.2a18.69 18.69 0 010 26.4l-79.2 79.2a7.83 7.83 0 01-4.27 2.22l-32 5.67a10.71 10.71 0 01-1.44.11zm32.05-13.65z"
            })
        ]
    });
};
/* harmony default export */ var solid_mono_Edit = (Edit);

// EXTERNAL MODULE: ./src/icons/solid-mono/Lamp.tsx
var Lamp = __webpack_require__(3521);
;// CONCATENATED MODULE: ./src/icons/lineal/Team.tsx

var Team = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 409.6 356.2",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-purple me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M265.2 180.7H144.4v-17.6c0-33.3 27-60.4 60.4-60.4s60.4 27 60.4 60.4v17.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M265.2 191.7H144.4c-6.1 0-11.1-5-11.1-11.1V163c-.5-39.5 31.1-71.8 70.6-72.3s71.8 31.1 72.3 70.6v19.3c0 6.2-4.9 11.1-11 11.1zm-109.7-22.1h98.6v-6.5c.4-27.2-21.4-49.6-48.6-50s-49.6 21.4-50 48.6v7.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M250.4 56.7c0 25.2-20.4 45.6-45.6 45.6s-45.6-20.4-45.6-45.6 20.4-45.6 45.6-45.6c25.2 0 45.6 20.4 45.6 45.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 113.3c-31.3 0-56.7-25.4-56.7-56.7S173.5-.1 204.8-.1s56.7 25.4 56.7 56.7c-.1 31.3-25.4 56.7-56.7 56.7zm0-91.2c-19.1 0-34.5 15.4-34.5 34.5s15.4 34.5 34.5 34.5 34.5-15.4 34.5-34.5c0-19-15.5-34.4-34.5-34.5zm193.7 334.1H296.8c-6.1 0-11.1-5-11.1-11.1v-14.8c0-34.2 27.8-62 62-62 6.1-.2 11.2 4.6 11.4 10.7s-4.6 11.2-10.7 11.4h-.7c-22 0-39.8 17.8-39.8 39.8v3.8h79.6v-3.7c0-3.2-.4-6.5-1.2-9.6-1.4-6 2.3-11.9 8.3-13.3 5.8-1.4 11.7 2.2 13.2 8 1.2 4.9 1.8 9.9 1.8 14.9v14.8c0 6.1-4.9 11.1-11.1 11.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M347.6 290.5c-27.3 0-49.5-22.2-49.5-49.5s22.2-49.5 49.5-49.5 49.5 22.2 49.5 49.5-22.2 49.5-49.5 49.5zm0-76.9c-15.1 0-27.3 12.3-27.3 27.4 0 15.1 12.3 27.3 27.4 27.3S375 256 375 241c0-15.1-12.3-27.3-27.4-27.4zM112.8 356.2H11.1c-6.1 0-11.1-5-11.1-11.1v-14.8c0-34.2 27.8-62 62-62 6.1.2 10.9 5.3 10.7 11.4-.2 5.9-4.9 10.6-10.7 10.7-22 0-39.8 17.8-39.8 39.8v3.8h79.6v-3.7c0-3.2-.4-6.5-1.2-9.6-1.5-5.9 2.2-11.9 8.1-13.4s11.9 2.2 13.4 8.1c1.2 4.9 1.8 9.9 1.8 14.9v14.8c.1 6.1-4.9 11.1-11.1 11.1.1 0 .1 0 0 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M61.9 290.5c-27.3 0-49.5-22.2-49.5-49.5s22.2-49.5 49.5-49.5 49.5 22.2 49.5 49.5-22.1 49.5-49.5 49.5zm0-76.9c-15.1 0-27.3 12.2-27.3 27.4 0 15.1 12.2 27.4 27.4 27.4 15.1 0 27.3-12.2 27.3-27.3 0-15.2-12.3-27.4-27.4-27.5zm142.9 72.1c-6.1 0-11.1-5-11.1-11.1v-56.4c-.2-6.1 4.6-11.2 10.7-11.4 6.1-.2 11.2 4.6 11.4 10.7v57.1c.1 6.2-4.9 11.1-11 11.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M279.5 285.7H130.1c-6.1.2-11.2-4.6-11.4-10.7s4.6-11.2 10.7-11.4h150.2c6.1-.2 11.2 4.6 11.4 10.7s-4.6 11.2-10.7 11.4h-.8z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Team = (Team);

// EXTERNAL MODULE: ./src/icons/lineal/Check.tsx
var Check = __webpack_require__(9);
;// CONCATENATED MODULE: ./src/icons/lineal/Medal.tsx

var Medal = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 316.5 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-yellow me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M158.2 409.6c-59.4 0-107.5-48.2-107.5-107.5S99 194.6 158.3 194.6s107.5 48.2 107.5 107.5c0 20-5.6 39.6-16.1 56.6-3.4 5.5-10.6 7.1-16 3.7s-7.1-10.6-3.7-16c24.4-39.5 12.2-91.3-27.3-115.8S111.3 218.5 86.8 258s-12.2 91.3 27.3 115.8c22.5 13.9 50.2 16.4 74.8 6.8 6-2.3 12.7.6 15.1 6.6 2.3 6-.6 12.7-6.6 15.1-12.5 4.8-25.8 7.3-39.2 7.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M158.2 206.2c19.9 0 39.4 6.2 55.6 17.8l88.1-152.5c4.6-8 3.7-18-2.2-25l-23-27.1c-4.1-4.9-10.2-7.7-16.6-7.7H56.4c-6.4 0-12.5 2.8-16.6 7.7l-23 27.2c-6 7-6.9 17-2.2 25l88 152.4c16.2-11.6 35.7-17.8 55.6-17.8zm73.4-134l-73.3 127-73.4-127h146.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M213.8 235.6c-2.4 0-4.8-.8-6.8-2.2-29.2-20.8-68.5-20.8-97.7 0-5.2 3.7-12.5 2.5-16.2-2.7l-.6-.9-88-152.5c-7-12.2-5.7-27.5 3.4-38.3l23-27.2C37.2 4.3 46.6 0 56.4 0h203.7c9.8 0 19.2 4.3 25.5 11.8l23 27.1c9.1 10.8 10.5 26.1 3.4 38.3l-88.1 152.5c-1.6 2.8-4.4 4.9-7.6 5.6-.8.2-1.6.3-2.5.3zM56.4 23.3c-3 0-5.8 1.3-7.8 3.6L25.7 54c-2.8 3.3-3.2 7.9-1 11.7l82.1 142c11.2-6.1 23.4-10.2 36-12.1L74.8 78c-3.2-5.6-1.3-12.7 4.3-15.9 1.8-1 3.8-1.6 5.8-1.6h146.7c6.4 0 11.6 5.2 11.6 11.7 0 2-.5 4-1.6 5.8l-67.9 117.7c12.6 1.8 24.8 5.9 36 12.1l82-142c2.1-3.7 1.7-8.4-1-11.6l-23-27.2c-1.9-2.3-4.8-3.6-7.7-3.6l-203.6-.1zm48.7 60.5l53.2 92.1 53.2-92.1H105.1zm45.1 192.9l-4.4 2.7c-1.1.8-2.4 1.2-3.8 1.2-4.4 0-7.4-4.7-7.4-9.4-.1-3.3 1.6-6.3 4.4-8l20-12.1c1.3-.8 2.9-1.1 4.4-1.1 4.8 0 10.4 2.9 10.4 7.4v96.2c0 4.9-5.9 7.3-11.8 7.3s-11.8-2.4-11.8-7.3v-76.9z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Medal = (Medal);

;// CONCATENATED MODULE: ./src/icons/lineal/Earth.tsx

var Earth = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 409.6C91.9 409.6 0 317.7 0 204.8c0-28.1 5.7-55.9 17-81.7C62.1 19.4 182.8-28.1 286.6 17c45.5 19.8 82.3 55.5 103.5 100.4 12.9 27.3 19.6 57.2 19.5 87.4v4.1c-.4 23.5-4.9 46.7-13.3 68.7-2.1 5.5-4.5 11.2-7.2 16.6 0 0 0 .1-.1.1l-.1.3c-7.8 16-17.7 30.8-29.3 44.2-4.1 4.9-11.4 5.5-16.2 1.4-4.9-4.1-5.5-11.4-1.4-16.2.1-.1.1-.2.2-.2 10.4-11.9 19.1-25.2 26-39.4l.2-.3c2.4-4.9 4.5-9.8 6.4-14.7 7.4-19.5 11.4-40.1 11.8-60.9v-3.8c.1-26.8-5.9-53.3-17.3-77.6C335 54.8 257.3 13.3 178.1 25 116.6 34 62.9 75.2 38 132.3c-10 22.9-15.1 47.6-15 72.5 0 100.2 81.5 181.8 181.8 181.8 26.1.1 52-5.6 75.7-16.5 5.8-2.6 12.6.1 15.2 5.9 2.5 5.7 0 12.4-5.6 15-26.7 12.3-55.8 18.7-85.3 18.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M398.1 204.8v3.9c-.4 22.2-4.6 44.1-12.5 64.8-2 5.4-4.3 10.6-6.8 15.7l-.1.3c-19.7-8.2-34.3-25.4-39.3-46.1l-12.2-50.7c-.7-2.8-2.5-5.3-4.9-6.8L311 179c-3.5-2.2-5.5-6.1-5.2-10.2l.8-9.8c.3-3.4 1.9-6.5 4.5-8.7l27.4-23.1c2.6-2.2 5.9-3.3 9.3-3l31.9-2c12.1 25.8 18.4 54 18.4 82.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M378.6 301c-1.5 0-3-.3-4.4-.9-23.1-9.6-40.2-29.7-46.1-54.1L316 195.5l-11-6.8c-7.3-4.4-11.4-12.6-10.6-21.1l.8-9.8c.6-6.4 3.6-12.3 8.6-16.5l27.3-23c4.7-3.9 10.6-6 16.7-5.7l31.2-1.9c4.7-.3 9.1 2.3 11.1 6.6 12.9 27.3 19.6 57.2 19.5 87.4v4.1c-.4 23.5-4.9 46.7-13.3 68.7-2.1 5.5-4.5 11.2-7.2 16.6 0 0 0 .1-.1.1l-.1.3c-2 4.1-6 6.5-10.3 6.5zm-61.4-131.6l10.9 6.7c5.1 3.1 8.7 8.1 10.1 13.9l12.2 50.7c2.3 9.6 7.1 18.3 13.9 25.4 2.7 2.8 5.6 5.3 8.8 7.4.6-1.4 1.1-2.8 1.6-4.1 7.4-19.5 11.4-40.1 11.8-60.9v-3.8c.1-24.2-4.8-48.2-14.2-70.5l-23.9 1.5h-1.8c-.3 0-.6.1-.8.3l-27.4 23.1c-.3.2-.4.5-.4.8l-.8 9.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M197.9 217.9s-22.1 60.7-32 88a19.44 19.44 0 01-18.3 12.8h-.2c-8.3-.1-15.6-5.4-18.2-13.3l-25.4-75.9c-.5-1.4-1.2-2.7-2.2-3.8-1-1.1-2.2-2-3.5-2.7-7.3-3.7-13.3-19-13.3-19l-2.7-22.2c-1.5-12.6-6.9-24.3-15.4-33.7-8.1-9-18.7-15.3-30.4-18.2l-3.4-.8c-2.5-.6-4.1-3.2-3.5-5.8l.3-.9c27.5-58.3 82.2-99.1 145.9-108.8.4-.1.7.1.9.4L191 42.9c.8 1.6 1.2 3.3 1.2 5v2.3c0 3.9-2 7.5-5.4 9.6l-9.2 5.6c-2.5 1.5-4.2 3.9-5 6.6l-11.8 43.2c-1.7 6.3-8.2 10-14.5 8.3-.4-.1-.8-.2-1.2-.4l-6.9-2.6c-5-1.9-12.3-.9-19.4 1-8.7 2.3-14.8 10.3-14.8 19.3 0 8.9 5.8 16.6 14.3 19.2 7.8 2.3 14.6 20.1 36.2 20.1 0 0 38-4.8 43.2 6.9 4.3 9.8 3.8 20.9.2 30.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M147.6 330.1h-.2c-13.2-.1-24.9-8.6-29.1-21.1L93 233.2c-10.4-5.3-17-20.5-18.8-25-.4-.9-.6-1.9-.7-2.8l-2.6-22.2c-1.2-10.2-5.6-19.7-12.5-27.3-6.6-7.3-15.2-12.4-24.7-14.8l-3.4-.8c-8.7-2.2-14-11-11.8-19.7.3-1 .6-2 1.1-3 29-61.8 87-105.1 154.6-115.2.6-.1 1.2-.1 1.8-.1 4.7 0 8.9 2.6 11 6.8l14.4 28.8c1.6 3.2 2.4 6.6 2.4 10.2v2.3c0 7.9-4.1 15.3-10.9 19.4l-9.1 5.6-11.8 42.8c-2.8 10.1-12 17.2-22.5 17.2-2.9 0-5.8-.5-8.5-1.6l-6.8-2.6c-.8-.2-1.5-.3-2.3-.2-3.4.1-6.8.7-10 1.6-3.7 1-6.3 4.3-6.3 8.2 0 1.1.2 2.1.6 3.1.9 2.4 2.9 4.3 5.4 5 5.4 1.6 9.3 5.5 13 9.2 5.2 5.2 10.2 10.2 19.3 10.4 5.7-.6 11.5-1 17.3-1 13.1 0 31.2 1.5 37 14.8 5.2 11.8 5.4 25.8.4 39.4 0 0-22.1 60.7-32 88-4.4 12.3-16 20.4-29 20.4zm-44.2-117.4c5.4 2.7 9.4 7.4 11.3 13.1l25.4 75.9c1.1 3.2 4.1 5.4 7.4 5.4h.1c3.3 0 6.3-2.1 7.5-5.2 9.9-27.2 32-88 32-88 2.7-7.5 2.9-15 .6-21.2-1.4-.6-5.7-2.1-16.4-2.1-5.1 0-10.2.3-15.2.9-.5.1-1 .1-1.4.1-19.1 0-29.8-10.8-36.2-17.2-1.2-1.3-2.5-2.5-3.8-3.6-13.1-4.1-22-16.3-22-30 0-14.2 9.6-26.7 23.3-30.4 5.2-1.5 10.6-2.3 16-2.4 3.6-.1 7.1.5 10.4 1.7l7.1 2.7c.1 0 .1 0 .2-.1.1 0 .1-.1.1-.2L161.5 69c1.5-5.6 5.1-10.4 10.1-13.4l9.1-5.5V48l-10.8-21.6c-54.1 10.5-100.4 45-126 93.8 26.9 8.7 46.3 32.3 49.7 60.3l2.4 20.6c2.2 5 5.6 10.4 7.4 11.6z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Earth = (Earth);

// EXTERNAL MODULE: ./src/icons/lineal/Shield.tsx
var Shield = __webpack_require__(9524);
// EXTERNAL MODULE: ./src/icons/lineal/Target.tsx
var Target = __webpack_require__(9708);
;// CONCATENATED MODULE: ./src/icons/lineal/Search.tsx

var Search = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 512 511.9",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-yellow mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M297.3 429.9c-118.7 0-215-96.2-215-215 0-80.1 44.5-153.5 115.5-190.6 105.1-54.7 235.1-13.8 289.9 91.3 4 8 .8 17.7-7.1 21.7-7.8 3.9-17.3.9-21.5-6.8C412.5 41.2 302 6.4 212.7 52.9c-89.4 46.7-124 156.9-77.4 246.3s156.9 124 246.3 77.4c61.7-32.2 99.8-96.8 98-166.4-.2-8.9 6.9-16.3 15.8-16.4 8.9-.2 16.2 6.8 16.4 15.7 2.9 118.8-91.1 217.5-209.9 220.4-1.4-.1-3 0-4.6 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "lineal-fill",
                cx: "297.1",
                cy: "214.9",
                r: "111.1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M297.1 342.1c-70.3 0-127.2-57-127.2-127.2s57-127.2 127.2-127.2 127.2 57 127.2 127.2c-.1 70.2-57 127.1-127.2 127.2zm0-222.2c-52.5 0-95 42.5-95 95s42.5 95 95 95 95-42.5 95-95c-.1-52.5-42.6-95-95-95zm-240.6 392C25.3 511.9 0 486.6 0 455.4c0-17.6 8.2-34.2 22.2-44.9L88.3 360c6.4-4.9 15.5-4.3 21.2 1.4l41.1 41.1c5.7 5.7 6.3 14.8 1.4 21.2l-50.5 66.1c-9.9 12.9-24.9 21-41.2 22.1h-3.8zm40.1-117.7l-54.9 41.9c-10.7 8.1-12.9 23.3-4.8 34s23.3 12.9 34 4.8c1.8-1.4 3.4-3 4.8-4.8l42-54.9-21.1-21z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Search = (Search);

// EXTERNAL MODULE: ./src/icons/lineal/ChatTwo.tsx
var ChatTwo = __webpack_require__(2875);
;// CONCATENATED MODULE: ./src/icons/solid-duo/Script.tsx

var Script = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256.02 213.34",
        className: "svg-inject icon-svg solid-duo ".concat(className || "icon-svg-sm text-grape-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M162.66 106.34a8 8 0 01-6.06-13.2l11.54-13.47-11.54-13.45a8 8 0 1112.14-10.42l16 18.67a8 8 0 010 10.42l-16 18.67a8 8 0 01-6.08 2.78zm-69.31 0a8 8 0 01-6.08-2.78l-16-18.67a8 8 0 010-10.42l16-18.67a8 8 0 0112.15 10.42L87.88 79.67l11.54 13.46a8 8 0 01-6.07 13.21zm24.87 15.8a8 8 0 01-6-9.6l16-69.33a8 8 0 1115.6 3.6l-16 69.33a8 8 0 01-9.6 6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M237.33 0H18.67A18.76 18.76 0 000 18.67v144a18.76 18.76 0 0018.67 18.67h81.68c-1.25 5.35-4.57 14-13.45 22.9a5.33 5.33 0 003.77 9.1h74.67a5.33 5.33 0 003.78-9.1c-8.86-8.86-12.27-17.54-13.6-22.9h81.82A18.77 18.77 0 00256 162.67v-144A18.79 18.79 0 00237.33 0zm-2.66 138.67H21.33V21.34h213.33v117.33z"
            })
        ]
    });
};
/* harmony default export */ var solid_duo_Script = (Script);

;// CONCATENATED MODULE: ./src/icons/solid-mono/Verify.tsx

var Verify = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 256 256",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-navy me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M186.67 117.33A69.34 69.34 0 10256 186.68a69.43 69.43 0 00-69.33-69.35zm37.34 55L186.68 215a10.65 10.65 0 01-7.68 3.63h-.35a10.67 10.67 0 01-7.53-3.12l-21.33-21.33a10.67 10.67 0 0115.09-15.09l13.26 13.27L208 158.3a10.67 10.67 0 1116 14.07z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M177.92 32.32L92.58.32a5.88 5.88 0 00-3.84 0l-85.35 32a5.36 5.36 0 00-3.39 5v68.59c0 97.28 88.64 117.76 89.5 118a6.28 6.28 0 002.34 0 73.48 73.48 0 0010.77-3.41A89.34 89.34 0 0196 186.68a90.78 90.78 0 0185.34-90.56V37.35a5.38 5.38 0 00-3.42-5z"
            })
        ]
    });
};
/* harmony default export */ var solid_mono_Verify = (Verify);

;// CONCATENATED MODULE: ./src/icons/solid-duo/Server.tsx

var Server = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-duo ".concat(className || "icon-svg-sm text-grape-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M250.58 126.14l-56-19a8 8 0 00-5.16 0l-56 19a8 8 0 00-5.42 7.57v42.87c0 52.32 58.38 77.72 60.88 78.8a8.19 8.19 0 003.12.62 7.85 7.85 0 003.12-.64c2.5-1.06 60.88-26.48 60.88-78.78v-42.87a8 8 0 00-5.42-7.57zm-23.52 40.45l-29.33 37.33a10.66 10.66 0 01-15.33 1.5l-18.67-16a10.66 10.66 0 0113.87-16.19l10.22 8.77 22.47-28.57a10.66 10.66 0 0116.77 13.18z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M202.67 0H32a32 32 0 000 64h170.67a32 32 0 000-64zM32 42.67A10.67 10.67 0 1142.67 32 10.67 10.67 0 0132 42.67zm42.67 0A10.67 10.67 0 1185.34 32a10.67 10.67 0 01-10.67 10.67zM32 85.33a32 32 0 000 64h74.67v-15.57a29.38 29.38 0 0120-27.84l55.89-19a29 29 0 019.49-1.6zM32 128a10.67 10.67 0 1110.67-10.67A10.7 10.7 0 0132 128zm42.67 0a10.67 10.67 0 1110.67-10.67A10.7 10.7 0 0174.67 128zm32 48.53v-5.87H32a32 32 0 000 64h95.68c-12.27-15.57-21.01-35.09-21.01-58.13zM32 213.33a10.67 10.67 0 1110.67-10.66A10.7 10.7 0 0132 213.33zm42.67 0a10.67 10.67 0 1110.67-10.66 10.7 10.7 0 01-10.67 10.66z"
            })
        ]
    });
};
/* harmony default export */ var solid_duo_Server = (Server);

;// CONCATENATED MODULE: ./src/icons/solid-duo/Setting.tsx

var Setting = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 213.34",
        className: "svg-inject icon-svg solid-duo ".concat(className || "icon-svg-sm text-grape-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M177.81 73.28c.11-1.28.21-2.56.21-4s-.12-2.67-.21-4l8.85-6.52a13.19 13.19 0 003.63-17.07l-7.89-13.98a12.76 12.76 0 00-16.64-5.44L156 26.86a51.33 51.33 0 00-6.08-3.63l-1.12-11.39A13 13 0 00135.89 0H120.1a13 13 0 00-12.92 11.84l-1.07 11.41a51.33 51.33 0 00-6.11 3.63l-9.81-4.59a12.86 12.86 0 00-16.64 5.44L65.7 41.81a13.12 13.12 0 003.63 17.07l8.85 6.51c-.12 1.28-.21 2.56-.21 4s.11 2.68.21 4l-8.85 6.51a13.12 13.12 0 00-3.62 17l7.89 14.08a12.84 12.84 0 0016.64 5.44l9.81-4.59a51.33 51.33 0 006.08 3.63l1.07 11.41a13 13 0 0012.91 11.84h15.79a13 13 0 0012.92-11.84l1.07-11.41a51.33 51.33 0 006.08-3.63l9.81 4.59a12.76 12.76 0 0016.64-5.44l7.88-14.08a13.12 13.12 0 00-3.63-17.07zm-23.14-3.94A26.67 26.67 0 11128 42.67a26.69 26.69 0 0126.67 26.67z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M224 149.34H32a32 32 0 000 64h192a32 32 0 000-64zM42.67 192a10.67 10.67 0 1110.67-10.66A10.67 10.67 0 0142.67 192zM96 192a10.67 10.67 0 1110.67-10.66A10.67 10.67 0 0196 192zm64 0a10.67 10.67 0 1110.67-10.66A10.67 10.67 0 01160 192zm53.33 0A10.67 10.67 0 11224 181.34 10.67 10.67 0 01213.33 192z"
            })
        ]
    });
};
/* harmony default export */ var solid_duo_Setting = (Setting);

;// CONCATENATED MODULE: ./src/icons/solid-mono/TeamTwo.tsx

var TeamTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 255.98 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-violet mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "128",
                cy: "26.67",
                r: "26.67"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "202.67",
                cy: "176",
                r: "26.67"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "53.33",
                cy: "176",
                r: "26.67"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M173.33 106.67H82.66a8 8 0 01-8-8v-5.33A29.35 29.35 0 01104 64h48a29.35 29.35 0 0129.33 29.32v5.33a8 8 0 01-8 8.02zM248 256h-90.67a8 8 0 01-8-8v-5.33a29.36 29.36 0 0129.33-29.33h48A29.36 29.36 0 01256 242.67V248a8 8 0 01-8 8zm-149.33 0H8a8 8 0 01-8-8v-5.33a29.36 29.36 0 0129.33-29.33h48a29.37 29.37 0 0129.33 29.33V248a8 8 0 01-8 8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M29.33 136.13a8 8 0 01-8-8 107.1 107.1 0 0161.73-96.77 8 8 0 116.73 14.51 91 91 0 00-52.48 82.26 8 8 0 01-7.98 8zm197.34 0a8 8 0 01-8-8 91 91 0 00-52.48-82.26 8 8 0 116.74-14.51 107.09 107.09 0 0161.73 96.77 8 8 0 01-8 8zM128 234.8a105.08 105.08 0 01-11.15-.58 8 8 0 011.66-15.9 93.73 93.73 0 0019.6-.06 8 8 0 011.76 15.9 110.68 110.68 0 01-11.87.64z"
            })
        ]
    });
};
/* harmony default export */ var solid_mono_TeamTwo = (TeamTwo);

;// CONCATENATED MODULE: ./src/icons/lineal/ShopTwo.tsx

var ShopTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 466.4",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-green me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M201.4 172.5h-96l26.1-158.4h83zm205.2 0h-96L297.5 14.1h83zm-216.7 97.1c7.2-7 16.8-10.9 26.9-10.8 9.6 0 18.8 3.1 26.9 5.8 4 1.4 8.1 2.6 12.3 3.5 4.2-.9 8.3-2.1 12.3-3.5 8.1-2.7 17.3-5.8 26.9-5.8 10-.1 19.7 3.7 26.9 10.8 24.4 22.9 15.9 48.4 10.9 63.7l-.3.8c-4.6 14-22 59.8-51.4 59.8-15.6 0-20.9-2.5-24.8-4.4l-.6-.3-.6.3c-3.9 1.9-9.1 4.4-24.8 4.4-29.3 0-46.7-45.8-51.4-59.8l-.3-.8c-4.8-15.3-13.3-40.8 11.1-63.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M511.1 147.4l-6.4-25.9c-1.9-7.6-9.6-12.1-17.2-10.2-7.5 1.9-12.1 9.5-10.3 17l6.4 25.9c.4 1.8-.7 3.6-2.5 4.1-.3.1-.5.1-.8.1h-61.7l-14.2-86-7.3-44.1h52.6c1.5 0 2.9 1 3.2 2.5l6.6 26.8c1.9 7.6 9.6 12.1 17.2 10.2 7.5-1.9 12.1-9.5 10.3-17L480.5 24C477 9.9 464.3 0 449.8 0H62.2C47.7 0 35 9.9 31.5 24L.9 147.4c-4.2 17 6.1 34.1 23.1 38.3 2.5.6 5.1.9 7.6.9h8.1v265.6c0 7.8 6.3 14.1 14.2 14.1h404.2c7.8 0 14.1-6.3 14.1-14.1V257.8c0-7.8-6.3-14.2-14.1-14.2s-14.2 6.3-14.2 14.1V438H68V186.7h412.4c17.5 0 31.6-14.2 31.6-31.6 0-2.6-.3-5.2-.9-7.7zM227.5 28.3h56.9l10.8 130.1h-78.4l10.7-130.1zM29 157.1c-.7-.8-.9-1.9-.6-2.9L59 30.8c.4-1.5 1.7-2.5 3.2-2.5h52.6l-5.3 32.1-16.2 98H31.6c-1 0-2-.5-2.6-1.3zm98.3-30.8l16.2-98h55.6l-10.7 130.1H122l5.3-32.1zm196.3 32.1L315.2 57l-2.4-28.7h55.6l16.2 98 5.3 32.1h-66.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M256 220c-7.8 0-14.1 6.3-14.1 14.1v15c-7.4-2.3-15.9-4.4-25-4.4-13.6-.1-26.8 5.1-36.6 14.6-31 29.1-19.9 62.4-14.6 78.4l.3.8c6.9 20.9 27 69.5 64.8 69.5 12.6 0 19.9-1.5 25.3-3.4 5.4 2 12.8 3.4 25.3 3.4 37.8 0 57.9-48.6 64.8-69.5l.3-.8c5.3-16 16.3-49.3-14.6-78.4-9.8-9.5-22.9-14.7-36.6-14.6-9.1 0-17.6 2.1-25 4.4v-15c-.1-7.8-6.4-14.1-14.3-14.1zm39.2 53c6.4-.1 12.7 2.4 17.2 6.9 16.5 15.5 13 31.3 7.1 48.9l-.3.8c-8.2 24.9-23.2 50.1-37.9 50.1-12.4 0-15.8-1.7-18.6-3l-.7-.3c-3.9-1.8-8.3-1.8-12.2 0l-.6.3c-2.8 1.3-6.2 3-18.6 3-14.8 0-29.7-25.1-37.9-50l-.3-.8c-5.8-17.6-9.3-33.4 7.1-48.9 4.5-4.6 10.8-7.1 17.2-6.9 7.3 0 15 2.6 22.5 5 4.6 1.7 9.4 3 14.2 4 1.7.3 3.3.3 5 0 4.8-1 9.6-2.3 14.2-4 7.6-2.6 15.3-5.1 22.6-5.1z"
            })
        ]
    });
};
/* harmony default export */ var lineal_ShopTwo = (ShopTwo);

// EXTERNAL MODULE: ./src/icons/lineal/Browser.tsx
var Browser = __webpack_require__(4630);
;// CONCATENATED MODULE: ./src/icons/solid-duo/Director.tsx

var Director = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-duo ".concat(className || "icon-svg-sm text-grape-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M163.78 19.12A42.63 42.63 0 00128 0c-18.54 0-34.77 11.81-40.14 28.34C74.26 31 64 42.66 64 56.53c0 15.89 13.42 28.8 29.92 28.8h63.3c19.18 0 34.78-15 34.78-33.43 0-16.22-12.08-29.87-28.22-32.78z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M224 168a8 8 0 01-8-8v-16H40v16a8 8 0 01-16 0v-24a8 8 0 018-8h192a8 8 0 018 8v24a8 8 0 01-8 8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M128 170.67a8 8 0 01-8-8v-48a8 8 0 0116 0v48a8 8 0 01-8 8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "32",
                cy: "197.33",
                r: "16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M40 224H24a24 24 0 00-24 24 8 8 0 008 8h48a8 8 0 008-8 24 24 0 00-24-24z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "128",
                cy: "197.33",
                r: "16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M136 224h-16a24 24 0 00-24 24 8 8 0 008 8h48a8 8 0 008-8 24 24 0 00-24-24z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "fill-primary",
                cx: "224",
                cy: "197.33",
                r: "16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M232 224h-16a24 24 0 00-24 24 8 8 0 008 8h48a8 8 0 008-8 24 24 0 00-24-24z"
            })
        ]
    });
};
/* harmony default export */ var solid_duo_Director = (Director);

;// CONCATENATED MODULE: ./src/icons/lineal/Settings.tsx

var Settings = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "lineal-fill",
                cx: "256",
                cy: "256",
                r: "112.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M256 382.6c-69.9 0-126.6-56.7-126.6-126.6S186.1 129.4 256 129.4 382.6 186.1 382.6 256c-.1 69.9-56.7 126.5-126.6 126.6zm0-225.1c-54.4 0-98.5 44.1-98.5 98.5s44.1 98.5 98.5 98.5 98.5-44.1 98.5-98.5c-.1-54.4-44.1-98.4-98.5-98.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M279.4 512h-46.8c-16.2 0-29.4-13.2-29.4-29.4v-19.2c-19.9-5-38.9-12.9-56.5-23.4l-13.6 13.6c-5.5 5.5-14.4 5.5-19.9 0s-5.5-14.4 0-19.9l21.6-21.5c4.8-4.8 12.2-5.5 17.8-1.7 20.4 13.7 43.3 23.2 67.5 27.9 6.6 1.3 11.4 7.1 11.4 13.8v30.5c0 .7.6 1.3 1.3 1.3h46.8c.7 0 1.3-.6 1.3-1.3v-30.5c0-6.7 4.8-12.5 11.4-13.8 24.1-4.7 47.1-14.2 67.5-28 5.6-3.7 13-3 17.8 1.7l21.5 21.5c.5.5 1.3.5 1.8 0l33.1-33.1c.5-.5.5-1.3 0-1.8l-21.5-21.5c-4.8-4.8-5.5-12.2-1.7-17.8 13.8-20.4 23.3-43.3 28-67.5 1.3-6.6 7.1-11.4 13.8-11.4h30.5c.7 0 1.3-.6 1.3-1.3v-46.8c0-.7-.6-1.3-1.3-1.3h-30.5c-6.7 0-12.5-4.8-13.8-11.4-4.7-24.1-14.3-47.1-28-67.5-3.7-5.6-3-13 1.7-17.8l21.5-21.6c5.6-5.4 14.5-5.2 19.9.3 5.3 5.5 5.3 14.1 0 19.6l-13.9 14c10.5 17.6 18.4 36.7 23.4 56.6h19.2c16.2 0 29.3 13.2 29.4 29.4v46.8c0 16.2-13.2 29.4-29.4 29.4h-19.2c-5 19.9-12.9 38.9-23.4 56.5l13.6 13.6c11.5 11.5 11.5 30.1 0 41.6l-33.1 33.1c-11.5 11.5-30.1 11.5-41.6 0L365.3 440a211.57 211.57 0 01-56.5 23.4v19.2c-.1 16.3-13.2 29.4-29.4 29.4zm-211-109.1c-7.8 0-14.1-6.3-14-14.1 0-3.7 1.5-7.3 4.1-9.9L72 365.3a211.57 211.57 0 01-23.4-56.5H29.4C13.2 308.8 0 295.6 0 279.4v-46.8c0-16.2 13.2-29.4 29.4-29.4h19.2c5-19.9 12.9-38.9 23.4-56.5l-13.6-13.6C47 121.6 47 103 58.4 91.5l33.1-33.1c11.5-11.5 30.1-11.5 41.6 0L146.7 72c17.6-10.5 36.7-18.4 56.5-23.4V29.4c0-16.2 13.2-29.4 29.4-29.4h46.8c16.2 0 29.4 13.2 29.4 29.4v19.2c19.9 5 38.9 12.9 56.5 23.4l13.6-13.6c5.5-5.5 14.4-5.5 19.9 0s5.5 14.4 0 19.9l-21.5 21.6c-4.8 4.8-12.2 5.5-17.8 1.7-20.4-13.7-43.3-23.2-67.5-28-6.6-1.3-11.4-7.1-11.4-13.8V29.4c0-.7-.6-1.3-1.3-1.3h-46.8c-.7 0-1.3.6-1.3 1.3v30.5c0 6.7-4.8 12.5-11.4 13.8-24.1 4.7-47.1 14.2-67.5 28-5.6 3.8-13 3-17.8-1.7L113 78.4c-.5-.5-1.3-.5-1.8 0l-33.1 33.1c-.5.5-.5 1.3 0 1.8l21.6 21.6c4.8 4.8 5.5 12.2 1.7 17.8-13.8 20.4-23.3 43.3-28 67.5-1.3 6.6-7.1 11.4-13.8 11.4H29.4c-.7 0-1.3.6-1.3 1.3v46.8c0 .7.6 1.3 1.3 1.3h30.5c6.7 0 12.5 4.8 13.8 11.4 4.7 24.1 14.2 47.1 28 67.5 3.7 5.6 3 13-1.7 17.8l-21.6 21.5c-2.7 2.3-6.3 3.7-10 3.7z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Settings = (Settings);

// EXTERNAL MODULE: ./src/icons/lineal/Telephone.tsx
var Telephone = __webpack_require__(8290);
;// CONCATENATED MODULE: ./src/icons/lineal/SearchTwo.tsx

var SearchTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 511.9",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-pink mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M297.3 429.9c-118.7 0-215-96.2-215-215 0-80.1 44.5-153.5 115.5-190.6 105.1-54.7 235.1-13.8 289.9 91.3 4 8 .8 17.7-7.1 21.7-7.8 3.9-17.3.9-21.5-6.8C412.5 41.2 302 6.4 212.7 52.9c-89.4 46.7-124 156.9-77.4 246.3s156.9 124 246.3 77.4c61.7-32.2 99.8-96.8 98-166.4-.2-8.9 6.9-16.3 15.8-16.4 8.9-.2 16.2 6.8 16.4 15.7 2.9 118.8-91.1 217.5-209.9 220.4-1.4-.1-3 0-4.6 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "lineal-fill",
                cx: "297.1",
                cy: "214.9",
                r: "111.1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M297.1 342.1c-70.3 0-127.2-57-127.2-127.2s57-127.2 127.2-127.2 127.2 57 127.2 127.2c-.1 70.2-57 127.1-127.2 127.2zm0-222.2c-52.5 0-95 42.5-95 95s42.5 95 95 95 95-42.5 95-95c-.1-52.5-42.6-95-95-95zm-240.6 392C25.3 511.9 0 486.6 0 455.4c0-17.6 8.2-34.2 22.2-44.9L88.3 360c6.4-4.9 15.5-4.3 21.2 1.4l41.1 41.1c5.7 5.7 6.3 14.8 1.4 21.2l-50.5 66.1c-9.9 12.9-24.9 21-41.2 22.1h-3.8zm40.1-117.7l-54.9 41.9c-10.7 8.1-12.9 23.3-4.8 34s23.3 12.9 34 4.8c1.8-1.4 3.4-3 4.8-4.8l42-54.9-21.1-21z"
            })
        ]
    });
};
/* harmony default export */ var lineal_SearchTwo = (SearchTwo);

// EXTERNAL MODULE: ./src/icons/lineal/Analytics.tsx
var Analytics = __webpack_require__(3293);
// EXTERNAL MODULE: ./src/icons/lineal/Megaphone.tsx
var Megaphone = __webpack_require__(58);
;// CONCATENATED MODULE: ./src/icons/lineal/ClockThree.tsx

var ClockThree = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 391.2",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-red me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M148.9 61.3C136 24.4 95.7 4.9 58.8 17.8S2.4 71.1 15.3 108c6.5 18.5 20.3 33.5 38.3 41.4 15.9-42.8 51.3-75.5 95.3-88.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M53.5 160.7c-1.6 0-3.1-.4-4.6-1C7.5 141.4-11.3 93 7 51.5s66.8-60.3 108.2-42c20.8 9.2 36.9 26.6 44.4 48.1 2.1 5.9-1 12.3-6.9 14.4-.2.1-.4.1-.6.2-40.5 11.6-73.1 41.7-87.9 81.1-1.8 4.5-6 7.4-10.7 7.4zM82.1 25.2c-32.8 0-59.5 26.6-59.5 59.5 0 19.4 9.5 37.7 25.4 48.8C65.2 97.2 95.8 69 133.4 54.7c-10.7-18.3-30.2-29.5-51.3-29.5z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M327.5 13.9c-30.1 0-56.9 19-66.8 47.5 44 12.6 79.4 45.2 95.4 88.1 35.8-15.8 52-57.6 36.2-93.3-11.3-25.8-36.7-42.3-64.8-42.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M356.1 160.7c-4.7 0-8.9-2.9-10.6-7.4-14.8-39.5-47.4-69.6-87.9-81.2-6-1.7-9.5-8-7.8-14 .1-.2.1-.4.2-.6C264.9 14.7 311.7-7.9 354.5 7S420 68.8 405 111.7c-7.5 21.5-23.6 38.9-44.4 48.1-1.4.6-2.9.9-4.5.9zM276.2 54.6c37.6 14.3 68.1 42.5 85.4 78.8 26.9-18.8 33.5-55.9 14.7-82.8s-55.9-33.5-82.8-14.7c-7.1 4.9-13 11.3-17.3 18.7zm-79.4 176c-3.1 0-6.1-.7-8.8-2.1l-45.1-22.6c-5.6-2.8-7.8-9.6-5-15.2s9.6-7.8 15.2-5l43.3 21.6 57.4-57.4c4.4-4.4 11.6-4.4 16 0s4.4 11.6 0 16l-58.9 58.9c-3.8 3.7-8.8 5.8-14.1 5.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 391.2c-96.8 0-175.6-78.8-175.6-175.6S108 39.9 204.8 39.9c69.8 0 133 41.3 161 105.2 2.5 5.7-.1 12.4-5.9 14.9s-12.4-.1-14.9-5.9c-24.4-55.7-79.4-91.7-140.2-91.7-84.4 0-153 68.6-153 153s68.6 153 153 153 153-68.6 153-153c-.2-6.2 4.7-11.5 11-11.6 6.2-.2 11.5 4.7 11.6 11v.7c0 96.9-78.8 175.7-175.6 175.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M287.1 281.5c-1.9 0-3.7-.5-5.4-1.4l-102.4-55.7c-5.5-3-7.5-9.8-4.5-15.3s9.8-7.5 15.3-4.5l102.5 55.7c5.5 3 7.5 9.8 4.5 15.3-2 3.6-5.8 5.9-10 5.9zm-82.3-178.4c-6.2 0-11.3-5-11.3-11.3V51.2c0-6.2 5.1-11.3 11.3-11.3s11.3 5.1 11.3 11.3v40.5c0 6.3-5 11.3-11.3 11.4zm0 288.1c-6.2 0-11.3-5.1-11.3-11.3v-40.5c0-6.2 5.1-11.3 11.3-11.3s11.3 5.1 11.3 11.3v40.5c0 6.2-5 11.3-11.3 11.3zm164.3-164.3h-40.5c-6.2.2-11.5-4.7-11.6-11-.2-6.2 4.7-11.5 11-11.6h41.2c6.2.2 11.2 5.4 11 11.6-.3 6-5.1 10.8-11.1 11zm-288.1 0H40.5c-6.2-.2-11.2-5.4-11-11.6.2-6 5-10.8 11-11H81c6.2.2 11.2 5.4 11 11.6-.2 6-5 10.8-11 11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M241.2 62.5c-6.2 0-11.3-5.1-11.3-11.3V27.9c0-2.9-2.4-5.3-5.3-5.3H185c-2.9 0-5.3 2.4-5.3 5.3v23.4c0 6.2-5.1 11.3-11.3 11.3s-11.3-5.1-11.3-11.3V27.9C157.1 12.5 169.6 0 185 0h39.6c15.4 0 27.9 12.5 27.9 27.9v23.4c-.1 6.2-5.1 11.2-11.3 11.2z"
            })
        ]
    });
};
/* harmony default export */ var lineal_ClockThree = (ClockThree);

// EXTERNAL MODULE: ./src/icons/solid-mono/DeliveryBox.tsx
var DeliveryBox = __webpack_require__(9585);
;// CONCATENATED MODULE: ./src/icons/solid-duo/CloudNetwork.tsx

var CloudNetwork = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256.03 256.02",
        className: "svg-inject icon-svg solid-duo ".concat(className || "icon-svg-sm text-grape-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-primary",
                d: "M193.17 36.14C180.21 14.05 155.12 0 128 0 93.52 0 63.55 22.64 55.62 53.65c-25.27 2.75-44.95 23.09-44.95 47.68 0 26.46 22.79 48 50.79 48h123.6c33.24 0 60.28-25.52 60.28-56.9 0-28.67-22.57-52.62-52.17-56.29z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "fill-secondary",
                d: "M245.34 208h-74.67v-8A18.69 18.69 0 00152 181.33h-13.33V144a10.67 10.67 0 10-21.34 0v37.33H104A18.69 18.69 0 0085.33 200v8H10.66a10.67 10.67 0 000 21.34h74.68v8A18.7 18.7 0 00104 256h48a18.7 18.7 0 0018.67-18.68v-8h74.67a10.67 10.67 0 100-21.34z"
            })
        ]
    });
};
/* harmony default export */ var solid_duo_CloudNetwork = (CloudNetwork);

// EXTERNAL MODULE: ./src/icons/lineal/SmartphoneTwo.tsx
var SmartphoneTwo = __webpack_require__(9711);
// EXTERNAL MODULE: ./src/icons/lineal/SettingsThree.tsx
var SettingsThree = __webpack_require__(1856);
// EXTERNAL MODULE: ./src/icons/lineal/CloudComputing.tsx
var CloudComputing = __webpack_require__(1777);
// EXTERNAL MODULE: ./src/types/demo-1.ts
var demo_1 = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/utils/color.ts
var color = __webpack_require__(516);
;// CONCATENATED MODULE: ./src/data/service.ts































// used in the services-1 block
var serviceList1 = [
    {
        id: 1,
        link: "#",
        icon: lineal_Search,
        title: "SEO Services",
        linkText: "Learn More",
        linkType: demo_1/* LinkType.yellow */.U.yellow,
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 2,
        link: "#",
        icon: Browser/* default */.Z,
        title: "Web Design",
        linkText: "Learn More",
        linkType: demo_1/* LinkType.red */.U.red,
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 3,
        link: "#",
        icon: ChatTwo/* default */.Z,
        linkType: demo_1/* LinkType.green */.U.green,
        title: "Social Engagement",
        linkText: "Learn More",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 4,
        link: "#",
        icon: Megaphone/* default */.Z,
        linkType: demo_1/* LinkType.blue */.U.blue,
        title: "Content Marketing",
        linkText: "Learn More",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    }
];
// used in the services-3, services-8, services-13 block
var serviceList2 = [
    {
        id: 1,
        linkUrl: "#",
        title: "24/7 Support",
        icon: "uil-phone-volume",
        description: "Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla."
    },
    {
        id: 2,
        linkUrl: "#",
        title: "Secure Payments",
        icon: "uil-shield-exclamation",
        description: "Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla."
    },
    {
        id: 3,
        linkUrl: "#",
        title: "Daily Updates",
        icon: "uil-laptop-cloud",
        description: "Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla."
    },
    {
        id: 4,
        linkUrl: "#",
        title: "Market Research",
        icon: "uil-chart-line",
        description: "Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla."
    }
];
// used in the services-4 block
var serviceList3 = [
    {
        id: 1,
        linkUrl: "#",
        title: "24/7 Support",
        icon: "uil-phone-volume",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo."
    },
    {
        id: 2,
        linkUrl: "#",
        title: "Secure Payments",
        icon: "uil-shield-exclamation",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo."
    },
    {
        id: 3,
        linkUrl: "#",
        title: "Daily Updates",
        icon: "uil-laptop-cloud",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo."
    },
    {
        id: 4,
        linkUrl: "#",
        title: "Market Research",
        icon: "uil-chart-line",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo."
    }
];
// used in the services-5 block
var serviceList4 = [
    {
        id: 1,
        Icon: Telephone/* default */.Z,
        title: "24/7 Support",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 2,
        Icon: Shield/* default */.Z,
        title: "Secure Payments",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 3,
        Icon: CloudComputing/* default */.Z,
        title: "Daily Updates",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 4,
        Icon: Analytics/* default */.Z,
        title: "Market Research",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 5,
        Icon: lineal_Settings,
        title: "System Integration",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 6,
        Icon: lineal_Earth,
        title: "SEO Services",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    }
];
// used in the services-6 block
var serviceList5 = (/* unused pure expression or super */ null && ([
    [
        "Aenean quam ornare curabitur blandit consectetur.",
        "Nullam quis risus eget urna mollis ornare aenean leo."
    ],
    [
        "Etiam porta euismod malesuada mollis nisl ornare.",
        "Vivamus sagittis lacus augue rutrum maecenas odio."
    ]
]));
// used in the services-7 block
var serviceList6 = [
    {
        id: 1,
        Icon: Target/* default */.Z,
        color: color/* default.aqua */.Z.aqua,
        title: "Fitness Goal",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 2,
        Icon: lineal_Medal,
        color: color/* default.yellow */.Z.yellow,
        title: "Activity Tracking",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 3,
        Icon: lineal_ClockThree,
        color: color/* default.red */.Z.red,
        title: "Sleep Analysis",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 4,
        Icon: Check/* default */.Z,
        color: color/* default.pink */.Z.pink,
        title: "Workout Report",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 5,
        Icon: lineal_ShopTwo,
        color: color/* default.green */.Z.green,
        title: "Nutritional Analysis",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 6,
        Icon: lineal_Team,
        color: color/* default.purple */.Z.purple,
        title: "Activity Sharing",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    }
];
// used in the services-9 block
var serviceList7 = [
    {
        id: 1,
        Icon: Telephone/* default */.Z,
        color: color/* default.yellow */.Z.yellow,
        title: "24/7 Support",
        cardColor: "bg-pale-yellow",
        columnClass: "col-md-5 offset-md-1 align-self-end",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta."
    },
    {
        id: 2,
        Icon: Shield/* default */.Z,
        color: color/* default.red */.Z.red,
        title: "Secure Payments",
        cardColor: "bg-pale-red",
        columnClass: "col-md-6 align-self-end",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta."
    },
    {
        id: 3,
        color: color/* default.leaf */.Z.leaf,
        Icon: CloudComputing/* default */.Z,
        title: "Daily Updates",
        cardColor: "bg-pale-leaf",
        columnClass: "col-md-5",
        description: "Nulla vitae elit libero, a pharetra augue."
    },
    {
        id: 4,
        Icon: Analytics/* default */.Z,
        color: color/* default.primary */.Z.primary,
        title: "Market Research",
        cardColor: "bg-pale-primary",
        columnClass: "col-md-6 align-self-start",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget."
    }
];
// used in the services-18 block
var serviceList8 = [
    {
        id: 1,
        Icon: Browser/* default */.Z,
        title: "Web Design",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo cum sociis natoque magnis."
    },
    {
        id: 2,
        Icon: SmartphoneTwo/* default */.Z,
        title: "Mobile Design",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo cum sociis natoque magnis."
    },
    {
        id: 3,
        Icon: SettingsThree/* default */.Z,
        title: "Development",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo cum sociis natoque magnis."
    },
    {
        id: 4,
        title: "SEO",
        Icon: lineal_SearchTwo,
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus. Cras justo cum sociis natoque magnis."
    }
];
// used in the services-19 block
var serviceList9 = [
    {
        id: 0,
        linkUrl: "#",
        color: color/* default.purple */.Z.purple,
        title: "Results Driven SEO",
        icon: "uil-phone-volume",
        description: "Browse our sites taking number 1 on Google for competitive keywords with traffic growing each month."
    },
    {
        id: 1,
        linkUrl: "#",
        color: color/* default.green */.Z.green,
        title: "Unique Skills",
        icon: "uil-shield-exclamation",
        description: "Our marketing, creative and technical skills help us maximise results, so you get the best ROI."
    },
    {
        id: 2,
        linkUrl: "#",
        color: color/* default.aqua */.Z.aqua,
        title: "Proven SEO Process",
        icon: "uil-laptop-cloud",
        description: "Our results driven process gets world class SEO results. Our transparent process lets you know what we will be addressing and proof is provided on completion."
    },
    {
        id: 3,
        linkUrl: "#",
        color: color/* default.orange */.Z.orange,
        icon: "uil-laptop-cloud",
        title: "White Hat SEO",
        description: "We comply with Google best practices to avoid penalties and maximise SEO efforts."
    },
    {
        id: 4,
        linkUrl: "#",
        color: color/* default.fuchsia */.Z.fuchsia,
        icon: "uil-laptop-cloud",
        title: "Regular Reporting",
        description: "Tailored reports each month."
    },
    {
        id: 5,
        linkUrl: "#",
        color: color/* default.yellow */.Z.yellow,
        icon: "uil-laptop-cloud",
        title: "Members Dashboard",
        description: "Our members dashboard puts all your data in one place so you can see your campaign progress and SEO results."
    }
];
// used in the services-20 block
var serviceList10 = [
    {
        id: 0,
        linkUrl: "#",
        Icon: solid_duo_Script,
        title: "Software & Integration",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 1,
        linkUrl: "#",
        Icon: solid_mono_Verify,
        title: "Network Security",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 2,
        linkUrl: "#",
        Icon: solid_duo_CloudNetwork,
        title: "Cloud Services",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 3,
        linkUrl: "#",
        Icon: solid_duo_Director,
        title: "Wireless Networking",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 4,
        linkUrl: "#",
        Icon: solid_duo_Setting,
        title: "IT Solutions",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    },
    {
        id: 5,
        linkUrl: "#",
        Icon: solid_duo_Server,
        title: "Server Configuration",
        description: "Duis mollis gravida commodo id luctus erat porttitor ligula, eget lacinia odio sem aget elit nullam quis risus eget."
    }
];
// used in the services-21 block
var serviceList11 = [
    {
        id: 1,
        link: "#",
        Icon: solid_mono_Edit,
        title: "Content Marketing",
        linkType: demo_1/* LinkType.fuchsia */.U.fuchsia,
        iconClassName: "icon-svg-sm solid-mono text-fuchsia mb-3",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 2,
        link: "#",
        Icon: solid_mono_TeamTwo,
        title: "Social Engagement",
        linkType: demo_1/* LinkType.violet */.U.violet,
        iconClassName: "icon-svg-sm solid-mono text-violet mb-3",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 3,
        link: "#",
        Icon: Lamp/* default */.Z,
        linkType: demo_1/* LinkType.orange */.U.orange,
        title: "Identity & Branding",
        iconClassName: "icon-svg-sm solid-mono text-orange mb-3",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 4,
        link: "#",
        Icon: DeliveryBox/* default */.Z,
        title: "Product Design",
        linkType: demo_1/* LinkType.green */.U.green,
        iconClassName: "icon-svg-sm solid-mono text-green mb-3",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    }
];
// used in the services-24 block
var serviceList12 = [
    {
        id: 1,
        title: "Web Design",
        image: {
            "1x": "/img/illustrations/i24.png",
            "2x": "/img/illustrations/i24@2x.png 2x"
        },
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget. Fusce dapibus\n    tellus."
    },
    {
        id: 2,
        title: "Graphic Design",
        image: {
            "1x": "/img/illustrations/i19.png",
            "2x": "/img/illustrations/i19@2x.png 2x"
        },
        description: "Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet. Sed posuere consectetur."
    },
    {
        id: 3,
        title: "3D Animation",
        image: {
            "1x": "/img/illustrations/i18.png",
            "2x": "/img/illustrations/i18@2x.png 2x"
        },
        description: "Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna scelerisque."
    }
];
// used in the services-25 block
var serviceList13 = [
    {
        id: 1,
        linkUrl: "#",
        color: color/* default.purple */.Z.purple,
        title: "Web Design",
        icon: "uil-monitor",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget. Fusce dapibus tellus."
    },
    {
        id: 2,
        linkUrl: "#",
        color: color/* default.green */.Z.green,
        title: "Graphic Design",
        icon: "uil-swatchbook",
        description: "Maecenas faucibus mollis interdum. Vivamus sagittis lacus vel augue laoreet. Sed posuere consectetur."
    },
    {
        id: 3,
        linkUrl: "#",
        color: color/* default.pink */.Z.pink,
        title: "3D Animation",
        icon: "uil-presentation-play",
        description: "Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna scelerisque."
    }
];
// used in the services-26 block
var serviceList14 = [
    {
        id: 1,
        url: "#",
        title: "Wedding",
        image: {
            "1x": "/img/photos/fs1.jpg",
            "2x": "/img/photos/fs1@2x.jpg 2x"
        }
    },
    {
        id: 2,
        url: "#",
        title: "Couples",
        image: {
            "1x": "/img/photos/fs2.jpg",
            "2x": "/img/photos/fs2@2x.jpg 2x"
        }
    },
    {
        id: 3,
        url: "#",
        title: "Engagement",
        image: {
            "1x": "/img/photos/fs3.jpg",
            "2x": "/img/photos/fs3@2x.jpg 2x"
        }
    }
];


/***/ }),

/***/ 9486:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useLightBox = function() {
    var lightboxLoad = function() {
        var GLightbox = __webpack_require__(7727);
        GLightbox({
            loop: false,
            moreLength: 0,
            zoomable: false,
            autoplayVideos: true,
            touchNavigation: true,
            selector: "*[data-glightbox]",
            // slideExtraAttributes: { poster: '' },
            plyr: {
                config: {
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            }
        });
    };
    useEffect(function() {
        lightboxLoad();
    }, []);
    return null;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useLightBox)));


/***/ }),

/***/ 3293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Analytics = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 512 427.5",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M186.9 353.4h138.3V413H186.9z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M460.2 0H51.8C23.2 0 0 23.2 0 51.8v264.4c0 28.6 23.2 51.7 51.8 51.8h120.6v30.6h-28.8c-8 0-14.5 6.5-14.5 14.5s6.5 14.5 14.5 14.5h224.9c8 0 14.5-6.5 14.5-14.5s-6.5-14.5-14.5-14.5h-28.8v-45.1c0-8-6.5-14.5-14.5-14.5H51.8C39.2 339 29 328.8 29 316.2V51.8C29 39.2 39.2 29 51.8 29h408.5c12.6 0 22.8 10.2 22.8 22.8v264.4c0 12.6-10.2 22.8-22.8 22.8h-45.9c-8-.2-14.6 6.1-14.8 14.1-.2 8 6.1 14.6 14.1 14.8h46.7c28.6 0 51.7-23.2 51.8-51.8V51.8C512 23.2 488.8 0 460.2 0zM201.3 398.5v-30.6h109.4v30.6H201.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M218.2 291.3h-75.6v-90.6c0-20.9 16.9-37.8 37.8-37.8s37.8 16.9 37.8 37.8v90.6zm75.6 0h-75.6V155.4c0-20.9 16.9-37.8 37.8-37.8s37.8 16.9 37.8 37.8v135.9z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M369.4 215.4c8 0 14.4-6.4 14.5-14.4v-91c0-28.9-23.5-52.2-52.3-52.2-28.3 0-51.4 22.6-52.2 50.8-25.8-12.9-57.1-2.5-70.1 23.3-3.4 6.9-5.3 14.4-5.5 22.1-25.8-12.9-57.2-2.5-70.1 23.3-3.6 7.3-5.5 15.3-5.5 23.4v90.6c0 8 6.5 14.5 14.5 14.5h226.7c8 .2 14.6-6.1 14.8-14.1.2-8-6.1-14.6-14.1-14.8h-61.9V110c0-12.9 10.4-23.3 23.3-23.3s23.3 10.4 23.3 23.3v91c.1 8 6.6 14.4 14.6 14.4zm-212.3-14.7c0-12.9 10.4-23.3 23.3-23.3s23.3 10.4 23.3 23.3v76.1h-46.6v-76.1zm75.6 0v-45.4c0-12.9 10.4-23.3 23.3-23.3s23.3 10.4 23.3 23.3v121.5h-46.6v-76.1z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 1777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CloudComputing = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 361.2",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M309.9 231h-12.7c-6.1.2-11.3-4.6-11.5-10.8-.2-6.1 4.6-11.3 10.8-11.5h13.4c23 0 41.6-18.7 41.6-41.6 0-20-14.3-37.1-33.9-40.8-6-1.1-10-6.9-8.9-13 0-.3.1-.5.2-.7 10-38.6-13.2-78-51.8-88-5.9-1.5-11.9-2.3-18-2.3-24.7-.1-47.7 12.6-60.9 33.5-3 4.7-8.9 6.5-14 4.2-23.4-10.6-50.9-.2-61.5 23.2-2.7 6-4.1 12.5-4.1 19.1 0 3.6.4 7.2 1.3 10.7 1.4 6-2.3 12-8.3 13.4-.1 0-.2 0-.3.1-22.5 4.7-36.9 26.7-32.2 49.2 4 19.3 21 33.1 40.7 33.1h138.4c6.1.2 11 5.3 10.8 11.5-.2 5.9-4.9 10.6-10.8 10.8H99.8c-35.3 0-63.8-28.6-63.8-63.9 0-26.3 16.1-49.8 40.5-59.4-.1-1.8-.2-3.6-.2-5.4 0-38 30.8-68.7 68.8-68.7 6.6 0 13.2 1 19.5 2.8C196.6-4.7 255.9-12 297 20.1c26.6 20.7 40.1 54 35.4 87.4 33 12.4 49.6 49.3 37.2 82.3-9.3 24.8-33.2 41.2-59.7 41.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 334.3c-6.1 0-11.1-5-11.1-11.1V220.8c-.2-6.1 4.6-11.3 10.8-11.5 6.1-.2 11.3 4.6 11.5 10.8v103.1c-.1 6.1-5.1 11.1-11.2 11.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M398.5 334.3H11.1C5 334.1.1 329 .3 322.8c.2-5.9 4.9-10.6 10.8-10.8h387.4c6.1.2 11 5.3 10.8 11.5-.2 5.9-4.9 10.6-10.8 10.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M234.8 350.1h-60.1c-8 0-14.5-6.5-14.5-14.4v-25c0-8 6.5-14.5 14.4-14.5h60.1c8 0 14.5 6.5 14.5 14.5v25c.1 7.9-6.4 14.4-14.4 14.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M234.8 361.2h-60.1c-14.1 0-25.6-11.5-25.6-25.6v-25c0-14.1 11.5-25.6 25.6-25.6h60.1c14.1 0 25.6 11.5 25.6 25.6v25c0 14.2-11.4 25.6-25.6 25.6zm-60-53.9c-1.8 0-3.3 1.5-3.3 3.3v25c0 1.8 1.5 3.3 3.3 3.3h60.1c1.8 0 3.3-1.5 3.3-3.3v-25c0-1.8-1.5-3.3-3.3-3.3h-60.1zM71.3 356.5c-6.1 0-11.1-5-11.1-11.1v-44.5c.2-6.1 5.3-11 11.5-10.8 5.9.2 10.6 4.9 10.8 10.8v44.5c-.1 6.1-5.1 11.1-11.2 11.1zm267 0c-6.1 0-11.1-5-11.1-11.1v-44.5c.2-6.1 5.3-11 11.5-10.8 5.9.2 10.6 4.9 10.8 10.8v44.5c-.1 6.1-5.1 11.1-11.2 11.1z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloudComputing);


/***/ }),

/***/ 757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Design = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 409.6 332.7",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-yellow me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M350.9 54.2H58.7c-6.2.2-11.4-4.7-11.5-10.9S51.8 31.9 58 31.7h292.9c6.2-.2 11.4 4.7 11.5 10.9s-4.7 11.4-10.9 11.5c-.2.1-.4.1-.6.1zM239.8 328.9a11.182 11.182 0 01-10.6-14.8c2.8-8.3 16.2-47.4 25.6-63.6-9.5-10.1-37-40.3-49.9-66.1-12.1 23.4-39.5 54.4-50.1 66 10.1 16.5 22.7 54.9 25.4 63.6.4 1.2.6 2.4.6 3.7 0 6.2-5 11.2-11.2 11.2-4.9 0-9.3-3.2-10.7-7.9v-.1c-6.6-20.7-18.4-52.9-24.3-60.3-4.8-6.1-3.4-14.5-.8-19.8.5-.9 1.1-1.8 1.8-2.6 20.6-22.3 50.7-59.4 52.7-72.4.6-3.7 3.3-10.1 14.8-10.7 12.5-.7 16.6 4.8 17.8 9.4 5.7 21.5 40 60.3 52.7 73.4.8.8 1.5 1.8 2 2.8 2.6 5.1 4 13.3-.5 19.5-5.7 7.7-18.2 41.6-24.8 61.1-1.3 4.6-5.6 7.7-10.5 7.6z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 254.9c-6.2 0-11.2-5-11.2-11.2V167c.3-6.2 5.6-10.9 11.8-10.6 5.7.3 10.3 4.9 10.6 10.6v76.7c0 6.2-5 11.2-11.2 11.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M366.6 244.6c-6.2 0-11.2-5-11.2-11.2v-28.6c0-83.1-67.6-150.6-150.6-150.6S54.2 121.7 54.2 204.8v28.6c-.2 6.2-5.4 11.1-11.5 10.9-5.9-.2-10.7-4.9-10.9-10.9v-28.6c-.1-95.5 77.2-172.9 172.7-173 46 0 90.1 18.2 122.6 50.8 32.6 32.3 50.9 76.3 50.9 122.2v28.6c-.1 6.2-5.2 11.2-11.4 11.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M220 74.7h-30.4c-9.1 0-16.5-7.4-16.5-16.5V27.7c0-9.1 7.4-16.5 16.5-16.5H220c9.1 0 16.5 7.4 16.5 16.5v30.5c0 9.1-7.4 16.5-16.5 16.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M220 85.9h-30.4c-15.3 0-27.7-12.4-27.7-27.7V27.7c0-15.3 12.4-27.7 27.7-27.7H220c15.3 0 27.7 12.4 27.7 27.7v30.5c0 15.3-12.4 27.7-27.7 27.7zm-30.4-63.5c-2.9 0-5.3 2.4-5.3 5.3v30.5c0 2.9 2.4 5.3 5.3 5.3H220c2.9 0 5.3-2.4 5.3-5.3V27.7c0-2.9-2.4-5.3-5.3-5.3h-30.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M381.9 275.4h-30.5c-9.1 0-16.5-7.4-16.5-16.5v-30.5c0-9.1 7.4-16.5 16.5-16.5h30.5c9.1 0 16.5 7.4 16.5 16.5v30.5c0 9.1-7.4 16.5-16.5 16.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M381.9 286.6h-30.5c-15.3 0-27.7-12.4-27.7-27.7v-30.5c0-15.3 12.4-27.7 27.7-27.7h30.5c15.3 0 27.7 12.4 27.7 27.7v30.5c0 15.3-12.4 27.7-27.7 27.7zm-30.5-63.4c-2.9 0-5.3 2.4-5.3 5.3V259c0 2.9 2.4 5.3 5.3 5.3h30.5c2.9 0 5.3-2.4 5.3-5.3v-30.5c0-2.9-2.4-5.3-5.3-5.3h-30.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M58.2 275.4H27.7c-9.1 0-16.5-7.4-16.5-16.5v-30.5c0-9.1 7.4-16.5 16.5-16.5h30.5c9.1 0 16.5 7.4 16.5 16.5V259c0 9.1-7.4 16.5-16.5 16.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M58.2 286.6H27.7C12.4 286.6 0 274.2 0 258.9v-30.5c0-15.3 12.4-27.7 27.7-27.7h30.5c15.3 0 27.7 12.4 27.7 27.7v30.5c0 15.3-12.4 27.7-27.7 27.7zm-30.5-63.4c-2.9 0-5.3 2.4-5.3 5.3V259c0 2.9 2.4 5.3 5.3 5.3h30.5c2.9 0 5.3-2.4 5.3-5.3v-30.5c0-2.9-2.4-5.3-5.3-5.3H27.7zm234.1 109.5h-114c-6.2 0-11.2-5-11.2-11.2 0-6.2 5-11.2 11.2-11.2h114c6.2 0 11.2 5 11.2 11.2 0 6.2-5 11.2-11.2 11.2z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Design);


/***/ }),

/***/ 9759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var LightBulb = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 321.7 409.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-blue me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M160.9 221.3c-19.1 0-37.4-7.3-51.3-20.4l51.3 127.2 51.3-127.2c-13.9 13.1-32.3 20.4-51.3 20.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M160.9 339.9c-4.8 0-9.1-2.9-10.9-7.4L98.6 205.3c-2.5-6 .3-12.9 6.3-15.4 4.3-1.8 9.3-.9 12.7 2.4 24.3 22.9 62.2 22.9 86.5 0 4.7-4.5 12.1-4.3 16.6.3 3.2 3.4 4.2 8.3 2.4 12.7l-51.4 127.2c-1.7 4.5-6 7.4-10.8 7.4zm-27.5-111.3l27.5 68.1 27.5-68.1c-17.9 5.9-37.2 5.9-55 0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M86.7 316.1c-5.9 0-10.9-4.4-11.7-10.2-2.2-16.6-9.8-23.9-22.3-36.1l-2.9-2.8C28.8 246.5 0 218.4 0 151.6c0-42.9 17.1-81.9 48-110C77.7 14.8 117.7 0 160.9 0s83.2 14.8 112.8 41.6c6.7 6.1 12.8 12.7 18.3 19.9 3.1 4.1 6 8.3 8.6 12.6 1.3 2.2 2.6 4.4 3.8 6.6 2.4 4.5 4.6 9.1 6.5 13.8 1.4 3.5 2.7 7.2 3.9 10.8 4.7 14.9 7 30.5 7 46.2 0 27.9-4.9 51.2-15 71.2-.6 1.2-1.2 2.4-1.8 3.5-1.8 3.3-3.8 6.5-5.9 9.6-.7 1-1.4 2-2 3-2.6 3.6-5.3 7.1-8.5 10.7-5.6 6.5-11.5 12.2-16.6 17.2-4.7 4.5-12.1 4.4-16.6-.2-4.5-4.7-4.4-12.1.2-16.6 5-4.9 10.2-9.9 15.2-15.7 2.6-3 4.9-6 7.1-9 .6-.8 1.1-1.6 1.7-2.4 1.7-2.5 3.3-5.2 4.7-7.8.5-.9 1-1.9 1.5-2.8 8.4-16.6 12.5-36.4 12.5-60.6 0-13.2-2-26.4-5.9-39.1-1-3.1-2.1-6.1-3.3-9.1-1.6-3.9-3.4-7.8-5.4-11.6-1-1.9-2.1-3.8-3.2-5.6-6.2-10.2-13.8-19.4-22.6-27.3-25.3-22.9-59.8-35.5-97-35.5S89.1 36.1 63.8 59c-26 23.5-40.3 56.4-40.3 92.5 0 56.9 22.7 79.1 42.8 98.6l2.8 2.7c13.4 13 26.1 25.2 29.3 49.9.9 6.4-3.7 12.4-10.1 13.2-.6.2-1.1.2-1.6.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M141.9 397.8h38c3.8 0 7.4-1.5 10.1-4.2l13-13c2-2 3.4-4.6 3.9-7.4l12.4-63.7h-117l12.4 63.7c.6 2.8 2 5.4 4 7.4l13 13c2.7 2.7 6.3 4.2 10.2 4.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M179.8 409.6h-37.9c-6.9 0-13.6-2.7-18.5-7.7l-13-13c-3.7-3.7-6.2-8.4-7.2-13.5l-12.4-63.7c-1.2-6.4 2.9-12.5 9.3-13.8.7-.1 1.5-.2 2.2-.2h117c6.5 0 11.8 5.3 11.8 11.8 0 .8-.1 1.5-.2 2.2l-12.4 63.7c-1 5.1-3.5 9.8-7.2 13.5l-13 13c-4.8 4.9-11.5 7.7-18.5 7.7zm-63.2-88.4l9.7 49.7c.1.5.4 1 .7 1.4l13 13c.5.5 1.2.8 1.9.8h38c.7 0 1.4-.3 1.9-.8l13-13c.4-.4.6-.9.7-1.4l9.6-49.7h-88.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M241.5 321H80.2c-6.5-.2-11.6-5.6-11.4-12.1.2-6.2 5.2-11.2 11.4-11.4h161.4c6.5-.2 11.9 4.9 12.1 11.4.2 6.5-4.9 11.9-11.4 12.1h-.8zm-14.8 44.3H95c-6.5-.2-11.6-5.6-11.4-12.1.2-6.2 5.2-11.2 11.4-11.4h131.7c6.5.2 11.6 5.6 11.4 12.1-.2 6.2-5.2 11.2-11.4 11.4z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LightBulb);


/***/ }),

/***/ 9669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var PieChartTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 408.1 409.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-green me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M396.3 192.3h-33.4c-6.4 0-11.6-5.2-11.6-11.6 0-6.4 5.2-11.6 11.6-11.6h19.7C363.2 71.1 268.1 7.3 170.1 26.6c-4.2.8-8.4 1.8-12.6 2.9L235.1 169h72c6.4 0 11.6 5.2 11.6 11.6 0 6.4-5.2 11.6-11.6 11.6h-78.9c-4.2 0-8.1-2.3-10.1-6l-87.9-158c-3.1-5.6-1.1-12.6 4.5-15.7.7-.4 1.5-.7 2.3-1l8.1-2.5c107.8-33.1 222 27.4 255.1 135.2 2.7 8.7 4.8 17.6 6.3 26.6l1.3 8c1.1 6.3-3.2 12.3-9.5 13.3-.7.2-1.3.2-2 .2zM204.6 409.6c-20.4-.1-40.6-3.2-60.1-9.2l-8.1-2.5c-6.1-1.9-9.6-8.4-7.7-14.5.2-.8.6-1.5 1-2.2l88.4-158.3c2.1-3.7 5.9-5.9 10.1-5.9h33.2c6.4.2 11.4 5.5 11.2 11.9-.2 6.1-5.1 11.1-11.2 11.2H235l-78 139.8c96.8 26.3 196.6-30.9 222.9-127.8 1.1-4 2-8 2.8-12h-65.4c-6.4.2-11.7-4.8-11.9-11.2-.2-6.4 4.8-11.7 11.2-11.9h79.8c6.4 0 11.6 5.2 11.6 11.6 0 .6-.1 1.3-.2 1.9l-1.3 7.9C390 337 304.7 409.4 204.6 409.6z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M93 361.8C6 300.1-14.5 179.6 47.1 92.6c12.7-17.9 28.4-33.5 46.3-46.2l6.2-4.4 90 161.7-90.4 162.5-6.2-4.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M99.2 377.8c-2.4 0-4.7-.7-6.7-2.1l-6.2-4.4C-5.9 305.9-27.7 178.2 37.7 86c13.5-19 30-35.5 49.1-48.9l6.2-4.4c5.2-3.7 12.4-2.4 16.1 2.8.2.3.5.7.7 1.1l90 161.7c1.9 3.5 1.9 7.8 0 11.3L109.4 372c-1.6 2.9-4.3 4.9-7.6 5.7-.8 0-1.7.1-2.6.1zM95.8 59C15.6 119.1-.7 232.9 59.4 313.1c10.2 13.7 22.4 25.8 36 36.1l81-145.4L95.8 59z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PieChartTwo);


/***/ }),

/***/ 5855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Rocket = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 294.2 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-aqua mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M31.2 342.9c-2.4 1.7-5.8 1.1-7.5-1.3-.6-.9-1-2-1-3.1v-77.1l68.9-77.2V150L5 247.1c-3.2 3.6-5 8.2-5 13v78.4c0 15.5 12.6 28.1 28.1 28.1 5.8 0 11.5-1.8 16.2-5.1l9.6-6.8-13.1-18.6-9.6 6.8zm258.1-95.8L200.7 148v34.2l70.8 79.3v77.1c0 3-2.4 5.4-5.4 5.4-1.1 0-2.2-.3-3.1-1l-9.6-6.7-13.1 18.6 9.6 6.7c12.7 8.9 30.3 5.9 39.2-6.9 3.3-4.7 5.1-10.4 5.1-16.1v-78.4c0-4.8-1.8-9.5-4.9-13.1zM147.1 409.6l-6.1-3.9c-2-1.3-49.3-32-49.3-72.5 0-40 23.3-72.6 53.1-74.2.8 0 1.6-.1 2.3-.1 4.1 0 8.1.6 12.1 1.7 9.1 2.7 17.6 8.4 24.6 16.6 11.9 14 18.7 34.4 18.7 55.9 0 40.5-47.2 71.2-49.3 72.5l-6.1 4zm0-127.9h-1c-17.5.9-31.7 24-31.7 51.5 0 19.6 19.9 39.1 32.6 48.9 12.7-9.8 32.6-29.3 32.6-48.9 0-16.2-4.9-31.2-13.3-41.1-4.1-4.8-8.8-8.1-13.6-9.5-1.8-.6-3.7-.9-5.6-.9z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M147.1 11.4c-13.1 0-96.4 71.4-96.4 143.4 0 24.5 29.3 178.4 29.3 178.4h134.1s29.3-153.9 29.3-178.4c.1-72.4-83.9-143.4-96.3-143.4zm49.8 159.2c-1 4.9-2.7 9.6-5.1 14-.8 1.4-1.6 2.8-2.5 4.2-3.7 5.4-8.3 10.1-13.7 13.7-1.3.9-2.7 1.8-4.2 2.5-24.7 13.4-55.6 4.2-68.9-20.5s-4.2-55.6 20.5-68.9c7.4-4 15.8-6.2 24.3-6.1 3.4 0 6.9.3 10.2 1 4.9 1 9.6 2.7 14 5.1 7.2 3.9 13.4 9.5 17.9 16.3 5.7 8.4 8.7 18.3 8.7 28.4-.1 3.5-.4 6.9-1.2 10.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M147.1 222.6c-34.4 0-62.2-28-62.2-62.3 0-34.4 28-62.2 62.3-62.2 10.3 0 20.4 2.6 29.5 7.5 2.6 1.4 5.2 3.1 7.6 4.9 24.8 18.5 32.2 52.4 17.5 79.6-1 1.8-2 3.5-3.1 5.1-4.5 6.6-10.2 12.3-16.8 16.8-1.6 1.1-3.4 2.2-5.1 3.1-9.1 4.9-19.3 7.5-29.7 7.5zm0-101.7c-21.8-.3-39.7 17-40.1 38.8s17 39.7 38.8 40.1h1.3c2.7 0 5.4-.3 8-.8 3.8-.8 7.4-2.1 10.8-4 1.1-.6 2.2-1.3 3.2-2 4.2-2.8 7.8-6.5 10.7-10.7.7-1.1 1.4-2.1 2-3.3 1.9-3.4 3.2-7 4-10.8.5-2.6.8-5.3.8-8 0-12.5-5.9-24.2-15.9-31.6-1.5-1.1-3.1-2.2-4.8-3.1-3.4-1.9-7-3.2-10.8-4-2.6-.5-5.3-.8-8-.8v.2z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M89.5 321.8h115.2c9-47.9 27.4-149.1 27.4-167 0-63-69.5-123.9-85-131.5-6.7 3.3-26.8 18.4-46.8 43.2-24.6 30.4-38.2 61.8-38.2 88.4 0 17.9 18.4 119.1 27.4 166.9zm134.1 22.8H70.7l-1.8-9.3c-3-15.9-29.5-155.7-29.5-180.6 0-42.2 25-80.9 45.9-106C101.1 29.9 131.8 0 147.1 0c15 0 45.7 29.8 61.5 48.6 21.1 25.1 46.2 63.8 46.2 106.2 0 24.9-26.5 164.7-29.5 180.6l-1.7 9.2z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Rocket);


/***/ }),

/***/ 4545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Savings = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 512 465.5",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-green mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M156.8 465.5c-9.9 0-24.2-4.8-56.2-40.6-16.2-18.2-29.5-36-30.1-36.8-.4-.5-.7-1-1-1.6-6.1-11-9.3-23.3-9.3-35.8v-90.9c0-7.9 6.4-14.4 14.3-14.4h116c16.5 0 32.4 6.5 44.2 18.1l59.4 58.5c17.2 17.2 17.3 45.1.1 62.3s-45.1 17.3-62.3.1L172.7 325c-5.9 0-15.5-.1-23.1-.1l-10.8-.1c-7.9 0-14.3-6.5-14.3-14.4s6.5-14.3 14.4-14.3h.1l10.8.1c6.8 0 14.1.1 19.6.1h6.9c4.2 0 8.5.1 12.7 4.3l63.5 63.5c6 6 15.7 6 21.7 0s6-15.7 0-21.7L214.6 284c-6.4-6.3-15-9.9-24-9.8H88.9v76.5c0 7.4 1.8 14.6 5.2 21.1 2.6 3.5 13.6 17.9 26.5 32.4 25.5 28.8 35.2 32.2 36.5 32.6h155.1c10.6 0 22.9-5.5 34.6-11.2 9.9-4.8 83.3-54.6 127.3-84.9l.7-.5c8.2-5.1 10.7-15.8 5.6-23.9-4.9-7.9-15.2-10.5-23.3-6L350 381.4c-6.6 4.4-15.5 2.6-19.9-4-4.4-6.6-2.6-15.5 4-19.9l107.5-71.3c.2-.1.3-.2.5-.3 21.8-13.1 50.1-6 63.2 15.8 12.9 21.6 6.2 49.6-15.2 62.8-13.3 9.2-115.8 79.6-130.8 86.9-14.7 7.1-30.5 14.1-47.1 14.1H156.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M14.4 242.2h84.2v189.6H14.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M98.5 446.1H14.4c-7.9 0-14.4-6.4-14.4-14.4V242.2c0-7.9 6.4-14.4 14.3-14.4h84.1c7.9 0 14.3 6.4 14.3 14.4v189.6c.1 7.9-6.3 14.3-14.2 14.3zm-69.8-28.7h55.4V256.5H28.7v160.9zM273 214.2c-59.2 0-107.1-48-107.1-107.1C165.9 47.9 213.9 0 273.1 0c59.1 0 107.1 48 107.1 107.1-.1 59.1-48.1 107.1-107.2 107.1zm0-185.5c-43.3 0-78.4 35.1-78.4 78.4s35.1 78.4 78.4 78.4c43.3 0 78.4-35.1 78.4-78.4-.1-43.3-35.1-78.3-78.4-78.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "lineal-fill",
                cx: "348.9",
                cy: "178.6",
                r: "92.8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M348.9 285.7c-59.1 0-107.1-47.9-107.1-107.1 0-59.1 47.9-107.1 107.1-107.1S456 119.4 456 178.6c-.1 59.1-48 107-107.1 107.1zm0-185.5c-43.3 0-78.4 35.1-78.4 78.4S305.7 257 349 257s78.4-35.1 78.4-78.4c-.1-43.3-35.2-78.4-78.5-78.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M345.4 224.9c-15.5-.5-28.2-8.5-28.2-16.8 0-4.4 3.9-10.9 8.8-10.9 5.4 0 9.8 7.6 19.4 9.3v-20.9c-11.9-4.5-25.9-10.1-25.9-26.6s12.1-24.3 25.9-26.2v-3.6c0-1.8 2.1-3.5 4.9-3.5 2.5 0 4.9 1.7 4.9 3.5v3.2c8 .3 23.1 2.3 23.1 11.2 0 3.5-2.3 10.6-8 10.6-4.3 0-6.7-4.1-15.1-4.8v18.9c11.8 4.4 25.5 10.5 25.5 27.9 0 16-10.4 25.7-25.5 28.2v3.8c0 1.8-2.5 3.5-4.9 3.5-2.9 0-4.9-1.7-4.9-3.5v-3.3zm1.3-59.7v-15.4c-5.8 1.2-8.3 4.1-8.3 7.2 0 3.8 3.4 6.1 8.3 8.2zm7.2 23.9v17.3c4.4-1 7.9-3.5 7.9-8.1 0-4.3-3.2-7-7.9-9.2z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Savings);


/***/ }),

/***/ 9524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Shield = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 339.8 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M169.9 409.6c-5.5 0-10.9-1.2-15.8-3.5C107.8 384.8 0 327.5 0 255.5V72.1c0-10.7 8.7-19.4 19.4-19.5 2.1 0 4.2.3 6.1 1 9.2 3.1 18.9 4.7 28.6 4.6 31.5.1 60.7-16.3 76.9-43.3C136.6 5.7 146.6 0 157.4 0h25c10.8.1 20.8 5.7 26.4 14.9 16.2 27 45.4 43.4 76.9 43.3 9.7 0 19.4-1.6 28.6-4.6 10.2-3.4 21.2 2.1 24.6 12.3.7 2 1 4.1 1 6.1v48c0 6.5-5.3 11.8-11.7 11.8-6.5 0-11.8-5.3-11.8-11.7V77.6c-10 2.8-20.3 4.2-30.6 4.2-39.7.2-76.5-20.6-97-54.6-1.3-2.2-3.7-3.6-6.3-3.6h-25c-2.6 0-5 1.4-6.3 3.6-20.5 34-57.3 54.8-97 54.6-10.3 0-20.6-1.4-30.6-4.2v178c0 47.7 72.5 98 140.4 129.3 3.8 1.7 8.2 1.7 12 0 67.9-31.3 140.4-81.6 140.4-129.3v-74.9c0-6.5 5.3-11.8 11.8-11.7 6.5 0 11.7 5.3 11.7 11.7v74.9c0 72-107.8 129.3-154.1 150.6-5 2.2-10.4 3.4-15.9 3.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M156 269l-62.2-31.1c-11.8-5.9-16.6-20.2-10.7-32 5.9-11.8 20.2-16.6 32-10.7l44.9 22.5 56.6-70.7c8.2-10.3 23.2-12 33.5-3.7 10.3 8.2 12 23.2 3.7 33.5l-68.6 85.8c-6.9 8.8-19.1 11.5-29.2 6.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M166.7 283.3c-5.5 0-11-1.3-15.9-3.8l-62.2-31.1c-17.6-8.8-24.7-30.2-15.9-47.8s30.2-24.7 47.8-15.9l36.4 18.2 50.6-63.3c12.3-15.4 34.7-17.9 50.1-5.6 15.4 12.3 17.9 34.7 5.6 50.1l-68.6 85.8c-6.8 8.5-17.1 13.4-27.9 13.4zm-62.2-78.8c-6.7 0-12.1 5.4-12.1 12.1 0 4.6 2.6 8.8 6.7 10.8l62.2 31.1c5.1 2.6 11.3 1.2 14.9-3.3l68.6-85.8c4.3-5.1 3.7-12.8-1.4-17.1-5.1-4.3-12.8-3.7-17.1 1.4-.1.2-.3.3-.4.5l-56.6 70.7c-3.5 4.3-9.5 5.6-14.4 3.2L110 205.6c-1.7-.7-3.6-1.1-5.5-1.1z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Shield);


/***/ }),

/***/ 9711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var SmartphoneTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 306.7 409.6",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-red mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M11.1 348.5c-6.1 0-11.1-5-11.1-11.1V72.2C0 66 5 61.1 11.1 61.1h284.5c6.1 0 11.1 5 11.1 11.1V257c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1V83.2H22.2v254.2c0 6.2-5 11.2-11.1 11.1 0 .1 0 .1 0 0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M48.8 398.5H258c20.8 0 37.7-16.9 37.7-37.7v-23.4H11.1v23.4c0 20.8 16.9 37.7 37.7 37.7z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M258 409.6H48.8C21.9 409.6 0 387.7 0 360.8v-23.4c0-6.1 5-11.1 11.1-11.1h284.5c6.1 0 11.1 5 11.1 11.1v23.4c0 26.9-21.8 48.7-48.7 48.8zM22.2 348.5v12.3c0 14.7 11.9 26.6 26.6 26.6H258c14.7 0 26.6-11.9 26.6-26.6v-12.3H22.2zM295.6 83.2H11.1C5 83.2 0 78.3 0 72.2V48.8C0 21.9 21.9 0 48.8 0H258c26.9 0 48.8 21.9 48.8 48.8v23.4c0 6.1-5 11-11.2 11zM22.2 61h262.3V48.8c0-14.7-11.9-26.5-26.5-26.6H48.8c-14.7 0-26.6 11.9-26.6 26.6V61z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "st2",
                d: "M65.1 130.8L85 145.3l23.3-28.9"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M85 156.4c-2.3 0-4.6-.7-6.5-2.1l-20-14.4c-5-3.6-6.1-10.5-2.5-15.5s10.5-6.1 15.5-2.5l11.5 8.3 16.7-20.7c3.9-4.8 10.9-5.5 15.6-1.6s5.5 10.9 1.6 15.6l-23.3 28.8c-2 2.6-5.2 4.1-8.6 4.1zM241.7 142H159c-6.1-.2-11-5.3-10.8-11.4.2-5.9 4.9-10.6 10.8-10.8h82.7c6.1.2 11 5.3 10.8 11.4-.2 5.9-4.9 10.6-10.8 10.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "st2",
                d: "M65.1 204.8L85 219.2l23.3-28.8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M85 230.3c-2.3 0-4.6-.7-6.5-2.1l-20-14.4c-5-3.6-6.1-10.5-2.5-15.5s10.5-6.1 15.5-2.5l11.5 8.3 16.7-20.7c3.8-4.8 10.8-5.5 15.6-1.7s5.5 10.8 1.7 15.6l-23.3 28.9c-2.1 2.6-5.3 4.1-8.7 4.1zm156.7-14.4H159c-6.1 0-11.1-5-11.1-11.1s5-11.1 11.1-11.1h82.7c6.1 0 11.1 5 11.1 11.1s-5 11.1-11.1 11.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "st2",
                d: "M65.1 278.8L85 293.2l23.3-28.9"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M85 304.3c-2.3 0-4.6-.7-6.5-2.1l-20-14.4c-5-3.6-6.1-10.5-2.5-15.5s10.5-6.1 15.5-2.5L83 278l16.7-20.7c3.9-4.8 10.9-5.5 15.6-1.7s5.5 10.9 1.7 15.6l-23.3 28.9c-2.1 2.7-5.3 4.2-8.7 4.2zm156.7-14.4H159c-6.1 0-11.1-5-11.1-11.1s5-11.1 11.1-11.1h82.7c6.1 0 11.1 5 11.1 11.1s-5 11.1-11.1 11.1z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SmartphoneTwo);


/***/ }),

/***/ 8290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Telephone = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 507 512",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-sm text-primary me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M402.4 437.9c0-10.5-4.4-20.4-12.6-28.7-5.1-5.6-10.6-11-16-16.1-2.7-2.6-5.5-5.3-8.1-8l-23.4-23.4c-18-18-41.3-18-59.4 0-2.4 2.4-4.9 4.8-7.3 7.2-6.4 6.4-13.1 12.9-19.6 19.9-11.6-5.2-23-12.4-36.5-23.2-13.4-10.9-62.2-59.7-73.2-73.2-10.7-13.5-17.9-25-23.2-36.5 7-6.4 13.5-13.1 19.9-19.6 2.4-2.4 4.8-4.9 7.2-7.3 18-18 18-41.3 0-59.4l-23.4-23.4c-2.7-2.7-5.4-5.4-8-8.1-5.2-5.3-10.6-10.8-16.1-16-8.3-8.2-18.3-12.6-28.7-12.6s-20.5 4.5-29.1 12.7l-.2.2L33.4 134c-10.8 10.6-17.4 24.8-18.6 39.9-2.1 25 5.3 48.4 11 63.6C39.6 275 60.4 309.7 91.3 347c11.2 13.3 23.2 26 35.9 37.8 11.8 12.7 24.4 24.7 37.8 35.8 37.2 31 72 51.7 109.5 65.6 15.3 5.7 38.6 13 63.6 11 15.1-1.2 29.3-7.8 39.9-18.6l11.6-11.4.2-.2c8.2-8.5 12.6-18.6 12.6-29.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M507 237.1C507 106.4 400.7 0 270 0c-54.9 0-108.2 19.1-150.6 54-6.1 5.1-7 14.2-1.9 20.3 5.1 6.1 14.1 7 20.2 2 37.3-30.6 84-47.4 132.3-47.4 114.9 0 208.3 93.4 208.3 208.3-.1 63.1-28.7 122.8-77.8 162.4l-.2-.2c-5.4-5.8-11.1-11.4-16.4-16.5l-.2-.1c-2.5-2.3-5-4.8-7.4-7.3l-23.8-23.8c-11.6-11.6-25.4-17.7-39.9-17.7s-28.3 6.1-39.9 17.7l-3.4 3.4c-1.1 1.1-2.6 2.5-3.8 3.7l-1.8 1.7c-3.5 3.5-7.1 7-10.8 10.7-8.6-4.9-16.8-10.5-24.4-16.7-12.9-10.5-60.4-58.1-71-71-6.2-7.7-11.8-15.8-16.8-24.4 3.7-3.6 7.2-7.2 10.7-10.7l1.7-1.8c1.3-1.3 2.6-2.6 3.8-3.9 1.1-1.1 2.2-2.3 3.4-3.4 23.5-23.5 23.5-56.2 0-79.7L149 148.3c4.5-6.1 9.4-11.8 14.8-17.1 58.5-58.5 153.6-58.5 212 0 44.9 45 56.6 113.4 29.3 170.8-3.4 7.2-.4 15.8 6.8 19.2s15.8.4 19.2-6.8c32.6-68.4 18.7-149.9-34.9-203.5-69.7-69.7-183.1-69.7-252.7 0-5.3 5.3-10.3 10.9-14.9 16.8-5-5.2-10.3-10.6-16-15.8-10.9-11-24.3-16.7-38.6-16.7s-27.8 5.7-39.1 16.6l-.2.2-.2.2-.1.1-11.3 11.6C9.9 136.9 1.8 154.2.4 172.7c-2.3 27.8 5.7 53.2 11.8 69.8 14.5 39.2 36.1 75.3 68.1 113.7C91.7 369.9 104 382.8 117 395c12.2 13 25.1 25.3 38.8 36.8 38.4 31.9 74.5 53.5 113.6 68 14.2 5.2 35.8 12.2 60 12.2 3.3 0 6.7-.1 10-.4 18.5-1.5 35.8-9.5 48.7-22.7l11.6-11.3.1-.1.2-.2.2-.2c10.9-11.3 16.6-24.9 16.6-39.1 0-4.5-.6-9-1.8-13.4 58-45 91.9-114.2 92-187.5zM379.5 457L368 468.4l-.1.1c-8.2 8.4-19.2 13.6-30.9 14.4-2.5.2-5 .3-7.5.3-19.5 0-37.8-6-49.9-10.4-36-13.4-69.5-33.4-105.2-63.1-12.9-10.8-25.1-22.3-36.6-34.6-.2-.3-.5-.5-.7-.7-12.3-11.4-23.8-23.6-34.6-36.5-29.8-35.9-49.9-69.4-63.3-105.4-5.2-14.1-11.9-35.3-10.1-57.4.9-11.8 6-22.8 14.5-31l.1-.1L55 132.5c5.8-5.6 12.4-8.5 19.1-8.5s13 2.9 18.6 8.4l.4.4c5.3 4.9 10.6 10.3 15.5 15.3 2.6 2.7 5.2 5.4 7.8 8l23.8 23.8c12.4 12.4 12.4 26.6 0 39l-3.6 3.6c-1.2 1.2-2.4 2.5-3.7 3.8l-1.9 1.8c-5.6 5.7-11.5 11.6-17.6 17.2-4.6 4.2-6 10.9-3.4 16.5 5.7 12.7 13.7 25.2 25 39.5l.1.2c11.7 14.4 60.9 63.6 75.3 75.3l.1.1c14.3 11.3 26.9 19.3 39.5 25 5.7 2.6 12.3 1.2 16.5-3.4 5.6-6.1 11.5-12 17.3-17.6l1.9-1.8c1.2-1.2 2.4-2.4 3.7-3.6s2.4-2.4 3.6-3.6c6.1-6.1 12.8-9.3 19.5-9.3s13.4 3.2 19.5 9.3l23.8 23.8c2.6 2.6 5.3 5.2 8 7.8 5 4.9 10.4 10.1 15.3 15.5l.4.4c3.9 3.9 8.4 10.3 8.4 18.6.1 6.6-2.8 13.2-8.4 19z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M274.8 258.4h-36.5c.1-4.4 6.9-9 14.7-14.3 13.4-9.2 30-20.6 30-40.4 0-20.4-18.1-31.4-35.1-31.4-16.6 0-34.1 10.2-34.1 29.2 0 8.7 3.9 13.2 11.6 13.2 8.6 0 13.3-5 13.3-9.7 0-7.8 5.1-9.4 9.4-9.4 7.1 0 9.6 4.8 9.6 8.8 0 8-9.9 15.2-20.4 22.9-12.4 9.1-25.2 18.5-25.2 31.2v14c0 5.2 6.6 8.4 11.3 8.4h51.5c4.4 0 8.2-5.3 8.2-11.4s-3.8-11.1-8.3-11.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M351.9 234.9h-4.8v-8.7c0-5-5-8.2-12.7-8.2s-12.7 3.2-12.7 8.2v8.7H313l24.6-49.3c.5-1 .8-2.2.8-3.3 0-6.2-8.2-10-12.7-10-4.6-.1-8.8 2.5-10.7 6.6l-33.4 65.5c-.8 1.5-1.3 3.2-1.3 5 0 5.5 3.6 9.3 9 9.3h32.4v13.9c0 5.8 6.6 8.4 12.7 8.4s12.7-2.6 12.7-8.4v-13.9h4.8c4.3 0 8.4-5.8 8.4-11.9 0-5.7-2.6-11.9-8.4-11.9z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Telephone);


/***/ }),

/***/ 2415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Compare = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-violet me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M123.22 148.5A8 8 0 00116 144H19.36a8 8 0 00-8 8c0 57.34 46.94 104 104.66 104a104.67 104.67 0 0045.45-10.29 8 8 0 003.76-10.71z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M152 19a8 8 0 00-8 8v95.39a7.93 7.93 0 00.8 3.49l41.73 85.95a8 8 0 0010.65 3.73c36.29-17.48 58.82-53.19 58.82-93.19C256 65.36 209.34 19 152 19z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M112 104V8a8 8 0 00-8-8A104.13 104.13 0 000 104a8 8 0 008 8h96a8 8 0 008-8z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Compare);


/***/ }),

/***/ 9585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var DeliveryBox = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-green mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M172 20.57L55.79 80 9.6 57.32 123.71 1A9.43 9.43 0 01132 1zm74.27 36.75l-118.21 58.56-44.27-21.8-6.38-3.25L193.7 31.36l6.4 3.24z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M118.59 132.76L118.46 256 5.23 196.91A9.89 9.89 0 010 188.22V74.2l48 23.64v41.55a9.6 9.6 0 1019.2 0v-31.94l6.4 3.12zm137.28-58.43l-118.08 58.31-.13 123.23L256 194.08z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryBox);


/***/ }),

/***/ 2948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(5753)["default"]);
!function(a) {
    if (true) module.exports = a();
    else { var b; }
}(function() {
    var a;
    return (function() {
        function a(b, c, d) {
            function e(g, h) {
                if (!c[g]) {
                    if (!b[g]) {
                        var i = undefined;
                        if (!h && i) return require(g, !0);
                        if (f) return f(g, !0);
                        var j = new Error("Cannot find module '" + g + "'");
                        throw j.code = "MODULE_NOT_FOUND", j;
                    }
                    var k = c[g] = {
                        exports: {}
                    };
                    b[g][0].call(k.exports, function(a) {
                        return e(b[g][1][a] || a);
                    }, k, k.exports, a, b, c, d);
                }
                return c[g].exports;
            }
            for(var f = undefined, g = 0; g < d.length; g++)e(d[g]);
            return e;
        }
        return a;
    })()({
        1: [
            function(b, c, d) {
                !function(b, e) {
                    "object" == typeof d && "object" == typeof c ? c.exports = e() : "function" == typeof a && a.amd ? a("shifty", [], e) : "object" == typeof d ? d.shifty = e() : b.shifty = e();
                }(window, function() {
                    return function(a) {
                        function b(d) {
                            if (c[d]) return c[d].exports;
                            var e = c[d] = {
                                i: d,
                                l: !1,
                                exports: {}
                            };
                            return a[d].call(e.exports, e, e.exports, b), e.l = !0, e.exports;
                        }
                        var c = {};
                        return b.m = a, b.c = c, b.d = function(a, c, d) {
                            b.o(a, c) || Object.defineProperty(a, c, {
                                enumerable: !0,
                                get: d
                            });
                        }, b.r = function(a) {
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(a, "__esModule", {
                                value: !0
                            });
                        }, b.t = function(a, c) {
                            if (1 & c && (a = b(a)), 8 & c) return a;
                            if (4 & c && "object" == typeof a && a && a.__esModule) return a;
                            var d = Object.create(null);
                            if (b.r(d), Object.defineProperty(d, "default", {
                                enumerable: !0,
                                value: a
                            }), 2 & c && "string" != typeof a) for(var e in a)b.d(d, e, (function(b) {
                                return a[b];
                            }).bind(null, e));
                            return d;
                        }, b.n = function(a) {
                            var c = a && a.__esModule ? function c() {
                                return a.default;
                            } : function() {
                                return a;
                            };
                            return b.d(c, "a", c), c;
                        }, b.o = function(a, b) {
                            return Object.prototype.hasOwnProperty.call(a, b);
                        }, b.p = "", b(b.s = 3);
                    }([
                        function(a, b, c) {
                            "use strict";
                            (function(a) {
                                var d = function d(a, b) {
                                    for(var _$c = 0; _$c < b.length; _$c++){
                                        var d1 = b[_$c];
                                        d1.enumerable = d1.enumerable || !1, d1.configurable = !0, "value" in d1 && (d1.writable = !0), Object.defineProperty(a, d1.key, d1);
                                    }
                                };
                                var f = function f(a, b) {
                                    var _$c = Object.keys(a);
                                    if (Object.getOwnPropertySymbols) {
                                        var d = Object.getOwnPropertySymbols(a);
                                        b && (d = d.filter(function(b) {
                                            return Object.getOwnPropertyDescriptor(a, b).enumerable;
                                        })), _$c.push.apply(_$c, d);
                                    }
                                    return _$c;
                                };
                                var g = function g(a) {
                                    var _arguments = arguments, _loop = function(_$b) {
                                        var _$c = null != _arguments[_$b] ? _arguments[_$b] : {};
                                        _$b % 2 ? f(Object(_$c), !0).forEach(function(b) {
                                            h(a, b, _$c[b]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(_$c)) : f(Object(_$c)).forEach(function(b) {
                                            Object.defineProperty(a, b, Object.getOwnPropertyDescriptor(_$c, b));
                                        });
                                    };
                                    for(var _$b = 1; _$b < arguments.length; _$b++)_loop(_$b);
                                    return a;
                                };
                                var h = function h(a, b, c) {
                                    return b in a ? Object.defineProperty(a, b, {
                                        value: c,
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0
                                    }) : a[b] = c, a;
                                };
                                var i = function i() {
                                    var _$a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$b = new v(), _$c = _$b.tween(_$a);
                                    return _$c.tweenable = _$b, _$c;
                                };
                                function e(a) {
                                    return (e = "function" == typeof Symbol && "symbol" == _typeOf(Symbol.iterator) ? function e(a) {
                                        return typeof a === "undefined" ? "undefined" : _typeOf(a);
                                    } : function(a) {
                                        return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a === "undefined" ? "undefined" : _typeOf(a);
                                    })(a);
                                }
                                c.d(b, "e", function() {
                                    return q;
                                }), c.d(b, "c", function() {
                                    return s;
                                }), c.d(b, "b", function() {
                                    return t;
                                }), c.d(b, "a", function() {
                                    return v;
                                }), c.d(b, "d", function() {
                                    return i;
                                });
                                var j = c(1), k =  true ? window : 0, l = k.requestAnimationFrame || k.webkitRequestAnimationFrame || k.oRequestAnimationFrame || k.msRequestAnimationFrame || k.mozCancelRequestAnimationFrame && k.mozRequestAnimationFrame || setTimeout, m = function m() {}, n = null, o = null, p = g({}, j), q = function q(a, b, c, d, e, f, g) {
                                    var h = a < f ? 0 : (a - f) / e;
                                    for(var i in b){
                                        var j = g[i], k = j.call ? j : p[j], l = c[i];
                                        b[i] = l + (d[i] - l) * k(h);
                                    }
                                    return b;
                                }, r = function r(a, b) {
                                    var _$c = a._attachment, d = a._currentState, e = a._delay, f = a._easing, g = a._originalState, h = a._duration, i = a._step, j = a._targetState, k = a._timestamp, l = k + e + h, m = b > l ? l : b, n = h - (l - m);
                                    m >= l ? (i(j, _$c, n), a.stop(!0)) : (a._applyFilter("beforeTween"), m < k + e ? (m = 1, h = 1, k = 1) : k += e, q(m, d, g, j, h, k, f), a._applyFilter("afterTween"), i(d, _$c, n));
                                }, s = function s() {
                                    for(var _$a = v.now(), _$b = n; _$b;){
                                        var _$c = _$b._next;
                                        r(_$b, _$a), _$b = _$c;
                                    }
                                }, t = function t(a) {
                                    var _$b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "linear", _$c = {}, d = e(_$b);
                                    if ("string" === d || "function" === d) for(var f in a)_$c[f] = _$b;
                                    else for(var g in a)_$c[g] = _$b[g] || "linear";
                                    return _$c;
                                }, u = function u(a) {
                                    if (a === n) (n = a._next) ? n._previous = null : o = null;
                                    else if (a === o) (o = a._previous) ? o._next = null : n = null;
                                    else {
                                        var _$b = a._previous, _$c = a._next;
                                        _$b._next = _$c, _$c._previous = _$b;
                                    }
                                    a._previous = a._next = null;
                                }, v = function() {
                                    function a() {
                                        var _$b = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                                        !function(a, b) {
                                            if (!_instanceof(a, b)) throw new TypeError("Cannot call a class as a function");
                                        }(this, a), this._currentState = _$b, this._configured = !1, this._filters = [], this._timestamp = null, this._next = null, this._previous = null, _$c && this.setConfig(_$c);
                                    }
                                    var _$b, _$c, e;
                                    return _$b = a, (_$c = [
                                        {
                                            key: "_applyFilter",
                                            value: function value(a) {
                                                var _$b = !0, _$c = !1, d = void 0;
                                                try {
                                                    for(var e, f = this._filters[Symbol.iterator](); !(_$b = (e = f.next()).done); _$b = !0){
                                                        var g = e.value[a];
                                                        g && g(this);
                                                    }
                                                } catch (a1) {
                                                    _$c = !0, d = a1;
                                                } finally{
                                                    try {
                                                        _$b || null == f.return || f.return();
                                                    } finally{
                                                        if (_$c) throw d;
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            key: "tween",
                                            value: function value() {
                                                var _$b = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, _$c = this._attachment, d = this._configured;
                                                return !_$b && d || this.setConfig(_$b), this._pausedAtTime = null, this._timestamp = a.now(), this._start(this.get(), _$c), this.resume();
                                            }
                                        },
                                        {
                                            key: "setConfig",
                                            value: function value() {
                                                var _$b = this, _$c = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, d = _$c.attachment, e = _$c.delay, f = void 0 === e ? 0 : e, h = _$c.duration, i = void 0 === h ? 500 : h, j = _$c.easing, k = _$c.from, l = _$c.promise, n = void 0 === l ? Promise : l, o = _$c.start, p = void 0 === o ? m : o, q = _$c.step, r = void 0 === q ? m : q, s = _$c.to;
                                                this._configured = !0, this._attachment = d, this._isPlaying = !1, this._pausedAtTime = null, this._scheduleId = null, this._delay = f, this._start = p, this._step = r, this._duration = i, this._currentState = g({}, k || this.get()), this._originalState = this.get(), this._targetState = g({}, s || this.get());
                                                var u = this._currentState;
                                                this._targetState = g({}, u, {}, this._targetState), this._easing = t(u, j);
                                                var v = a.filters;
                                                for(var w in this._filters.length = 0, v)v[w].doesApply(this) && this._filters.push(v[w]);
                                                return this._applyFilter("tweenCreated"), this._promise = new n(function(a, c) {
                                                    _$b._resolve = a, _$b._reject = c;
                                                }), this._promise.catch(m), this;
                                            }
                                        },
                                        {
                                            key: "get",
                                            value: function value() {
                                                return g({}, this._currentState);
                                            }
                                        },
                                        {
                                            key: "set",
                                            value: function value(a) {
                                                this._currentState = a;
                                            }
                                        },
                                        {
                                            key: "pause",
                                            value: function value() {
                                                if (this._isPlaying) return this._pausedAtTime = a.now(), this._isPlaying = !1, u(this), this;
                                            }
                                        },
                                        {
                                            key: "resume",
                                            value: function value() {
                                                if (null === this._timestamp) return this.tween();
                                                if (this._isPlaying) return this._promise;
                                                var _$b = a.now();
                                                return this._pausedAtTime && (this._timestamp += _$b - this._pausedAtTime, this._pausedAtTime = null), this._isPlaying = !0, null === n ? (n = this, o = this, function a() {
                                                    n && (l.call(k, a, 1e3 / 60), s());
                                                }()) : (this._previous = o, o._next = this, o = this), this._promise;
                                            }
                                        },
                                        {
                                            key: "seek",
                                            value: function value(b) {
                                                b = Math.max(b, 0);
                                                var _$c = a.now();
                                                return this._timestamp + b === 0 ? this : (this._timestamp = _$c - b, this._isPlaying || r(this, _$c), this);
                                            }
                                        },
                                        {
                                            key: "stop",
                                            value: function value() {
                                                var _$a = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], _$b = this._attachment, _$c = this._currentState, d = this._easing, e = this._originalState, f = this._targetState;
                                                if (this._isPlaying) return this._isPlaying = !1, u(this), _$a ? (this._applyFilter("beforeTween"), q(1, _$c, e, f, 1, 0, d), this._applyFilter("afterTween"), this._applyFilter("afterTweenEnd"), this._resolve(_$c, _$b)) : this._reject(_$c, _$b), this;
                                            }
                                        },
                                        {
                                            key: "isPlaying",
                                            value: function value() {
                                                return this._isPlaying;
                                            }
                                        },
                                        {
                                            key: "setScheduleFunction",
                                            value: function value(b) {
                                                a.setScheduleFunction(b);
                                            }
                                        },
                                        {
                                            key: "dispose",
                                            value: function value() {
                                                for(var _$a in this)delete this[_$a];
                                            }
                                        }
                                    ]) && d(_$b.prototype, _$c), e && d(_$b, e), a;
                                }();
                                v.setScheduleFunction = function(a) {
                                    return l = a;
                                }, v.formulas = p, v.filters = {}, v.now = Date.now || function() {
                                    return +new Date();
                                };
                            }).call(this, c(2));
                        },
                        function(a, b, c) {
                            "use strict";
                            c.r(b), c.d(b, "linear", function() {
                                return d;
                            }), c.d(b, "easeInQuad", function() {
                                return e;
                            }), c.d(b, "easeOutQuad", function() {
                                return f;
                            }), c.d(b, "easeInOutQuad", function() {
                                return g;
                            }), c.d(b, "easeInCubic", function() {
                                return h;
                            }), c.d(b, "easeOutCubic", function() {
                                return i;
                            }), c.d(b, "easeInOutCubic", function() {
                                return j;
                            }), c.d(b, "easeInQuart", function() {
                                return k;
                            }), c.d(b, "easeOutQuart", function() {
                                return l;
                            }), c.d(b, "easeInOutQuart", function() {
                                return m;
                            }), c.d(b, "easeInQuint", function() {
                                return n;
                            }), c.d(b, "easeOutQuint", function() {
                                return o;
                            }), c.d(b, "easeInOutQuint", function() {
                                return p;
                            }), c.d(b, "easeInSine", function() {
                                return q;
                            }), c.d(b, "easeOutSine", function() {
                                return r;
                            }), c.d(b, "easeInOutSine", function() {
                                return s;
                            }), c.d(b, "easeInExpo", function() {
                                return t;
                            }), c.d(b, "easeOutExpo", function() {
                                return u;
                            }), c.d(b, "easeInOutExpo", function() {
                                return v;
                            }), c.d(b, "easeInCirc", function() {
                                return w;
                            }), c.d(b, "easeOutCirc", function() {
                                return x;
                            }), c.d(b, "easeInOutCirc", function() {
                                return y;
                            }), c.d(b, "easeOutBounce", function() {
                                return z;
                            }), c.d(b, "easeInBack", function() {
                                return A;
                            }), c.d(b, "easeOutBack", function() {
                                return B;
                            }), c.d(b, "easeInOutBack", function() {
                                return C;
                            }), c.d(b, "elastic", function() {
                                return D;
                            }), c.d(b, "swingFromTo", function() {
                                return E;
                            }), c.d(b, "swingFrom", function() {
                                return F;
                            }), c.d(b, "swingTo", function() {
                                return G;
                            }), c.d(b, "bounce", function() {
                                return H;
                            }), c.d(b, "bouncePast", function() {
                                return I;
                            }), c.d(b, "easeFromTo", function() {
                                return J;
                            }), c.d(b, "easeFrom", function() {
                                return K;
                            }), c.d(b, "easeTo", function() {
                                return L;
                            });
                            var d = function d(a) {
                                return a;
                            }, e = function e(a) {
                                return Math.pow(a, 2);
                            }, f = function f(a) {
                                return -(Math.pow(a - 1, 2) - 1);
                            }, g = function g(a) {
                                return (a /= 0.5) < 1 ? 0.5 * Math.pow(a, 2) : -0.5 * ((a -= 2) * a - 2);
                            }, h = function h(a) {
                                return Math.pow(a, 3);
                            }, i = function i(a) {
                                return Math.pow(a - 1, 3) + 1;
                            }, j = function j(a) {
                                return (a /= 0.5) < 1 ? 0.5 * Math.pow(a, 3) : 0.5 * (Math.pow(a - 2, 3) + 2);
                            }, k = function k(a) {
                                return Math.pow(a, 4);
                            }, l = function l(a) {
                                return -(Math.pow(a - 1, 4) - 1);
                            }, m = function m(a) {
                                return (a /= 0.5) < 1 ? 0.5 * Math.pow(a, 4) : -0.5 * ((a -= 2) * Math.pow(a, 3) - 2);
                            }, n = function n(a) {
                                return Math.pow(a, 5);
                            }, o = function o(a) {
                                return Math.pow(a - 1, 5) + 1;
                            }, p = function p(a) {
                                return (a /= 0.5) < 1 ? 0.5 * Math.pow(a, 5) : 0.5 * (Math.pow(a - 2, 5) + 2);
                            }, q = function q(a) {
                                return 1 - Math.cos(a * (Math.PI / 2));
                            }, r = function r(a) {
                                return Math.sin(a * (Math.PI / 2));
                            }, s = function s(a) {
                                return -0.5 * (Math.cos(Math.PI * a) - 1);
                            }, t = function t(a) {
                                return 0 === a ? 0 : Math.pow(2, 10 * (a - 1));
                            }, u = function u(a) {
                                return 1 === a ? 1 : 1 - Math.pow(2, -10 * a);
                            }, v = function v(a) {
                                return 0 === a ? 0 : 1 === a ? 1 : (a /= 0.5) < 1 ? 0.5 * Math.pow(2, 10 * (a - 1)) : 0.5 * (2 - Math.pow(2, -10 * --a));
                            }, w = function w(a) {
                                return -(Math.sqrt(1 - a * a) - 1);
                            }, x = function x(a) {
                                return Math.sqrt(1 - Math.pow(a - 1, 2));
                            }, y = function y(a) {
                                return (a /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - a * a) - 1) : 0.5 * (Math.sqrt(1 - (a -= 2) * a) + 1);
                            }, z = function z(a) {
                                return a < 1 / 2.75 ? 7.5625 * a * a : a < 2 / 2.75 ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : a < 2.5 / 2.75 ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375;
                            }, A = function A(a) {
                                var _$b = 1.70158;
                                return a * a * ((_$b + 1) * a - _$b);
                            }, B = function B(a) {
                                var _$b = 1.70158;
                                return (a -= 1) * a * ((_$b + 1) * a + _$b) + 1;
                            }, C = function C(a) {
                                var _$b = 1.70158;
                                return (a /= 0.5) < 1 ? a * a * ((1 + (_$b *= 1.525)) * a - _$b) * 0.5 : 0.5 * ((a -= 2) * a * ((1 + (_$b *= 1.525)) * a + _$b) + 2);
                            }, D = function D(a) {
                                return -1 * Math.pow(4, -8 * a) * Math.sin((6 * a - 1) * (2 * Math.PI) / 2) + 1;
                            }, E = function E(a) {
                                var _$b = 1.70158;
                                return (a /= 0.5) < 1 ? a * a * ((1 + (_$b *= 1.525)) * a - _$b) * 0.5 : 0.5 * ((a -= 2) * a * ((1 + (_$b *= 1.525)) * a + _$b) + 2);
                            }, F = function F(a) {
                                var _$b = 1.70158;
                                return a * a * ((_$b + 1) * a - _$b);
                            }, G = function G(a) {
                                var _$b = 1.70158;
                                return (a -= 1) * a * ((_$b + 1) * a + _$b) + 1;
                            }, H = function H(a) {
                                return a < 1 / 2.75 ? 7.5625 * a * a : a < 2 / 2.75 ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : a < 2.5 / 2.75 ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375;
                            }, I = function I(a) {
                                return a < 1 / 2.75 ? 7.5625 * a * a : a < 2 / 2.75 ? 2 - (7.5625 * (a -= 1.5 / 2.75) * a + 0.75) : a < 2.5 / 2.75 ? 2 - (7.5625 * (a -= 2.25 / 2.75) * a + 0.9375) : 2 - (7.5625 * (a -= 2.625 / 2.75) * a + 0.984375);
                            }, J = function J(a) {
                                return (a /= 0.5) < 1 ? 0.5 * Math.pow(a, 4) : -0.5 * ((a -= 2) * Math.pow(a, 3) - 2);
                            }, K = function K(a) {
                                return Math.pow(a, 4);
                            }, L = function L(a) {
                                return Math.pow(a, 0.25);
                            };
                        },
                        function(a, b) {
                            var c;
                            c = function() {
                                return this;
                            }();
                            try {
                                c = c || new Function("return this")();
                            } catch (a1) {
                                 true && (c = window);
                            }
                            a.exports = c;
                        },
                        function(a, b, c) {
                            "use strict";
                            var d = function d(a) {
                                return parseInt(a, 16);
                            };
                            var e = function e(a) {
                                var _$b = a._currentState;
                                [
                                    _$b,
                                    a._originalState,
                                    a._targetState
                                ].forEach(B), a._tokenData = E(_$b);
                            };
                            var f = function f(a) {
                                var _$b = a._currentState, _$c = a._originalState, d = a._targetState, e = a._easing, f1 = a._tokenData;
                                K(e, f1), [
                                    _$b,
                                    _$c,
                                    d
                                ].forEach(function(a) {
                                    return F(a, f1);
                                });
                            };
                            var g = function g(a) {
                                var _$b = a._currentState, _$c = a._originalState, d = a._targetState, e = a._easing, f = a._tokenData;
                                [
                                    _$b,
                                    _$c,
                                    d
                                ].forEach(function(a) {
                                    return J(a, f);
                                }), L(e, f);
                            };
                            var h = function h(a, b) {
                                var _$c = Object.keys(a);
                                if (Object.getOwnPropertySymbols) {
                                    var d = Object.getOwnPropertySymbols(a);
                                    b && (d = d.filter(function(b) {
                                        return Object.getOwnPropertyDescriptor(a, b).enumerable;
                                    })), _$c.push.apply(_$c, d);
                                }
                                return _$c;
                            };
                            var i = function i(a) {
                                var _arguments = arguments, _loop = function(_$b) {
                                    var _$c = null != _arguments[_$b] ? _arguments[_$b] : {};
                                    _$b % 2 ? h(Object(_$c), !0).forEach(function(b) {
                                        j(a, b, _$c[b]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(_$c)) : h(Object(_$c)).forEach(function(b) {
                                        Object.defineProperty(a, b, Object.getOwnPropertyDescriptor(_$c, b));
                                    });
                                };
                                for(var _$b = 1; _$b < arguments.length; _$b++)_loop(_$b);
                                return a;
                            };
                            var j = function j(a, b, c) {
                                return b in a ? Object.defineProperty(a, b, {
                                    value: c,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : a[b] = c, a;
                            };
                            var k = function k(a) {
                                return function(a) {
                                    if (Array.isArray(a)) {
                                        for(var _$b = 0, _$c = new Array(a.length); _$b < a.length; _$b++)_$c[_$b] = a[_$b];
                                        return _$c;
                                    }
                                }(a) || function(a) {
                                    if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
                                }(a) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                                }();
                            };
                            var l = function l(a, b) {
                                for(var _$c = 0; _$c < b.length; _$c++){
                                    var d = b[_$c];
                                    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(a, d.key, d);
                                }
                            };
                            var m = function m(a, b) {
                                var _$c = b.get(a);
                                if (!_$c) throw new TypeError("attempted to get private field on non-instance");
                                return _$c.get ? _$c.get.call(a) : _$c.value;
                            };
                            var n = function n(a, b, c, d, e, f) {
                                var g, h, i = 0, j = 0, k = 0, l = 0, m = 0, n1 = 0, o = function o(a) {
                                    return ((i * a + j) * a + k) * a;
                                }, p = function p(a) {
                                    return (3 * i * a + 2 * j) * a + k;
                                }, q = function q(a) {
                                    return a >= 0 ? a : 0 - a;
                                };
                                return i = 1 - (k = 3 * b) - (j = 3 * (d - b) - k), l = 1 - (n1 = 3 * c) - (m = 3 * (e - c) - n1), g = a, h = function(a) {
                                    return 1 / (200 * a);
                                }(f), function(a) {
                                    return ((l * a + m) * a + n1) * a;
                                }(function(a, b) {
                                    var _$c, _$d, _$e, _$f, g, h;
                                    for(_$e = a, h = 0; h < 8; h++){
                                        if (_$f = o(_$e) - a, q(_$f) < b) return _$e;
                                        if (g = p(_$e), q(g) < 1e-6) break;
                                        _$e -= _$f / g;
                                    }
                                    if ((_$e = a) < (_$c = 0)) return _$c;
                                    if (_$e > (_$d = 1)) return _$d;
                                    for(; _$c < _$d;){
                                        if (_$f = o(_$e), q(_$f - a) < b) return _$e;
                                        a > _$f ? _$c = _$e : _$d = _$e, _$e = 0.5 * (_$d - _$c) + _$c;
                                    }
                                    return _$e;
                                }(g, h));
                            };
                            c.r(b);
                            var o = {};
                            c.r(o), c.d(o, "doesApply", function() {
                                return M;
                            }), c.d(o, "tweenCreated", function() {
                                return e;
                            }), c.d(o, "beforeTween", function() {
                                return f;
                            }), c.d(o, "afterTween", function() {
                                return g;
                            });
                            var p, q, r = c(0), s = /(\d|-|\.)/, t = /([^\-0-9.]+)/g, u = /[0-9.-]+/g, v = (p = u.source, q = /,\s*/.source, new RegExp("rgb\\(".concat(p).concat(q).concat(p).concat(q).concat(p, "\\)"), "g")), w = /^.*\(/, x = /#([0-9]|[a-f]){3,6}/gi, y = function y(a, b) {
                                return a.map(function(a, c) {
                                    return "_".concat(b, "_").concat(c);
                                });
                            }, z = function z(a) {
                                return "rgb(".concat((_$b = a, 3 === (_$b = _$b.replace(/#/, "")).length && (_$b = (_$b = _$b.split(""))[0] + _$b[0] + _$b[1] + _$b[1] + _$b[2] + _$b[2]), [
                                    d(_$b.substr(0, 2)),
                                    d(_$b.substr(2, 2)),
                                    d(_$b.substr(4, 2))
                                ]).join(","), ")");
                                var _$b;
                            }, A = function A(a, b, c) {
                                var d = b.match(a), e = b.replace(a, "VAL");
                                return d && d.forEach(function(a) {
                                    return e = e.replace("VAL", c(a));
                                }), e;
                            }, B = function B(a) {
                                for(var _$b in a){
                                    var _$c = a[_$b];
                                    "string" == typeof _$c && _$c.match(x) && (a[_$b] = A(x, _$c, z));
                                }
                            }, C = function C(a) {
                                var _$b = a.match(u).map(Math.floor);
                                return "".concat(a.match(w)[0]).concat(_$b.join(","), ")");
                            }, D = function D(a) {
                                return a.match(u);
                            }, E = function E(a) {
                                var _$b, _$c, d = {};
                                for(var e in a){
                                    var f = a[e];
                                    "string" == typeof f && (d[e] = {
                                        formatString: (_$b = f, _$c = void 0, _$c = _$b.match(t), _$c ? (1 === _$c.length || _$b.charAt(0).match(s)) && _$c.unshift("") : _$c = [
                                            "",
                                            ""
                                        ], _$c.join("VAL")),
                                        chunkNames: y(D(f), e)
                                    });
                                }
                                return d;
                            }, F = function F(a, b) {
                                var _$c = function _$c(c) {
                                    D(a[c]).forEach(function(d, e) {
                                        return a[b[c].chunkNames[e]] = +d;
                                    }), delete a[c];
                                };
                                for(var d in b)_$c(d);
                            }, G = function G(a, b) {
                                var _$c = {};
                                return b.forEach(function(b) {
                                    _$c[b] = a[b], delete a[b];
                                }), _$c;
                            }, H = function H(a, b) {
                                return b.map(function(b) {
                                    return a[b];
                                });
                            }, I = function I(a, b) {
                                return b.forEach(function(b) {
                                    return a = a.replace("VAL", +b.toFixed(4));
                                }), a;
                            }, J = function J(a, b) {
                                for(var _$c in b){
                                    var d = b[_$c], e = d.chunkNames, f = d.formatString, g = I(f, H(G(a, e), e));
                                    a[_$c] = A(v, g, C);
                                }
                            }, K = function K(a, b) {
                                var _$c = function _$c(c) {
                                    var d = b[c].chunkNames, e = a[c];
                                    if ("string" == typeof e) {
                                        var f = e.split(" "), g = f[f.length - 1];
                                        d.forEach(function(b, c) {
                                            return a[b] = f[c] || g;
                                        });
                                    } else d.forEach(function(b) {
                                        return a[b] = e;
                                    });
                                    delete a[c];
                                };
                                for(var d in b)_$c(d);
                            }, L = function L(a, b) {
                                for(var _$c in b){
                                    var d = b[_$c].chunkNames, e = a[d[0]];
                                    a[_$c] = "string" == typeof e ? d.map(function(b) {
                                        var _$c = a[b];
                                        return delete a[b], _$c;
                                    }).join(" ") : e;
                                }
                            }, M = function M(a) {
                                var _$b = a._currentState;
                                return Object.keys(_$b).some(function(a) {
                                    return "string" == typeof _$b[a];
                                });
                            }, N = new r.a(), O = r.a.filters, P = function P(a, b, c, d) {
                                var e = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, f = i({}, a), g = Object(r.b)(a, d);
                                for(var h in N._filters.length = 0, N.set({}), N._currentState = f, N._originalState = a, N._targetState = b, N._easing = g, O)O[h].doesApply(N) && N._filters.push(O[h]);
                                N._applyFilter("tweenCreated"), N._applyFilter("beforeTween");
                                var j = Object(r.e)(c, f, a, b, 1, e, g);
                                return N._applyFilter("afterTween"), j;
                            }, Q = function() {
                                function a() {
                                    !function(a, b) {
                                        if (!_instanceof(a, b)) throw new TypeError("Cannot call a class as a function");
                                    }(this, a), R.set(this, {
                                        writable: !0,
                                        value: []
                                    });
                                    for(var _$b = arguments.length, _$c = new Array(_$b), d = 0; d < _$b; d++)_$c[d] = arguments[d];
                                    _$c.forEach(this.add.bind(this));
                                }
                                var _$b, _$c, d;
                                return _$b = a, (_$c = [
                                    {
                                        key: "add",
                                        value: function value(a) {
                                            return m(this, R).push(a), a;
                                        }
                                    },
                                    {
                                        key: "remove",
                                        value: function value(a) {
                                            var _$b = m(this, R).indexOf(a);
                                            return ~_$b && m(this, R).splice(_$b, 1), a;
                                        }
                                    },
                                    {
                                        key: "empty",
                                        value: function value() {
                                            return this.tweenables.map(this.remove.bind(this));
                                        }
                                    },
                                    {
                                        key: "isPlaying",
                                        value: function value() {
                                            return m(this, R).some(function(a) {
                                                return a.isPlaying();
                                            });
                                        }
                                    },
                                    {
                                        key: "play",
                                        value: function value() {
                                            return m(this, R).forEach(function(a) {
                                                return a.tween();
                                            }), this;
                                        }
                                    },
                                    {
                                        key: "pause",
                                        value: function value() {
                                            return m(this, R).forEach(function(a) {
                                                return a.pause();
                                            }), this;
                                        }
                                    },
                                    {
                                        key: "resume",
                                        value: function value() {
                                            return m(this, R).forEach(function(a) {
                                                return a.resume();
                                            }), this;
                                        }
                                    },
                                    {
                                        key: "stop",
                                        value: function value(a) {
                                            return m(this, R).forEach(function(b) {
                                                return b.stop(a);
                                            }), this;
                                        }
                                    },
                                    {
                                        key: "tweenables",
                                        get: function get() {
                                            return k(m(this, R));
                                        }
                                    },
                                    {
                                        key: "promises",
                                        get: function get() {
                                            return m(this, R).map(function(a) {
                                                return a._promise;
                                            });
                                        }
                                    }
                                ]) && l(_$b.prototype, _$c), d && l(_$b, d), a;
                            }(), R = new WeakMap(), S = function S(a, b, c, d, e) {
                                var f = function(a, b, c, d) {
                                    return function(e) {
                                        return n(e, a, b, c, d, 1);
                                    };
                                }(b, c, d, e);
                                return f.displayName = a, f.x1 = b, f.y1 = c, f.x2 = d, f.y2 = e, r.a.formulas[a] = f;
                            }, T = function T(a) {
                                return delete r.a.formulas[a];
                            };
                            c.d(b, "processTweens", function() {
                                return r.c;
                            }), c.d(b, "Tweenable", function() {
                                return r.a;
                            }), c.d(b, "tween", function() {
                                return r.d;
                            }), c.d(b, "interpolate", function() {
                                return P;
                            }), c.d(b, "Scene", function() {
                                return Q;
                            }), c.d(b, "setBezierFunction", function() {
                                return S;
                            }), c.d(b, "unsetBezierFunction", function() {
                                return T;
                            }), r.a.filters.token = o;
                        }
                    ]);
                });
            },
            {}
        ],
        2: [
            function(a, b, c) {
                var d = a("./shape"), e = a("./utils"), f = function f(a, b) {
                    this._pathTemplate = "M 50,50 m 0,-{radius} a {radius},{radius} 0 1 1 0,{2radius} a {radius},{radius} 0 1 1 0,-{2radius}", this.containerAspectRatio = 1, d.apply(this, arguments);
                };
                f.prototype = new d(), f.prototype.constructor = f, f.prototype._pathString = function(a) {
                    var _$b = a.strokeWidth;
                    a.trailWidth && a.trailWidth > a.strokeWidth && (_$b = a.trailWidth);
                    var c = 50 - _$b / 2;
                    return e.render(this._pathTemplate, {
                        radius: c,
                        "2radius": 2 * c
                    });
                }, f.prototype._trailString = function(a) {
                    return this._pathString(a);
                }, b.exports = f;
            },
            {
                "./shape": 7,
                "./utils": 9
            }
        ],
        3: [
            function(a, b, c) {
                var d = a("./shape"), e = a("./utils"), f = function f(a, b) {
                    this._pathTemplate = b.vertical ? "M {center},100 L {center},0" : "M 0,{center} L 100,{center}", d.apply(this, arguments);
                };
                f.prototype = new d(), f.prototype.constructor = f, f.prototype._initializeSvg = function(a, b) {
                    var c = b.vertical ? "0 0 " + b.strokeWidth + " 100" : "0 0 100 " + b.strokeWidth;
                    a.setAttribute("viewBox", c), a.setAttribute("preserveAspectRatio", "none");
                }, f.prototype._pathString = function(a) {
                    return e.render(this._pathTemplate, {
                        center: a.strokeWidth / 2
                    });
                }, f.prototype._trailString = function(a) {
                    return this._pathString(a);
                }, b.exports = f;
            },
            {
                "./shape": 7,
                "./utils": 9
            }
        ],
        4: [
            function(a, b, c) {
                b.exports = {
                    Line: a("./line"),
                    Circle: a("./circle"),
                    SemiCircle: a("./semicircle"),
                    Square: a("./square"),
                    Path: a("./path"),
                    Shape: a("./shape"),
                    utils: a("./utils")
                };
            },
            {
                "./circle": 2,
                "./line": 3,
                "./path": 5,
                "./semicircle": 6,
                "./shape": 7,
                "./square": 8,
                "./utils": 9
            }
        ],
        5: [
            function(a, b, c) {
                var d = a("shifty"), e = a("./utils"), f = d.Tweenable, g = {
                    easeIn: "easeInCubic",
                    easeOut: "easeOutCubic",
                    easeInOut: "easeInOutCubic"
                }, h = function a(b, c) {
                    if (!_instanceof(this, a)) throw new Error("Constructor was called without new keyword");
                    c = e.extend({
                        delay: 0,
                        duration: 800,
                        easing: "linear",
                        from: {},
                        to: {},
                        step: function step() {}
                    }, c);
                    var d;
                    d = e.isString(b) ? document.querySelector(b) : b, this.path = d, this._opts = c, this._tweenable = null;
                    var f = this.path.getTotalLength();
                    this.path.style.strokeDasharray = f + " " + f, this.set(0);
                };
                h.prototype.value = function() {
                    var _$a = this._getComputedDashOffset(), _$b = this.path.getTotalLength(), c = 1 - _$a / _$b;
                    return parseFloat(c.toFixed(6), 10);
                }, h.prototype.set = function(a) {
                    this.stop(), this.path.style.strokeDashoffset = this._progressToOffset(a);
                    var _$b = this._opts.step;
                    if (e.isFunction(_$b)) {
                        var c = this._easing(this._opts.easing);
                        _$b(this._calculateTo(a, c), this._opts.shape || this, this._opts.attachment);
                    }
                }, h.prototype.stop = function() {
                    this._stopTween(), this.path.style.strokeDashoffset = this._getComputedDashOffset();
                }, h.prototype.animate = function(a, b, c) {
                    b = b || {}, e.isFunction(b) && (c = b, b = {});
                    var d = e.extend({}, b), g = e.extend({}, this._opts);
                    b = e.extend(g, b);
                    var h = this._easing(b.easing), i = this._resolveFromAndTo(a, h, d);
                    this.stop(), this.path.getBoundingClientRect();
                    var j = this._getComputedDashOffset(), k = this._progressToOffset(a), l = this;
                    this._tweenable = new f(), this._tweenable.tween({
                        from: e.extend({
                            offset: j
                        }, i.from),
                        to: e.extend({
                            offset: k
                        }, i.to),
                        duration: b.duration,
                        delay: b.delay,
                        easing: h,
                        step: function step(a) {
                            l.path.style.strokeDashoffset = a.offset;
                            var _$c = b.shape || l;
                            b.step(a, _$c, b.attachment);
                        }
                    }).then(function(a) {
                        e.isFunction(c) && c();
                    }).catch(function(a) {
                        throw console.error("Error in tweening:", a), a;
                    });
                }, h.prototype._getComputedDashOffset = function() {
                    var _$a = window.getComputedStyle(this.path, null);
                    return parseFloat(_$a.getPropertyValue("stroke-dashoffset"), 10);
                }, h.prototype._progressToOffset = function(a) {
                    var _$b = this.path.getTotalLength();
                    return _$b - a * _$b;
                }, h.prototype._resolveFromAndTo = function(a, b, c) {
                    return c.from && c.to ? {
                        from: c.from,
                        to: c.to
                    } : {
                        from: this._calculateFrom(b),
                        to: this._calculateTo(a, b)
                    };
                }, h.prototype._calculateFrom = function(a) {
                    return d.interpolate(this._opts.from, this._opts.to, this.value(), a);
                }, h.prototype._calculateTo = function(a, b) {
                    return d.interpolate(this._opts.from, this._opts.to, a, b);
                }, h.prototype._stopTween = function() {
                    null !== this._tweenable && (this._tweenable.stop(!0), this._tweenable = null);
                }, h.prototype._easing = function(a) {
                    return g.hasOwnProperty(a) ? g[a] : a;
                }, b.exports = h;
            },
            {
                "./utils": 9,
                shifty: 1
            }
        ],
        6: [
            function(a, b, c) {
                var d = a("./shape"), e = a("./circle"), f = a("./utils"), g = function g(a, b) {
                    this._pathTemplate = "M 50,50 m -{radius},0 a {radius},{radius} 0 1 1 {2radius},0", this.containerAspectRatio = 2, d.apply(this, arguments);
                };
                g.prototype = new d(), g.prototype.constructor = g, g.prototype._initializeSvg = function(a, b) {
                    a.setAttribute("viewBox", "0 0 100 50");
                }, g.prototype._initializeTextContainer = function(a, b, c) {
                    a.text.style && (c.style.top = "auto", c.style.bottom = "0", a.text.alignToBottom ? f.setStyle(c, "transform", "translate(-50%, 0)") : f.setStyle(c, "transform", "translate(-50%, 50%)"));
                }, g.prototype._pathString = e.prototype._pathString, g.prototype._trailString = e.prototype._trailString, b.exports = g;
            },
            {
                "./circle": 2,
                "./shape": 7,
                "./utils": 9
            }
        ],
        7: [
            function(a, b, c) {
                var d = a("./path"), e = a("./utils"), f = "Object is destroyed", g = function a(b, c) {
                    if (!_instanceof(this, a)) throw new Error("Constructor was called without new keyword");
                    if (0 !== arguments.length) {
                        this._opts = e.extend({
                            color: "#555",
                            strokeWidth: 1,
                            trailColor: null,
                            trailWidth: null,
                            fill: null,
                            text: {
                                style: {
                                    color: null,
                                    position: "absolute",
                                    left: "50%",
                                    top: "50%",
                                    padding: 0,
                                    margin: 0,
                                    transform: {
                                        prefix: !0,
                                        value: "translate(-50%, -50%)"
                                    }
                                },
                                autoStyleContainer: !0,
                                alignToBottom: !0,
                                value: null,
                                className: "progressbar-text"
                            },
                            svgStyle: {
                                display: "block",
                                width: "100%"
                            },
                            warnings: !1
                        }, c, !0), e.isObject(c) && void 0 !== c.svgStyle && (this._opts.svgStyle = c.svgStyle), e.isObject(c) && e.isObject(c.text) && void 0 !== c.text.style && (this._opts.text.style = c.text.style);
                        var f, g = this._createSvgView(this._opts);
                        if (!(f = e.isString(b) ? document.querySelector(b) : b)) throw new Error("Container does not exist: " + b);
                        this._container = f, this._container.appendChild(g.svg), this._opts.warnings && this._warnContainerAspectRatio(this._container), this._opts.svgStyle && e.setStyles(g.svg, this._opts.svgStyle), this.svg = g.svg, this.path = g.path, this.trail = g.trail, this.text = null;
                        var h = e.extend({
                            attachment: void 0,
                            shape: this
                        }, this._opts);
                        this._progressPath = new d(g.path, h), e.isObject(this._opts.text) && null !== this._opts.text.value && this.setText(this._opts.text.value);
                    }
                };
                g.prototype.animate = function(a, b, c) {
                    if (null === this._progressPath) throw new Error(f);
                    this._progressPath.animate(a, b, c);
                }, g.prototype.stop = function() {
                    if (null === this._progressPath) throw new Error(f);
                    void 0 !== this._progressPath && this._progressPath.stop();
                }, g.prototype.pause = function() {
                    if (null === this._progressPath) throw new Error(f);
                    void 0 !== this._progressPath && this._progressPath._tweenable && this._progressPath._tweenable.pause();
                }, g.prototype.resume = function() {
                    if (null === this._progressPath) throw new Error(f);
                    void 0 !== this._progressPath && this._progressPath._tweenable && this._progressPath._tweenable.resume();
                }, g.prototype.destroy = function() {
                    if (null === this._progressPath) throw new Error(f);
                    this.stop(), this.svg.parentNode.removeChild(this.svg), this.svg = null, this.path = null, this.trail = null, this._progressPath = null, null !== this.text && (this.text.parentNode.removeChild(this.text), this.text = null);
                }, g.prototype.set = function(a) {
                    if (null === this._progressPath) throw new Error(f);
                    this._progressPath.set(a);
                }, g.prototype.value = function() {
                    if (null === this._progressPath) throw new Error(f);
                    return void 0 === this._progressPath ? 0 : this._progressPath.value();
                }, g.prototype.setText = function(a) {
                    if (null === this._progressPath) throw new Error(f);
                    null === this.text && (this.text = this._createTextContainer(this._opts, this._container), this._container.appendChild(this.text)), e.isObject(a) ? (e.removeChildren(this.text), this.text.appendChild(a)) : this.text.innerHTML = a;
                }, g.prototype._createSvgView = function(a) {
                    var _$b = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    this._initializeSvg(_$b, a);
                    var c = null;
                    (a.trailColor || a.trailWidth) && (c = this._createTrail(a), _$b.appendChild(c));
                    var d = this._createPath(a);
                    return _$b.appendChild(d), {
                        svg: _$b,
                        path: d,
                        trail: c
                    };
                }, g.prototype._initializeSvg = function(a, b) {
                    a.setAttribute("viewBox", "0 0 100 100");
                }, g.prototype._createPath = function(a) {
                    var _$b = this._pathString(a);
                    return this._createPathElement(_$b, a);
                }, g.prototype._createTrail = function(a) {
                    var _$b = this._trailString(a), c = e.extend({}, a);
                    return c.trailColor || (c.trailColor = "#eee"), c.trailWidth || (c.trailWidth = c.strokeWidth), c.color = c.trailColor, c.strokeWidth = c.trailWidth, c.fill = null, this._createPathElement(_$b, c);
                }, g.prototype._createPathElement = function(a, b) {
                    var c = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    return c.setAttribute("d", a), c.setAttribute("stroke", b.color), c.setAttribute("stroke-width", b.strokeWidth), b.fill ? c.setAttribute("fill", b.fill) : c.setAttribute("fill-opacity", "0"), c;
                }, g.prototype._createTextContainer = function(a, b) {
                    var c = document.createElement("div");
                    c.className = a.text.className;
                    var d = a.text.style;
                    return d && (a.text.autoStyleContainer && (b.style.position = "relative"), e.setStyles(c, d), d.color || (c.style.color = a.color)), this._initializeTextContainer(a, b, c), c;
                }, g.prototype._initializeTextContainer = function(a, b, c) {}, g.prototype._pathString = function(a) {
                    throw new Error("Override this function for each progress bar");
                }, g.prototype._trailString = function(a) {
                    throw new Error("Override this function for each progress bar");
                }, g.prototype._warnContainerAspectRatio = function(a) {
                    if (this.containerAspectRatio) {
                        var _$b = window.getComputedStyle(a, null), c = parseFloat(_$b.getPropertyValue("width"), 10), d = parseFloat(_$b.getPropertyValue("height"), 10);
                        e.floatEquals(this.containerAspectRatio, c / d) || (console.warn("Incorrect aspect ratio of container", "#" + a.id, "detected:", _$b.getPropertyValue("width") + "(width)", "/", _$b.getPropertyValue("height") + "(height)", "=", c / d), console.warn("Aspect ratio of should be", this.containerAspectRatio));
                    }
                }, b.exports = g;
            },
            {
                "./path": 5,
                "./utils": 9
            }
        ],
        8: [
            function(a, b, c) {
                var d = a("./shape"), e = a("./utils"), f = function f(a, b) {
                    this._pathTemplate = "M 0,{halfOfStrokeWidth} L {width},{halfOfStrokeWidth} L {width},{width} L {halfOfStrokeWidth},{width} L {halfOfStrokeWidth},{strokeWidth}", this._trailTemplate = "M {startMargin},{halfOfStrokeWidth} L {width},{halfOfStrokeWidth} L {width},{width} L {halfOfStrokeWidth},{width} L {halfOfStrokeWidth},{halfOfStrokeWidth}", d.apply(this, arguments);
                };
                f.prototype = new d(), f.prototype.constructor = f, f.prototype._pathString = function(a) {
                    var _$b = 100 - a.strokeWidth / 2;
                    return e.render(this._pathTemplate, {
                        width: _$b,
                        strokeWidth: a.strokeWidth,
                        halfOfStrokeWidth: a.strokeWidth / 2
                    });
                }, f.prototype._trailString = function(a) {
                    var _$b = 100 - a.strokeWidth / 2;
                    return e.render(this._trailTemplate, {
                        width: _$b,
                        strokeWidth: a.strokeWidth,
                        halfOfStrokeWidth: a.strokeWidth / 2,
                        startMargin: a.strokeWidth / 2 - a.trailWidth / 2
                    });
                }, b.exports = f;
            },
            {
                "./shape": 7,
                "./utils": 9
            }
        ],
        9: [
            function(a, b, c) {
                var e = function e(a, b) {
                    var c = a;
                    for(var _$d in b)if (b.hasOwnProperty(_$d)) {
                        var e1 = b[_$d], f = "\\{" + _$d + "\\}", g = new RegExp(f, "g");
                        c = c.replace(g, e1);
                    }
                    return c;
                };
                var f = function f(a, b, c) {
                    for(var _$d = a.style, e = 0; e < p.length; ++e){
                        _$d[p[e] + h(b)] = c;
                    }
                    _$d[b] = c;
                };
                var g = function g(a, b) {
                    m(b, function(b, c) {
                        null !== b && void 0 !== b && (l(b) && !0 === b.prefix ? f(a, c, b.value) : a.style[c] = b);
                    });
                };
                var h = function h(a) {
                    return a.charAt(0).toUpperCase() + a.slice(1);
                };
                var i = function i(a) {
                    return "string" == typeof a || _instanceof(a, String);
                };
                var j = function j(a) {
                    return "function" == typeof a;
                };
                var k = function k(a) {
                    return "[object Array]" === Object.prototype.toString.call(a);
                };
                var l = function l(a) {
                    return !k(a) && "object" == typeof a && !!a;
                };
                var m = function m(a, b) {
                    for(var c in a)if (a.hasOwnProperty(c)) {
                        var _$d = a[c];
                        b(_$d, c);
                    }
                };
                var n = function n(a, b) {
                    return Math.abs(a - b) < q;
                };
                var o = function o(a) {
                    for(; a.firstChild;)a.removeChild(a.firstChild);
                };
                function d(a, b, c) {
                    a = a || {}, b = b || {}, c = c || !1;
                    for(var e in b)if (b.hasOwnProperty(e)) {
                        var f = a[e], g = b[e];
                        c && l(f) && l(g) ? a[e] = d(f, g, c) : a[e] = g;
                    }
                    return a;
                }
                var p = "Webkit Moz O ms".split(" "), q = 0.001;
                b.exports = {
                    extend: d,
                    render: e,
                    setStyle: f,
                    setStyles: g,
                    capitalize: h,
                    isString: i,
                    isFunction: j,
                    isObject: l,
                    forEachObject: m,
                    floatEquals: n,
                    removeChildren: o
                };
            },
            {}
        ]
    }, {}, [
        4
    ])(4);
}); //# sourceMappingURL=progressbar.min.js.map


/***/ }),

/***/ 713:
/***/ (function() {

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/ !function() {
    "use strict";
    function t(n) {
        if (!n) throw new Error("No options passed to Waypoint constructor");
        if (!n.element) throw new Error("No element option passed to Waypoint constructor");
        if (!n.handler) throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, n), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = n.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, e += 1;
    }
    var e = 0, i = {};
    t.prototype.queueTrigger = function(t) {
        this.group.queueTrigger(this, t);
    }, t.prototype.trigger = function(t) {
        this.enabled && this.callback && this.callback.apply(this, t);
    }, t.prototype.destroy = function() {
        this.context.remove(this), this.group.remove(this), delete i[this.key];
    }, t.prototype.disable = function() {
        return this.enabled = !1, this;
    }, t.prototype.enable = function() {
        return this.context.refresh(), this.enabled = !0, this;
    }, t.prototype.next = function() {
        return this.group.next(this);
    }, t.prototype.previous = function() {
        return this.group.previous(this);
    }, t.invokeAll = function(t) {
        var e = [];
        for(var n in i)e.push(i[n]);
        for(var o = 0, r = e.length; r > o; o++)e[o][t]();
    }, t.destroyAll = function() {
        t.invokeAll("destroy");
    }, t.disableAll = function() {
        t.invokeAll("disable");
    }, t.enableAll = function() {
        t.Context.refreshAll();
        for(var e in i)i[e].enabled = !0;
        return this;
    }, t.refreshAll = function() {
        t.Context.refreshAll();
    }, t.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight;
    }, t.viewportWidth = function() {
        return document.documentElement.clientWidth;
    }, t.adapters = [], t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    }, t.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight();
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth();
        }
    }, window.Waypoint = t;
}(), function() {
    "use strict";
    var t = function t(t1) {
        window.setTimeout(t1, 1e3 / 60);
    };
    function e(t) {
        this.element = t, this.Adapter = o.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        }, this.waypoints = {
            vertical: {},
            horizontal: {}
        }, t.waypointContextKey = this.key, n[t.waypointContextKey] = this, i += 1, o.windowContext || (o.windowContext = !0, o.windowContext = new e(window)), this.createThrottledScrollHandler(), this.createThrottledResizeHandler();
    }
    var i = 0, n = {}, o = window.Waypoint, r = window.onload;
    e.prototype.add = function(t) {
        var _$e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[_$e][t.key] = t, this.refresh();
    }, e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal), _$e = this.Adapter.isEmptyObject(this.waypoints.vertical), i = this.element == this.element.window;
        t && _$e && !i && (this.adapter.off(".waypoints"), delete n[this.key]);
    }, e.prototype.createThrottledResizeHandler = function() {
        var t = function t() {
            _$e.handleResize(), _$e.didResize = !1;
        };
        var _$e = this;
        this.adapter.on("resize.waypoints", function() {
            _$e.didResize || (_$e.didResize = !0, o.requestAnimationFrame(t));
        });
    }, e.prototype.createThrottledScrollHandler = function() {
        var t = function t() {
            _$e.handleScroll(), _$e.didScroll = !1;
        };
        var _$e = this;
        this.adapter.on("scroll.waypoints", function() {
            (!_$e.didScroll || o.isTouch) && (_$e.didScroll = !0, o.requestAnimationFrame(t));
        });
    }, e.prototype.handleResize = function() {
        o.Context.refreshAll();
    }, e.prototype.handleScroll = function() {
        var t = {}, _$e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for(var i in _$e){
            var n = _$e[i], o = n.newScroll > n.oldScroll, r = o ? n.forward : n.backward;
            for(var s in this.waypoints[i]){
                var l = this.waypoints[i][s];
                if (null !== l.triggerPoint) {
                    var a = n.oldScroll < l.triggerPoint, h = n.newScroll >= l.triggerPoint, p = a && h, u = !a && !h;
                    (p || u) && (l.queueTrigger(r), t[l.group.id] = l.group);
                }
            }
        }
        for(var d in t)t[d].flushTriggers();
        this.oldScroll = {
            x: _$e.horizontal.newScroll,
            y: _$e.vertical.newScroll
        };
    }, e.prototype.innerHeight = function() {
        return this.element == this.element.window ? o.viewportHeight() : this.adapter.innerHeight();
    }, e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty();
    }, e.prototype.innerWidth = function() {
        return this.element == this.element.window ? o.viewportWidth() : this.adapter.innerWidth();
    }, e.prototype.destroy = function() {
        var t = [];
        for(var _$e in this.waypoints)for(var i in this.waypoints[_$e])t.push(this.waypoints[_$e][i]);
        for(var n = 0, o = t.length; o > n; n++)t[n].destroy();
    }, e.prototype.refresh = function() {
        var t, _$e = this.element == this.element.window, i = _$e ? void 0 : this.adapter.offset(), n = {};
        this.handleScroll(), t = {
            horizontal: {
                contextOffset: _$e ? 0 : i.left,
                contextScroll: _$e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: _$e ? 0 : i.top,
                contextScroll: _$e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for(var r in t){
            var s = t[r];
            for(var l in this.waypoints[r]){
                var a, h, p, u, d, f = this.waypoints[r][l], c = f.options.offset, w = f.triggerPoint, y = 0, g = null == w;
                f.element !== f.element.window && (y = f.adapter.offset()[s.offsetProp]), "function" == typeof c ? c = c.apply(f) : "string" == typeof c && (c = parseFloat(c), f.options.offset.indexOf("%") > -1 && (c = Math.ceil(s.contextDimension * c / 100))), a = s.contextScroll - s.contextOffset, f.triggerPoint = Math.floor(y + a - c), h = w < s.oldScroll, p = f.triggerPoint >= s.oldScroll, u = h && p, d = !h && !p, !g && u ? (f.queueTrigger(s.backward), n[f.group.id] = f.group) : !g && d ? (f.queueTrigger(s.forward), n[f.group.id] = f.group) : g && s.oldScroll >= f.triggerPoint && (f.queueTrigger(s.forward), n[f.group.id] = f.group);
            }
        }
        return o.requestAnimationFrame(function() {
            for(var t in n)n[t].flushTriggers();
        }), this;
    }, e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t);
    }, e.refreshAll = function() {
        for(var t in n)n[t].refresh();
    }, e.findByElement = function(t) {
        return n[t.waypointContextKey];
    }, window.onload = function() {
        r && r(), e.refreshAll();
    }, o.requestAnimationFrame = function(e) {
        var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
        i.call(window, e);
    }, o.Context = e;
}(), function() {
    "use strict";
    var t = function t(t1, e) {
        return t1.triggerPoint - e.triggerPoint;
    };
    var e = function e(t, e1) {
        return e1.triggerPoint - t.triggerPoint;
    };
    var i = function i(t) {
        this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), n[this.axis][this.name] = this;
    };
    var n = {
        vertical: {},
        horizontal: {}
    }, o = window.Waypoint;
    i.prototype.add = function(t) {
        this.waypoints.push(t);
    }, i.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        };
    }, i.prototype.flushTriggers = function() {
        for(var i in this.triggerQueues){
            var n = this.triggerQueues[i], o = "up" === i || "left" === i;
            n.sort(o ? e : t);
            for(var r = 0, s = n.length; s > r; r += 1){
                var l = n[r];
                (l.options.continuous || r === n.length - 1) && l.trigger([
                    i
                ]);
            }
        }
        this.clearTriggerQueues();
    }, i.prototype.next = function(e) {
        this.waypoints.sort(t);
        var i = o.Adapter.inArray(e, this.waypoints), n = i === this.waypoints.length - 1;
        return n ? null : this.waypoints[i + 1];
    }, i.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var i = o.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null;
    }, i.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t);
    }, i.prototype.remove = function(t) {
        var e = o.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
    }, i.prototype.first = function() {
        return this.waypoints[0];
    }, i.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1];
    }, i.findOrCreate = function(t) {
        return n[t.axis][t.name] || new i(t);
    }, o.Group = i;
}(), function() {
    "use strict";
    var t = function t(t1) {
        return t1 === t1.window;
    };
    var e = function e(e1) {
        return t(e1) ? e1 : e1.defaultView;
    };
    var i = function i(t) {
        this.element = t, this.handlers = {};
    };
    var n = window.Waypoint;
    i.prototype.innerHeight = function() {
        var e = t(this.element);
        return e ? this.element.innerHeight : this.element.clientHeight;
    }, i.prototype.innerWidth = function() {
        var e = t(this.element);
        return e ? this.element.innerWidth : this.element.clientWidth;
    }, i.prototype.off = function(t, e) {
        var i = function i(t, e, i1) {
            for(var n = 0, o = e.length - 1; o > n; n++){
                var r = e[n];
                i1 && i1 !== r || t.removeEventListener(r);
            }
        };
        var n = t.split("."), o = n[0], r = n[1], s = this.element;
        if (r && this.handlers[r] && o) i(s, this.handlers[r][o], e), this.handlers[r][o] = [];
        else if (o) for(var l in this.handlers)i(s, this.handlers[l][o] || [], e), this.handlers[l][o] = [];
        else if (r && this.handlers[r]) {
            for(var a in this.handlers[r])i(s, this.handlers[r][a], e);
            this.handlers[r] = {};
        }
    }, i.prototype.offset = function() {
        if (!this.element.ownerDocument) return null;
        var t = this.element.ownerDocument.documentElement, i = e(this.element.ownerDocument), n = {
            top: 0,
            left: 0
        };
        return this.element.getBoundingClientRect && (n = this.element.getBoundingClientRect()), {
            top: n.top + i.pageYOffset - t.clientTop,
            left: n.left + i.pageXOffset - t.clientLeft
        };
    }, i.prototype.on = function(t, e) {
        var i = t.split("."), n = i[0], o = i[1] || "__default", r = this.handlers[o] = this.handlers[o] || {}, s = r[n] = r[n] || [];
        s.push(e), this.element.addEventListener(n, e);
    }, i.prototype.outerHeight = function(e) {
        var i, n = this.innerHeight();
        return e && !t(this.element) && (i = window.getComputedStyle(this.element), n += parseInt(i.marginTop, 10), n += parseInt(i.marginBottom, 10)), n;
    }, i.prototype.outerWidth = function(e) {
        var i, n = this.innerWidth();
        return e && !t(this.element) && (i = window.getComputedStyle(this.element), n += parseInt(i.marginLeft, 10), n += parseInt(i.marginRight, 10)), n;
    }, i.prototype.scrollLeft = function() {
        var t = e(this.element);
        return t ? t.pageXOffset : this.element.scrollLeft;
    }, i.prototype.scrollTop = function() {
        var t = e(this.element);
        return t ? t.pageYOffset : this.element.scrollTop;
    }, i.extend = function() {
        var t = function t(t1, e) {
            if ("object" == typeof t1 && "object" == typeof e) for(var i in e)e.hasOwnProperty(i) && (t1[i] = e[i]);
            return t1;
        };
        for(var e = Array.prototype.slice.call(arguments), i = 1, n = e.length; n > i; i++)t(e[0], e[i]);
        return e[0];
    }, i.inArray = function(t, e, i) {
        return null == e ? -1 : e.indexOf(t, i);
    }, i.isEmptyObject = function(t) {
        for(var e in t)return !1;
        return !0;
    }, n.adapters.push({
        name: "noframework",
        Adapter: i
    }), n.Adapter = i;
}();


/***/ }),

/***/ 516:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var color = {
    aqua: "aqua",
    fuchsia: "fuchsia",
    grape: "grape",
    green: "green",
    leaf: "leaf",
    navy: "navy",
    orange: "orange",
    pink: "pink",
    purple: "purple",
    red: "red",
    sky: "sky",
    blue: "blue",
    violet: "violet",
    yellow: "yellow",
    primary: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (color);


/***/ })

}]);